import { Component, Input, OnInit, ViewChild, Output, EventEmitter, ElementRef, OnDestroy, ViewChildren, QueryList } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AccountsService } from '../../accounts.service';
import { TemplateService } from "../../template.service";
import { ClientService } from '../../../client/client.service'
import { ToastrService } from 'ngx-toastr';
import { ModalDirective, BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Contact } from 'src/app/Models/contacts';
import { Task } from 'src/app/Models/Task';
import { Clientdetails } from 'src/app/Models/clients';
import { FormsModule, NgForm, NgModel, ReactiveFormsModule } from '@angular/forms';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { FolderTypeService } from '../../../settings/folder-type/folder-type.service';
import { CommonModule, DatePipe, NgTemplateOutlet } from '@angular/common';
import { CustomField, Logtime } from 'src/app/Models/job';
import { DropDownListComponent } from '@syncfusion/ej2-angular-dropdowns';
import { SMClientService } from 'src/app/client/SM-client.service';
import { KcWarningPopupComponent } from '../kc-warning-popup/kc-warning-popup.component';
import { warningPopResponse } from 'src/app/shared/app.constant';
import { CommonService } from '../../common.service';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { KC_MATERIAL_DATE_FORMATS } from 'src/app/Models/materialDatepickerConfig';
import { CmAddress } from 'src/app/client/shared-client.service';
import { Observable, Subject, Subscription, timer } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, switchMap, takeUntil } from 'rxjs/operators';
import * as _ from 'lodash';
import { UserManagementService } from 'src/app/shared/userManagement.service';
import { industryCodeData } from '../../../industryCodeData';
import { DivisionManagementService } from 'src/app/settings/division-management/division-management.service';
import { FirmDetailService } from 'src/app/settings/firm-details/firm-detail.service';
import { OfficeService } from 'src/app/settings/services/office.service';
import { TempWorkEmail, TempHomePhone, defaultCountry } from 'src/app/client/clientUtils/clientList';
import { TeamsService } from 'src/app/shared/teams.service';
import { EntityService } from 'src/app/shared/Entity.service';
import { XeroService } from 'src/app/settings/connections/xero/xero.service';
import { FileManagerService } from 'src/app/shared/fileManager.service';
import { azureService } from 'src/app/settings/connections/azure/azure.service';
import { CategoryService } from 'src/app/document/services/category.service';
import { JobMilestoneService } from 'src/app/job/job.service';
import { formateDateInYMDFormat, getFormattedDateWithTimeZone, getNormalizedFullName, getNormalizedMultilineText, getNormalizedName, sortTagsToTop as sortClientTagsToTop } from 'src/app/utility/helper-function.utils';
import { selectAllUsers } from 'src/app/store/users/users.selectors';
import { Store } from '@ngrx/store';
import { parsePhoneNumberFromString, type CountryCode } from 'libphonenumber-js';
import { PhoneNumberUtil } from 'google-libphonenumber';
import { DropDownListModule } from '@syncfusion/ej2-angular-dropdowns';
import { DatePickerModule } from '@syncfusion/ej2-angular-calendars';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatButtonModule } from '@angular/material/button';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxMaskModule } from 'ngx-mask';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NiGenerateformPopupComponent } from '../ni-generateform-popup/ni-generateform-popup.component';
import { FocusOnErrorFieldDirective } from 'src/app/directives/focus-on-error-field.directive';
import { TextareaAutoresizeDirective } from 'src/app/directives/auto-resize.directive';

interface AddressData {
  unit: string;
  addressLine1: string;
  addressLine2: string;
  suburb: string;
  state: string;
  country: string;
  postcode: string;
}

interface AddressSet {
  addressPoolMappingId: number;
  addressPoolId: number;
  addressTypeId: number;
  careof: string;
  contextId: number;
  contextType: string;
  isFavorite: boolean;
  isDeleted: boolean;
  fullAddressList: any[];
  addressInput$: Subject<string>;
}

@Component({
  selector: 'app-createclient',
  standalone: true,
  imports: [
    CommonModule, FormsModule, ReactiveFormsModule,
    DropDownListModule , DatePickerModule, AutocompleteLibModule, DropDownListModule, DatePickerModule,
    MatFormFieldModule, MatDatepickerModule, MatButtonModule, MatMenuModule, MatSlideToggleModule, MatInputModule,
    NgMultiSelectDropDownModule, NgSelectModule, NgTemplateOutlet, NiGenerateformPopupComponent, FocusOnErrorFieldDirective,
    NgxMaskModule, MatTooltipModule, TextareaAutoresizeDirective
  ],
  templateUrl: './createclient.component.html',
  styleUrls: ['./createclient.component.scss'],
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: KC_MATERIAL_DATE_FORMATS },
  ],
})

export class CreateclientComponent implements OnInit, OnDestroy {
  @ViewChild('addClientForm') public addClientForm: NgForm;
  @ViewChild('WarningPopup') public WarningPopup: any;
  @ViewChild('WarningPopupone') public WarningPopupone: any;
  @ViewChild('CreateNewAddress') public CreateNewAddress: any;
  @Input() partnerFormInvalid: boolean;
  @Input() managerFormInvalid: boolean;
  /** Comma-separated dynamic columns the hosting grid is showing; the beta response includes them with the base columns. */
  @Input() clientGridDynamicCols: string = '';
  @Input() clientGridIsCustomFields: boolean = false;
  @ViewChild('addPartnerInfoForm') addPartnerInfoForm;
  @ViewChild('addManagerInfoForm') addManagerInfoForm;
  @ViewChild('addTaxAgentInfoForm') addTaxAgentInfoForm;
  @ViewChild('addStatusInfoForm') addStatusInfoForm;
  @ViewChild('addIsTaxInfoForm') addIsTaxInfoForm;
  @ViewChild('clientcontactForm') clientcontactForm;
  @ViewChild('MeetingForm') MeetingForm;
  @ViewChild('sectionNeedToScroll') sectionNeedToScroll: ElementRef
  @ViewChild('salutation') salutation; 
  public dropDownListObject: DropDownListComponent;
  @ViewChildren('datePickerRef') datePickers: QueryList<NgModel>;
  loadedForm: any;
  currentForm: any;
  isChanged: boolean;
  loadedAddress: AddressSet[];
  currentAddress: AddressSet[];
  isAddressChanged: boolean;
  tabOne: boolean;
  tabTwo: boolean;
  @Input() set Tempcid(Tempcid: number) { this._TempClientId = Tempcid; }
  @Input() set tempload(tempload: number) { this._tempload = tempload; }
  public items = [
    { display: 'Pizza', value: 1 },
    { display: 'Pasta', value: 2 },
    { display: 'Parmesan', value: 3 },
  ];
  public _TempClientId: number = 0;
  public _tempload: number = 0;
  TestData = [];
  TestDataone = [];
  countOfSlectedDynamicFilter = 0;
  public clients: Clients[] = [];
  public clientsDetail = new ClientsDetail();
  public contactDataModal = new Contact();
  public tempcontactemail = new Tcontactworkemail();
  public tempcontactphone = new tcontacthomephone();
  cfqcitem: Array<CustomField> = [];
  tempqccfitem: Array<CustomField> = [];
  cfqlconitem: Array<CustomField> = [];
  tempqlcfconitem: Array<CustomField> = [];
  mobNumberPattern = "^((\\+91-?)|0)?[0-9]{0,10}$";
  emailcontactPattern = "[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$";
  workContactEmailCount: number = 1;
  homeContactPhoneCount: number = 1;
  contactId: any = null;
  CcontactId: any;
  contactsIds: any;
  cutomeFilterName = ''
  contactstates: any;
  contactstates1: any;
  contactstates2: any;
  contactstates3: any;
  issamephysicalcontact: boolean = true;
  isBulkOptionDisabled: boolean = false;
  contactcountries: any;
  partnerList: any; minDate = new Date();
  public mgrList: any;
  public taxagentList: any;
  public tagListforClient: any;
  public SavedDynamicFilterList = [];
  public dynamicfilter = new Dynamicfilter();
  public allClientList: Clients[] = [];
  public contactTable: any = [];
  ClientProfileActivities: any = [];
  public temp_client: Clients[] = [];
  public LocaltempclientFilter = [];
  public contactList = [];
  selectedItems = [];
  public statePostal: string[] = [];
  public statePhysical: string[] = [];
  public tempemail: TempWorkEmail[] = [];
  public tempphone: TempHomePhone[] = [];
  public Obj_email: any[] = [];
  public obJ_phone: any[] = [];
  public Obj_email1: WorkEmai[] = [];
  public obJ_phone1: HomePhone[] = [];
  public dynamicfilterObj = new DynaicFilterPost();
  public assignEntity = new assignEntity();
  public entities: Entities[] = [];
  assignEntitydata = new assignEntity();
  dynamicFilterList;
  staticStatusList;
  staticEntityTypeList;
  isDefaulft: boolean = true;
  DynamicfilterId;
  isVisibleError: boolean = false;
  isVisibleStatusError: boolean = false;
  isVisibleClientTaxError: boolean = false;
  public isShowclientName: boolean = true;
  public isShowentityType: boolean = true;
  public isShowlocation: boolean = false;
  public isShowpartnerName: boolean = true;
  public isShowcontactName: boolean = true;
  public isShowemail: boolean = true;
  public isShowassignTagsCount: boolean = true;
  filterName: string = '';
  clientCount: number = 0;
  public isShowclientCode: boolean = false; public isShowmanager: boolean = false;
  public isShowinTaxClient: boolean = false; public isShowtaxAgent: boolean = false;
  public isShowcrmActivity: boolean = true; public isShowworkPhone: boolean = false;
  public isShowstatus: boolean = false; public isShowabn: boolean = false;
  public isShowopenJobs: boolean = false; public isShowwip: boolean = false;
  public isShowfollowUpDate: boolean = false; public isShowlastActivityDate: boolean = true;
  public isShowindustry: boolean = false; public isShowacn: boolean = false;
  public isShowgstRegistered: boolean = false; public isShowopportunityJobs: boolean = false;
  public isShowlastInvoiceSent: boolean = false; public isShowannualIncome: boolean = false;
  public isShowassigneeCount: boolean = false; public isShowMeetingDate: boolean = false;
  public isWIPVisible: boolean = false;
  isFilterSavedName: boolean = false;
  public contactdata = [];
  isArchive: boolean = false;
  public rn: number;
  headers: any;
  readonly = true;
  childRow = [];
  selectedEntityTypeId: any;
  catpureEntiyname: any;
  Index: any;
  public isshowthat: boolean = false;
  sub_tabno: number;
  subadd_tabno: number;
  suban_tabno: number;
  public changeContactField: boolean = false;
  subaddan_tabno: number;
  radioTitle: string;
  radioItems: Array<string>;
  model = { option: 'ABN' };
  tableView = new TableData(2, 7);
  public logTime = new Logtime();
  public clientDataModal = new Clientdetails();
  public originalPhysicalAddress = new CmAddress();
  public originalPostalAddress = new CmAddress();
  public Task = new Task();
  pageSize: any = "10";
  searchTxt: any = "";
  entitytype: any;
  asignstaff: any;
  starHide: boolean = false;
  starHideOne: boolean = false;
  starHideTwo: boolean = false;
  fillStarHide: boolean = false;
  starHidePhone: boolean = false;
  starHidePhoneOne: boolean = false;
  starHidePhoneTwo: boolean = false;
  isremove: boolean = false;
  public temp_clientFilter = [];
  public temp_ActiveFilter = [];
  public temp_ArchiveFilter = [];
  public temp_ActiveProspect = [];
  public temp_IndvidualFilter = [];
  public temp_CopmFilter = [];
  public temp_PartneFilter = [];
  public temp_SMSFFilter = [];
  public temp_TrustFilter = [];
  ShowStaticSaveFilter: boolean = false;
  filterTypeList = [];
  public changeField: boolean = false;
  isAllStatusSelected: boolean = false;
  isProspectStatusSelected: boolean = false;
  isActiveStatusSelected: boolean = false;
  isArchiveStatusSelected: boolean = false;
  isLostStatusSelected: boolean = false;
  isIndivisualEntitySelected: boolean = false;
  isCompanyEntitySelected: boolean = false;
  isPartnershipEntitySelected: boolean = false;
  isTustEntitySelected: boolean = false;
  isSMSFEntitySelected: boolean = false;
  public btnId: string = "";
  isEditMode: boolean = false;
  validPartnersList: any[] = [];
  validManagersList: any[] = [];
  _CurrentTFNData: any = '';
  _CurrentDINData: any = '';
  _CurrentBSBData: any = '';
  _CurrentAccountNumberData: any = '';
  noPermissionTFNData: any = '';
  noPermissionDINData: any = '';
  noPermissionBSBData: any = '';
  noPermissionAccountNumberData: any = '';
  isShowBankAccountnumber: boolean = false;
  isShowBSB: boolean = false;
  isShowTFN: boolean = false;
  isShowDIN: boolean = false;
  IsclientPrivacy: boolean = false;
  @ViewChild('primaryModal') public primaryModal: ModalDirective;
  @ViewChild('addClientModal') public addClientModal: ModalDirective;
  @ViewChild('uploadDocModal') public uploadDocModal: ModalDirective;
  @ViewChild('addJobModal') public addJobModal: ModalDirective;
  @ViewChild('assignStaff') public assignStaff: ModalDirective;
  @ViewChild('primaryContactModal') public primaryContactModal: ModalDirective;
  @ViewChild('capturelogTimeModel') public capturelogTimeModel: ModalDirective;
  @ViewChild('importModel') public importModel: ModalDirective;
  @ViewChild('addjob') public addjob: ModalDirective;
  @ViewChild('cancel') cancel: ElementRef;
  @ViewChild('cancel1') cancel1: ElementRef;
  @ViewChild('cancelContact') cancelContact: ElementRef;
  @ViewChild('cancel3') cancel3: ElementRef;
  @ViewChild('FilterModalPopup') public FilterModalPopup: ModalDirective;
  public fields: any = { text: 'name', value: 'countryId' };
  client: any;
  location: any = [];
  ManagerList: any = [];
  ContactNameList: any = [];
  IndustryTypeList: any = [];
  TaxAgentList: any = [];
  TagListPost: any = [];
  LocationListPost: any = [];
  StatusTypePost: any = [];
  entityTypePost: any = [];
  partnerListPost: any = [];
  ManagerListPost: any = [];
  ContactNameListPost: any = [];
  IndustryTypeListPost: any = [];
  TaxAgentListPost: any = [];
  NextFollowupDatePost: any = [];
  LastActivityDatePost: any = [];
  GSTRegisteredPost: string = 'No';
  TaxClientPost: boolean = false;
  ActiveJobPost: any = [];
  OppurtunityJobPost: any = [];
  WIPPost: any = [];
  LastInvoiceSentPost: any = [];
  AnnualIncomePost: any = [];
  checkBoxIds: any = [];
  @Output() closeCreateclientPopup = new EventEmitter();
  CheckedLoaction: any = [];
  CheckedTag: any = [];
  CheckedStatus: any = [];
  CheckedEntity: any = [];
  CheckedManager: any = [];
  Checkedpartner: any = [];
  CheckedConatct: any = [];
  CheckedIndustry: any = [];
  CheckedTaxAgent: any = [];
  AddOrUpdateDynamicFilter = 'Save';
  IseditClient: boolean = false;
  buttontext: string = 'Create';
  clientId: any;
  selectedClentId: any;
  entityId: any;
  addJobIsActive: boolean;
  bsModalRef: BsModalRef;
  clientType: string;
  emailoption1: string = '2';
  emailoption2: string = '2';
  emailoption3: string = '2';
  emailstring1: string;
  emailstring2: string;
  emailstring3: string;
  emailbookmark1: boolean = false;
  emailbookmark2: boolean = false;
  emailbookmark3: boolean = false;
  emailoption4: string = '1';
  emailoption5: string = '1';
  emailoption6: string = '1';
  emailstring4: string;
  emailstring5: string;
  emailstring6: string;
  public checkCreateClient: boolean = false;
  emailbookmark4: boolean = false;
  emailbookmark5: boolean = false;
  emailbookmark6: boolean = false;
  IsIndividual: boolean = true;
  phoneoption1: string = '3';
  phoneoption2: string = '3';
  phoneoption3: string = '3';
  phonestring1: string;
  phonestring2: string;
  phonestring3: string;
  phonebookmark1: boolean = false;
  phonebookmark2: boolean = false;
  phonebookmark3: boolean = false;
  phoneoption4: string = '1';
  phoneoption5: string = '1';
  phoneoption6: string = '1';
  phonestring4: string;
  phonestring5: string;
  phonestring6: string;
  phonebookmark4: boolean = false;
  phonebookmark5: boolean = false;
  phonebookmark6: boolean = false;
  issamephysical: boolean = true;
  currentDate: Date = new Date();
  maxDate: Date;
  datemaxlength: number = 8;
  dropdownSettings: IDropdownSettings = {};
  tagDropdownSettings: IDropdownSettings = {};
  selectedClientTags: any[] = [];
  public archiveUnarchiveList: any = "Archive"
  cid: any;
  workEmailCount: number = 1;
  homePhoneCount: number = 1;
  workEmailCount2: number = 1;
  homePhoneCount2: number = 1;
  clientName: any;
  allFolderTypeList: any;
  dummy: any;
  show = false;
  entitynm: any;
  files: File[] = [];
  Entities: any[];
  hideNotes: boolean = false;
  clid: number = 0;
  isLinkedEntitesAvailable: boolean;
  isClickedFilter: boolean = false;
  clienttolog: any;
  TagList: any;
  activiesCount: any;
  TagIdList: any;
  ClientTagsbyId: any = [];
  testclient: any;
  showclient: boolean = true;
  showcontact: boolean = false;
  validatecount: number;
  invalidselect: boolean;
  countries: any;
  states: any;
  _phone1Validator: boolean = false;
  _phone2Validator: boolean = false;
  _phone3Validator: boolean = false;
  public modeselect = this.clientDataModal.entityTypeId = 'INDIVIDUAL';
  _tfnValidateStatus: boolean = false;
  _abnValidateStatus: boolean = false;
  _dinValidateStatus: boolean = false;
  _acnValidateStatus: boolean = false;
  createContactPhone3: boolean;
  createContactPhone2: boolean;
  createContactPhone1: boolean;
  createContactEmail1: boolean;
  createContactEmail2: boolean;
  createContactEmail3: boolean;
  filterCustomStatusId: any = 0;
  firmDetails: any;
  isAuto: any;
  _isABNExist: boolean = false;
  _isACNExist: boolean = false;
  @Output() closeCreateEditJobsPopUp = new EventEmitter();
  @Output() getclientlistload = new EventEmitter<{response: any}>();
  addQuick: any;
  warningPopupRes = warningPopResponse;
  isClickedOnUpdate: boolean = false;
  public filterPlaceholder: string = 'Search';
  public cancelSelectedOption: string = '';
  public industryList: any = [];
  clientOldName: string = "";
  clientOldEntityType: number = 0;
  tooltipPhysicalCountryName1: string = ''; tooltipPhysicalCountryName2: string = '';
  tooltipPostalCountryName1: string = ''; tooltipPostalCountryName2: string = '';
  allUsers: any[] = [];
  cfUserDropdownSetting: IDropdownSettings;
  @Input() selectedClientData: any;
  public _tempClientDetails: any;
  @ViewChild('generateFormPopupRef', { static: true }) public generateFormPopupRef: any;
  changedPhysicalAddress: CmAddress = new CmAddress();
  changedNewPhyAddress: any;
  newPhyAddressId: number;
  newPhyAddresscareOf: string;
  public tempClientId: number; addressData: AddressData = {
    unit: '',
    addressLine1: '',
    addressLine2: '',
    suburb: '',
    state: '',
    country: '',
    postcode: ''
  };
  officeData: any = {
    officeList: [],
    selectedOfficeId: null,
    officeViewManagePermission: false
  }
  private sub = new Subscription();
  private unsubscribe = new Subject<void>();
  users$ = this.store.select(selectAllUsers);
  private modalRef: BsModalRef;
  private modelRefNew: BsModalRef;
  private childModalRef: BsModalRef;
  sharedEmailEntities: any[] = [];
  fromEmail: string = '';
  toEmail: string = '';
  isCheckAllEmail = false;
  modalStep: string = '';
  modalScreen: number = 1;
  bulkEmailGroups: {
    fromEmail: string;
    toEmail: string | null;
    entities: any[];
  }[] = [];
  @ViewChild('BulkEmailUpdate', { static: true }) BulkEmailUpdate: any;
  private _clientData: any;
  private _inputForm: any;
  private _isSaveAndNext: boolean;
  private _physicalAddressChange: boolean;
  backUpEmailPoolIds: any[] = [];
  backUpPhonePoolIds: any[] = [];
  addressSets: AddressSet[] = [];
  addressSetsContact: AddressSet[] = [];
  addressTypeList: any = [];
  addressTypeListContact: any = [];
  public activateButtonContact: boolean = false;
  public emailTypes: any;
  public contactdataval: any = [];
  public titleList: [];
  emails: any[] = [];
  maxEmailsPerType = 5;
  phones: any[] = [];
  maxPhonesPerType = 5;
  allPhonesNotEmpty: boolean = false;
  private phoneInput$ = new Subject<{ value: string, row: any }>();
  defaultSelectedCountry: any = defaultCountry;
  isShift: boolean = false;
  seperator: any = "/";
  value1: number = 0;
  highValue: number = 60;
  value2: number = 0;
  highValue2: number = 60;
  public partnerAndManagerList: any;
  public teamList: any;
  public phoneTypes: any;
  basicone: boolean = true;
  linkone: boolean = false;
  finanicialone: boolean = false;
  softwareone: boolean = false;
  contactHide: boolean = false;
  public checkSaveAndContinue: boolean = false;
  public missingAddressString: string;
  public validationMessage: string = "";
  public clientListCheck: any = [];
  public allClientCodes: any = [];
  public checkChangePage: boolean = false;
  clientCodeExists: boolean;
  invalidClientCode: boolean;
  people = [
    { id: "one", name: "Python" },
    { name: 'Node Js' },
    { name: 'Java' },
  ];
  public Showcheck: boolean;
  keyword = 'name';
  public contactlist = [];
  public dynamicName1: any;
  rowBeingEditedEmailTypeId: number | null = null;
  rowBeingEditedPhoneTypeId: number | null = null;
  isManageBillerReference = false;
  bpayAlgorithm: number;
  bpayRefError: boolean = false;
  clientGridType: string;

  constructor(private el: ElementRef,
    private router: Router,
    private accountsService: AccountsService,
    private templateservice: TemplateService,
    private _clientService: ClientService,
    private _toastr: ToastrService,
    private folderTypeService: FolderTypeService,
    private commonService: CommonService,
    private datePipe: DatePipe,
    private route: ActivatedRoute,
    private stateManagement: SMClientService,
    private modalService: BsModalService,
    private userManagementService: UserManagementService,
    private divisionManagementService: DivisionManagementService,
    private firmDetailService: FirmDetailService, private officeService: OfficeService, private teamsService: TeamsService, private entityService: EntityService, private xeroService: XeroService, private fileManagerService: FileManagerService, private azureService: azureService, private categoryService: CategoryService, private jobService: JobMilestoneService,private store: Store) {
    this.clientDataModal = new Clientdetails();
    this.accountsService.setbodybackground();
    this.rn = 1;
    this.sub_tabno = 1;
    this.suban_tabno = 1;
    this.radioTitle = 'Radio Button in Angular';
    this.radioItems = ['ABN', 'ACN', 'Default'];
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'entityId',
      textField: 'entityName',
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      itemsShowLimit: 4,
      allowSearchFilter: true,

    };
     this.tagDropdownSettings = {
      singleSelection: false,
      idField: 'tagId',
      textField: 'tagname',
      selectAllText: 'Select all',
      unSelectAllText: 'Unselect all',
      closeDropDownOnSelection: false,
      itemsShowLimit: 100,
      allowSearchFilter: true,
    };
  }

  ngOnInit() {
    this.clientGridType = this.router.url.includes('client/clientlist') ? 'beta' : 'classic';
    this.getAddressTypes();
    this.getEmailTypes();
    this.getPhoneTypes();
    this.tempClientId = this._TempClientId;
    this._tempClientDetails = this.selectedClientData;
    this.GetUserPermissions();
    this.getUsersDisplayInClientOrJob('client');
    this.cfUserDropdownSetting = {
      singleSelection: false,
      idField: 'id',
      textField: "text",
      itemsShowLimit: 1,
      allowSearchFilter: true,
      enableCheckAll: false,
    }
    this.industryList = industryCodeData;
    this.industryList.forEach((element, index) => {
      this.industryList[index].industryName = element.class_code + ' - ' + element.class_title;
    });
    this.getClientListcheck();
    this.getContactCountries();
    this.getTitleList();
    this.getFirmDetails();
    this.getTeams();

    this.addressSets.forEach((addressSet: AddressSet) => {
      addressSet.addressInput$ = new Subject<string>();
      addressSet.fullAddressList = [];

      this.sub.add(addressSet.addressInput$.pipe(
        debounceTime(500),
        distinctUntilChanged(),
        filter(term => term.length >= 3),
        switchMap(term => this.fetchAddresses(term))
      ).subscribe((addresses: any[]) => {
        addressSet.fullAddressList = addresses;
      }));
    });

    this.addressSetsContact.forEach((aSet: AddressSet) => {
      aSet.addressInput$ = new Subject<string>();
      aSet.fullAddressList = [];

      this.sub.add(aSet.addressInput$.pipe(
        debounceTime(500),
        distinctUntilChanged(),
        filter(term => term.length >= 3),
        switchMap(term => this.fetchAddresses(term))
      ).subscribe((addresses: any[]) => {
        aSet.fullAddressList = addresses;
      }));
    });
    this.initializeConstants();
    this.phoneInput$
    .pipe(debounceTime(300))
    .subscribe(({ value, row }) => {
      this.phoneInput = value;
      this.sanitizePhone(1, row);
    });
  }

  addAddress() {
    const selectedCountry = this.countries.find(c => c.countryId === this.selectedCountryId);
    const selectedState = this.stateList.find(s => s.stateId === this.selectedStateId);

    const addressData: AddressData = {
      ...this.addressData,
      country: selectedCountry ? selectedCountry.name : '',
      state: selectedState ? selectedState.name : ''
    };

    this._clientService.addNewAddress(addressData).subscribe(
      response => {
        if (response.success) {
          const newAddress = JSON.parse(response.moreInfo);
          this._toastr.success('New Address Added.');
          if (this.type === 'client') {
            this.addressSets[this.addressIndex].fullAddressList = [
              ...this.addressSets[this.addressIndex].fullAddressList,
              newAddress
            ];
            this.addressSets[this.addressIndex].addressPoolId = newAddress.addressPoolId;
            this.checkAddressPool(this.addressSets[this.addressIndex]);
          }
          else if (this.type === 'contact') {
            this.addressSetsContact[this.addressIndex].fullAddressList = [
              ...this.addressSetsContact[this.addressIndex].fullAddressList,
              newAddress
            ];
            this.addressSetsContact[this.addressIndex].addressPoolId = newAddress.addressPoolId;
            this.checkAddressPoolContact(this.addressSetsContact[this.addressIndex]);
          }
          this.createAddressPopupclose();
        } else {
          this._toastr.error('Unable to add the address');
        }
      }
    );
  }

  clearAddressTypeContact(addressSet) {
    addressSet.addressPoolId = undefined;
    addressSet.careof = '';
  }
  private normalizeCareOf(careof: string): string {
    if (!careof) return '';
    // collapse multiple whitespace and trim
    let val = careof.replace(/\s+/g, ' ').trim();
    // strip any leading "C/-" or "Care of" (with optional colon/space), repeated, case-insensitive
    val = val.replace(/^(?:(?:C\/-|Care of)[:\s]*)+/i, '').trim();
    return val;
  }
  private sanitizeCareOf(value: string): string {
    if (!value) {
      return value;
    }

    // remove any occurrence of "C/-" (case-insensitive)
    const removed = value.replace(/c\/-/gi, '').replace(/\s{2,}/g, ' ').trim();

    // return empty string so binding keeps the input empty
    return removed === '' ? '' : removed;
  }
  onAddressCareOfChange(careof: string, index: number, context: 'client' | 'contact' = 'client') {
    const sanitized = this.sanitizeCareOf(careof);

    if (context === 'client') {
      if (this.addressSets && this.addressSets[index]) {
        this.addressSets[index].careof = sanitized;
      }
    } else {
      if (this.addressSetsContact && this.addressSetsContact[index]) {
        this.addressSetsContact[index].careof = sanitized;
      }
    }
  }
  addAddressSetContact() {
    this.activateButtonContact = true;
    if (this.addressSetsContact.length < 3) {
      const newAddressSet: AddressSet = {
        addressPoolMappingId: 0,
        addressPoolId: undefined,
        addressTypeId: undefined,
        careof: '',
        contextId: 0,
        contextType: 'Contact',
        isFavorite: false,
        isDeleted: false,
        fullAddressList: [],
        addressInput$: new Subject<string>()
      };
      this.sub.add(newAddressSet.addressInput$.pipe(
        debounceTime(500),
        distinctUntilChanged(),
        filter(term => term.length >= 3),
        switchMap(term => this.fetchAddresses(term))
      ).subscribe((addresses: any[]) => {
        newAddressSet.fullAddressList = addresses;
      }));
      if (this.addressSetsContact.length > 0) {
        const selectedAddresses = this.addressSetsContact
          .filter(set => set.addressPoolId && set.addressTypeId)
          .map(set => {
            const selectedAddress = set.fullAddressList.find(address => address.addressPoolId === set.addressPoolId);
            const addressType = this.addressTypes.find(type => type.addressTypeId === set.addressTypeId);
            if (selectedAddress && addressType) {
              return {
                ...selectedAddress,
                addressLine: `${addressType.addressTypeName}: ${selectedAddress.addressLine}`
              };
            }
            return null;
          })
          .filter(address => address !== null);

        newAddressSet.fullAddressList = selectedAddresses;
      }
      if (this.addressSetsContact.length === 2) {
        newAddressSet.fullAddressList[1].addressLine = this.removeSecondAddress(newAddressSet.fullAddressList[1].addressLine);
      }
      this.addressSetsContact.push(newAddressSet);
    }

    if (this.addressTypeListContact.length === 0) {
      this.addressTypeListContact[this.addressSetsContact.length - 1] = this.addressTypes;
    }
    else {
      let addressTypeIds = this.addressSetsContact.map(obj => obj.addressTypeId);
      this.addressTypeListContact[this.addressSetsContact.length - 1] = this.addressTypes.filter(item => !addressTypeIds.includes(item.addressTypeId));
    }
  }

  onAddClientClear(index) {
    this.addressSets[index].addressInput$ = new Subject<string>();
    this.sub.add(this.addressSets[index].addressInput$.pipe(
      debounceTime(500),
      distinctUntilChanged(),
      filter(term => term.length >= 3),
      switchMap(term => this.fetchAddresses(term))
    ).subscribe((addresses: any[]) => {
      this.addressSets[index].fullAddressList = addresses;
    }));
  }

  onAddContactClear(index) {
    this.addressSetsContact[index].addressInput$ = new Subject<string>();

    this.sub.add(this.addressSetsContact[index].addressInput$.pipe(
      debounceTime(500),
      distinctUntilChanged(),
      filter(term => term.length >= 3),
      switchMap(term => this.fetchAddresses(term))
    ).subscribe((addresses: any[]) => {
      this.addressSetsContact[index].fullAddressList = addresses;
    }));
  }

  clearAddressType(addressSet) {
    addressSet.addressPoolId = undefined;
    addressSet.careof = '';
  }

  addAddressSet() {
    this.activateButton = true;
    if (this.addressSets.length < this.addressTypes.length) {
      const newAddressSet: AddressSet = {
        addressPoolMappingId: 0,
        addressPoolId: undefined,
        addressTypeId: undefined,
        careof: '',
        contextId: 0,
        contextType: 'Client',
        isFavorite: false,
        isDeleted: false,
        fullAddressList: [],
        addressInput$: new Subject<string>()
      };

      this.sub.add(newAddressSet.addressInput$.pipe(
        debounceTime(500),
        distinctUntilChanged(),
        filter(term => term.length >= 3),
        switchMap(term => this.fetchAddresses(term))
      ).subscribe((addresses: any[]) => {
        newAddressSet.fullAddressList = addresses;
      }));

      if (this.addressSets.length > 0) {
        const selectedAddresses = this.addressSets
          .filter(set => set.addressPoolId && set.addressTypeId)
          .map(set => {
            const selectedAddress = set.fullAddressList.find(address => address.addressPoolId === set.addressPoolId);
            const addressType = this.addressTypes.find(type => type.addressTypeId === set.addressTypeId);
            if (selectedAddress && addressType) {
              return {
                ...selectedAddress,
                addressLine: `${addressType.addressTypeName}: ${selectedAddress.addressLine}`
              };
            }
            return null;
          })
          .filter(address => address !== null);

        newAddressSet.fullAddressList = selectedAddresses;
      }
      if (this.addressSets.length > 1 && this.addressSets.length < this.addressTypes.length) {
        for (let i = 1; i < newAddressSet?.fullAddressList.length; i++) {
          newAddressSet.fullAddressList[i].addressLine = this.removeSecondAddress(newAddressSet.fullAddressList[i].addressLine);
        }
      }
      this.addressSets.push(newAddressSet);
    }
    if (this.addressTypeList.length === 0) {
      this.addressTypeList[this.addressSets.length - 1] = this.addressTypes;
    } else {
      let addressTypeIds = this.addressSets.map(obj => obj.addressTypeId);
      this.addressTypeList[this.addressSets.length - 1] = this.addressTypes.filter(item => !addressTypeIds.includes(item.addressTypeId));
    }
  }

  removeSecondAddress(inputString) {
    const count = (inputString.match(/address:/g) || []).length;
    if (count > 1) {
      const firstIndex = inputString.indexOf('address:');
      const secondIndex = inputString.indexOf('address:', firstIndex + 1);
      const spaceIndex = inputString.lastIndexOf(' ', inputString.lastIndexOf(' ', secondIndex) - 1);
      return inputString.slice(0, spaceIndex) + inputString.slice(secondIndex + 'address:'.length);
    }
    return inputString;
  }

  fetchAddresses(term: string): Observable<any> {
    return this._clientService.getAddressList(JSON.stringify(term));
  }

  onAddressSearch(event: { term: string }, index: number) {
    if (event.term.length >= 3) {
      this.addressSets[index].addressInput$.next(event.term);
    } else {
      this.addressSets[index].fullAddressList = [];
    }
  }

  onAddressSearchContact(event: { term: string }, index: number) {
    if (event.term.length >= 3) {
      this.addressSetsContact[index].addressInput$.next(event.term);
    } else {
      this.addressSetsContact[index].fullAddressList = [];
    }
  }

  setAddressAsFavorite(index) {
    for (let i = 0; i < this.addressSets.length; i++) {
      if (i === index) {
        this.addressSets[i].isFavorite = true;
      }
      else {
        this.addressSets[i].isFavorite = false;
      }
    }
  }

  setAddressAsFavoriteContact(index) {
    for (let i = 0; i < this.addressSetsContact.length; i++) {
      if (i === index) {
        this.addressSetsContact[i].isFavorite = true;
      }
      else {
        this.addressSetsContact[i].isFavorite = false;
      }
    }
  }

  public deletedAddressSets: any = [];
  removeAddress(index: number) {
    this.addressSets[index].isDeleted = true;
    this.deletedAddressSets.push(this.addressSets[index]);
    this.deletedAddressSets.forEach(address => {
      delete address.addressInput$;
    })
    this.addressSets = this.addressSets.filter(item => item.isDeleted === false);
    if (this.addressSets.length === 0) {
      this.addAddressSet();
    }
  }

  public deletedAddressSetsContact: any = [];
  removeAddressContact(index: number) {
    this.addressSetsContact[index].isDeleted = true;
    this.deletedAddressSetsContact.push(this.addressSetsContact[index]);
    this.addressSetsContact = this.addressSetsContact.filter(item => item.isDeleted === false);
    if (this.addressSetsContact.length === 0) {
      this.addAddressSetContact();
    }
  }
  public activateButton: boolean = false;
  checkAddressPool(address) {
    if (address.addressTypeId && address.addressPoolId === null) {
      this._toastr.warning('Address cannot be empty');
    }
    if (address.addressTypeId && address.addressPoolId) {
      this.activateButton = false;
    }
  }

  checkAddressPoolContact(address) {
    if (address.addressTypeId && address.addressPoolId === null) {
      this._toastr.warning('Address cannot be empty');
    }
    if (address.addressTypeId && address.addressPoolId) {
      this.activateButtonContact = false;
    }
  }
  
  getUsersDisplayInClientOrJob(key) {
    this.userManagementService.getUsersDisplayInClientOrJob(key).subscribe(
      response => {
        this.partnerAndManagerList = response;
        this.validatePartnersAndManagerList();
      }
    )
  }

  initializeConstants() {
    this.maxDate = new Date();
    this.clientDataModal.clientStartDate = this.maxDate;
  }

  getTeams() {
    this.teamsService.GetTeamsForCombo().subscribe(result => {
      this.teamList = result;
    })
  }

  getFirmDetails() {
    this.firmDetailService.getFirmDetails().subscribe(result => {
      this.firmDetails = result;
      this.isAuto = this.firmDetails.isAutoMode;
      this.bpayAlgorithm = this.firmDetails.bPayAlgorithm ?? 10;      
      this.officeData.officeViewManagePermission = result?.canEnableOffice || false;
      (this.officeData.officeViewManagePermission) ? this.getActiveOfficesList() : '';
    })
  }

  ResetSymphy() {
    this.clientDataModal.title = null;
  }

  dateFormatSet(event) {
    if (event.target.value != "") {
      if (event.target.value.split('/').length == 2) {
        this.datemaxlength = 9;
      }
      else if (event.target.value.split('/').length == 3) {
        this.datemaxlength = 10;
      }
      else {
        this.datemaxlength = 8;
      }
    }
  }

  initData() {
    this.getStaffs()
    if (this._tempload == 1) {
      this.contactTable = [];
      this.currentPage = 0;
      this.clientDataModal.entityTypeId = 1;
      let list1 = { 'ContactId': 0, 'Name': '', 'Emailaddress': '', 'DateOfBirth': '', 'ContactType': 0, 'ContestType': 'Contact' };
      this.contactTable.push(list1);
      if (this.checkCreateClient) {
        this.checkCreateClient = false;
      } else {
        this.getAllPartners();
        this.getAllManagers();
      }
      this.getAllDivisions();
       this.GetAllClientTag();
      this.getAllTaxAgents();
      this.maxDate = new Date();
      this.datemaxlength = 8;
      this.masterSelected = false;
      this.isBulkOptionDisabled = false;
      this.clientDataModal.entityTypeId = 1;
      this.onChangeEType(this.clientDataModal.entityTypeId);
      this.clientDataModal.divisionId = undefined; this.makebuttondisable = false; this._count = 0; this.clientDataModal.clientCode = '';

      this.dynamicFilterList = [
        { id: '1', Name: 'Tag' }, { id: 2, Name: 'Location' }, { id: 3, Name: 'Partner' }, { id: 4, Name: 'Manager' }, { id: 5, Name: 'Is Tax Client' }, { id: 6, Name: 'Tax Agent' }
        , { id: 7, Name: 'Contact Name' }, { id: 8, Name: 'Next Followup Date' }, { id: 9, Name: 'Last Activity Date' }, { id: 10, Name: 'Industry' }, { id: 11, Name: 'GST Registered' }
        , { id: 12, Name: 'Active Jobs' }, { id: 13, Name: 'Number of Opportunity Jobs' }, { id: 14, Name: 'WIP' }, { id: 15, Name: 'Last Invoice Sent' }
      ]
      this.staticStatusList = [{ StatusId: 1, Name: 'All' }, { StatusId: 2, Name: 'Active' }, { StatusId: 3, Name: 'Archive' }, { StatusId: 4, Name: 'Oppurtunity' }]
      this.staticEntityTypeList = [{ EntityTypeId: 1, Name: 'Individual' }, { EntityTypeId: 2, Name: 'Company' }, { EntityTypeId: 3, Name: 'Partnership' }, { EntityTypeId: 4, Name: 'Trust' }, { EntityTypeId: 5, Name: 'SMSF' }]
      this.setdefaultcoloumns();
      this.clientType = window.location.pathname.split("/").pop();
      this.entitynm;
      this.GetEntityType();
      this.GetTagdetailsList(this.isArchive);
      this.getAllFolderType();
      this.GetCustomFieldsforClientinQuicklinkByRole(this._TempClientId);
      this.contactTable = [];
      this.buttontext = 'Create';
      this.IseditClient = false;
      this.clientDataModal.entityTypeId = 1; this.onChangeEType(this.clientDataModal.entityTypeId);
      this.clientDataModal.divisionId = undefined;
      this.selectedClientTags = [];
      this.currentPage = 0;
      this.clientDataModal.physicalcountry = '13';
      this.clientDataModal.postalcountry = '13';
      this.onChangeContactCountry('13');
      this.onChangeContactCountry1('13');
      this.contactDataModal.physicalcountry = '13';
      this.contactDataModal.postalcountry = '13';
      this.onChangeContactCountry2('13');
      this.onChangeContactCountry3('13');
      this.GetContactforClient();
    }

    if (this._TempClientId > 0) {
      this.buttontext = 'Update ';
      this.isEditMode = true;
      this.GetClientDetailsById(this._TempClientId);
    }
    else {
      this.isEditMode = false;
    }
    this.isShowTFN = false;
    this.isShowDIN = false;
    this.noPermissionTFNData = '';
    this.noPermissionDINData = '';
    this.isShowBSB = false;
    this.noPermissionBSBData = '';
    this.isShowBankAccountnumber = false;
    this.noPermissionAccountNumberData = '';
    this.selectedClientTags = [];
    (this.clientDataModal as any).tagIdsJson = JSON.stringify({ TagIds: [] });
  }

  basic() {
    this.basicone = true;
    this.linkone = false;
    this.finanicialone = false;
    this.softwareone = false;
  }

  openSubMenuNote(trigger) {
    trigger.openMenu();
  }

  closeSubMenuNote(trigger) {
    trigger.closeMenu();
  }

  closeclient(ConfirmCode: boolean, inputform: NgForm, selectedOption) {
    this.cancelSelectedOption = selectedOption;
    if (selectedOption == "SaveClose") {
      this.modalRef.hide();
      this.UpdateButtonClicked();
      let element: HTMLElement = document.getElementById('buttontext1') as HTMLElement;
      element.click();
    }
    else if (ConfirmCode) {
      this.modalRef.hide();
    }
    else {
      this.changeField = false;
      this.clean(inputform);
      this.modalRef.hide();
      this.closeCreateclientPopup.emit()
    }
    this.onChangeEType(1);
  }

  UpdateButtonClicked() {
    this.isClickedOnUpdate = true;
    if (this.tabOne) {
      this.tabOne = false;
      this.tabTwo = false;
    } else {
      this.tabTwo = true;
    }
  }

  updateClientInfo(delta: number, inputform: NgForm) {
    this.updateClientCodeValidation();
    /* CUST-4894, Dev: Parth, 09-Sep-2024 - if form is invalid return immediately */
    if (inputform?.form?.invalid) {
      inputform.form.markAllAsTouched();
      this.commonService.focus_invalid_form_field(inputform.form, this.el);
      return;
    }
    this.tabOne = true;
    this.emailString = "";
    this.phoneString = "";
    this.missingAddressString = '';
    this.checkSaveAndContinue = false;
    this.missingAddresses = this.addressSets.filter(address =>
      address.addressPoolId === undefined && address.addressTypeId !== undefined
    );
    if ((!this.validationReturnCheck() && this.currentPage == 0) || (this.missingAddresses.length > 0 && this.currentPage == 0)) {
      this.allEmailsNotEmpty = this.emails.every(e => !e.emailId || e.emailId.trim() === '');
      this.allPhonesNotEmpty = this.phones.every(p => !p.phoneNumber || p.phoneNumber.trim() === '');
      const phoneNumberValidationFailed = this.phones.some(p => p.phoneNumber && !p.isValidPhone);
      if (this.emails.length < 0 || this.allEmailsNotEmpty || this.phones.length < 0 || this.allPhonesNotEmpty || this.missingAddresses.length > 0 || phoneNumberValidationFailed) {
        if (this.allEmailsNotEmpty) {
          this.emailString = " <b>Email</b>";
        }
        if (this.allPhonesNotEmpty) {
          this.phoneString = " <b>Phone</b>";
        }
        if(phoneNumberValidationFailed) {
          this._toastr.error("Please correct the invalid phone numbers before proceeding.");
          return;
        }
        if (this.missingAddresses.length > 0) {
          this.missingAddressString = " <b>Address</b>"
        }

        let missingFields = [];
        if (this.emailString !== "") missingFields.push(this.emailString);
        if (this.phoneString !== "") missingFields.push(this.phoneString);
        if (this.missingAddressString !== "") missingFields.push(this.missingAddressString);

        if (missingFields.length === 0) {
          this.validationMessage = '';
        } else if (missingFields.length === 1) {
          this.validationMessage = missingFields[0];
        } else {
          this.validationMessage = missingFields.slice(0, -1).join(', ') + ' and ' + missingFields[missingFields.length - 1];
        }

        this.modalRef = this.modalService.show(KcWarningPopupComponent, {
          class: 'modal-dialog-centered',
          backdrop: 'static',
          initialState: {
            mainContent: "You are about to " + this.buttontext.toLocaleLowerCase() + " a client without" + this.validationMessage + ".",
            isSaveAndCloseReq: false
          }
        });
        this.modalRef.content.event.subscribe(res => {
          if (res === this.warningPopupRes.YES) {
            this.checkSaveAndContinue = true;
            this.changeField = false;
            this.modalRef?.hide();
            this.checkbypassValidation = true;
            this.SaveAndNext(delta, inputform);
          }
          if (res === this.warningPopupRes.NO) {
            this.checkChangePage = false;
            this.checkbypassValidation = false;
            this.allPhonesNotEmpty = false;
            this.allEmailsNotEmpty = false;
            this.modalRef?.hide();
          }
        })
      } else {
        this.SaveAndNext(delta, inputform);
      }
    } else {
      this.SaveAndNext(delta, inputform);
    }
  }

  SaveAndNext(delta: number, inputform: NgForm) {
    this.isClickedOnUpdate = false;
    this.setLoadedForm();

    if (inputform.form.invalid && !this.checkbypassValidation) {
      const firstInvalidControl: HTMLElement = this.el.nativeElement.querySelector("form .ng-invalid");
      firstInvalidControl.focus();
      this._toastr.error("Please enter all required field first", 'Create client');
      return
    } else if (this.currentPage == 1 && (this.contactTable.length != 0 && this.contactTable[this.contactTable.length - 1].ContactId == 0)) {
      this._toastr.error('Please add contact first!', 'Add contact')
      return
    } else {
      if (this.validate() && this.ValidateLinked) {
        this.currentPage += delta;
        if (this.clientDataModal.cfirstName != undefined && this.clientDataModal.cfirstName != "")
          this.contactHide = true;
        this.addingClientdetails(inputform, true);
      }
    }

    if (this.clientDataModal.entityTypeId != undefined) {
      if (this.clientDataModal.entityTypeId == 1) {
        this.IsIndividual = true;
      }
      else {
        this.IsIndividual = false;
      }
    }
  }
  Link() {
    this.basicone = false;
    this.finanicialone = false;
    this.softwareone = false;
    this.linkone = true;
  }
  finacial() {
    this.basicone = false;
    this.finanicialone = true;
    this.softwareone = false;
    this.linkone = false;
  }
  software() {
    this.basicone = false;
    this.finanicialone = false;
    this.softwareone = true;
    this.linkone = false;
  }
  public currentPage = 0;
  public changePage1(delta: number): void {
    this.updateClientCodeValidation();
    /* CUST-4894, Dev: Parth, 23-Oct-2024 - if form is invalid return immediately */
    if (this.addClientForm?.form?.invalid) {
      this.commonService.focus_invalid_form_field(this.addClientForm.form, this.el);
      return;
    }

    this.currentPage += delta;
    if (this.currentPage == 0) {
      this.contactHide = false;
      this.setLoadedForm();
      this.SetDefaultValue();
    }
    this._count = this._count > 0 ? this._count - 1 : 0;
  }

  getClientListcheck() {
    this._clientService.GetClientListForCombo().subscribe({
      next: (result: any) => {
      if (result) {
        this.clientListCheck = result;
        this.allClientCodes = result.map(obj => obj.clientCode);
      }
    }, error: (error: any) => {
      this._toastr.error("Please contact system admin", "Something went wrong")
    }
    });
  }

  public changePage(event, delta: number): void {
    this.updateClientCodeValidation();
    /* CUST-4894, Dev: Parth, 23-Oct-2024 - if form is invalid return immediately */
    if (this.addClientForm?.form?.invalid) {
      this.commonService.focus_invalid_form_field(this.addClientForm.form, this.el);
      return;
    }

    if (!this.ValidateLinked) {
      return;
    }
    if (!this.checkbypassValidation) {
      this.checkChangePage = true;
    }
    this.btnId = event.currentTarget.id;
    if (this.currentPage == 1 && (this.contactTable.length != 0 && this.contactTable[this.contactTable.length - 1].ContactId == 0)) {
      this._toastr.error('Please add contact first!', 'Add contact')
      return
    }
    if (this.validate() && this.ValidateLinked) {
      if ((this.clientDataModal.clientCode == "" || this.clientDataModal.clientCode == null)) {
        return;
      }

      let res = this.clientListCheck.filter(item => item.clientCode == this.clientDataModal.clientCode);
      if (res.length != 0) {
        this._flagCodeExist = true;
        return;
      }
      this.currentPage += delta;
      if (this.currentPage == 1) {
        if (this.phoneValidation()) {
          this.currentPage = 0;
        }
      }
      if (this.clientDataModal.cfirstName != undefined && this.clientDataModal.cfirstName != "")
        this.contactHide = true;
      if (this.contactdata == undefined || this.contactdata.length == 0) {
        this.GetContactforClient();
      }
    }
  }
  onChangeEntity() {
    this.clientDataModal.clientCode = null;
    this.clientDataModal.firstname = null;
    this.clientDataModal.lastname = null;
    this.clientDataModal.companyName = null;
    this.clientDataModal.trustName = null;
    this.clientDataModal.partnershipname = null;
    this.clientDataModal.smsfName = null;
    this.clearPrefilledNames();
  }

  generateClientCode() {
    if(!this.IseditClient) { this.prefillMailingName(); }

    if (this.isAuto && this.buttontext == 'Create') {
      const entityTypeId = this.clientDataModal.entityTypeId;
      let clientCode;

      const removeSpaces = (str) => str.replace(/[^a-z0-9]/gi, '');

      if (entityTypeId === 1) {
        const firstName = removeSpaces(this.clientDataModal.firstname || '');
        const lastName = removeSpaces(this.clientDataModal.lastname || '');

        const firstTwoDigits = firstName.slice(0, 2).toUpperCase();
        const lastTwoDigits = lastName.slice(0, 2).toUpperCase();

        let clientCodeBase = `${lastTwoDigits}${firstTwoDigits}000`;
        let suffix = 1;
        clientCode = `${clientCodeBase}${suffix}`;

        if (clientCode.length < 8) {
          const zerosToAdd = 8 - clientCode.length;
          const middleZeros = '0'.repeat(zerosToAdd);
          clientCode = `${lastTwoDigits}${firstTwoDigits}${middleZeros}0001`;
        }
      } else if (entityTypeId === 2 || entityTypeId === 3 || entityTypeId === 4 || entityTypeId === 5) {
        let name;
        switch (entityTypeId) {
          case 2:
            name = removeSpaces(this.clientDataModal.companyName || '');
            break;
          case 3:
            name = removeSpaces(this.clientDataModal.trustName || '');
            break;
          case 4:
            name = removeSpaces(this.clientDataModal.partnershipname || '');
            break;
          case 5:
            name = removeSpaces(this.clientDataModal.smsfName || '');
            break;
          default:
            break;
        }

        const firstFourDigits = name.slice(0, 4).toUpperCase();

        let clientCodeBase = `${firstFourDigits}0001`;
        clientCode = clientCodeBase;

        if (clientCode.length < 8) {
          const zerosToAdd = 8 - clientCode.length;
          const middleZeros = '0'.repeat(zerosToAdd);
          clientCode = `${firstFourDigits}${middleZeros}0001`;
        }
      }

      let suffix = 1;
      let finalClientCode = clientCode;
      while (this.allClientCodes.includes(finalClientCode)) {
        suffix++;
        finalClientCode = `${clientCode.slice(0, -4)}${suffix.toString().padStart(4, '0')}`;
      }

      this.clientDataModal.clientCode = finalClientCode;
    }
  }

  validateClientCode() {
    if (this.allClientCodes.includes(this.clientDataModal.clientCode)) {
      this.clientCodeExists = true;
    }
    else {
      this.clientCodeExists = false;
    }
  }

  isClientCodeValid() {
    const regex = /^[a-zA-Z0-9]+$/;
    if (regex.test(this.clientDataModal.clientCode)) {
      this.invalidClientCode = false;
    }
    else {
      this.invalidClientCode = true;
    }
  }

  updateClientCodeValidation() {
    if (this.phonestring1) {
      const cleanedPhone1 = this.phonestring1.replace(/\s+/g, '');
      if (cleanedPhone1.length !== 10) {
        this._phone1Validator = true;
      }
    }

    if (this.phonestring2) {
      const cleanedPhone2 = this.phonestring2.replace(/\s+/g, '');
      if (cleanedPhone2.length !== 10) {
        this._phone2Validator = true;
      }
    }
    if (this.phonestring3) {
      const cleanedPhone3 = this.phonestring3.replace(/\s+/g, '');
      if (cleanedPhone3.length !== 10) {
        this._phone3Validator = true;
      }
    }
    let formControl = this.addClientForm.form.controls['ClientCodedd'];

    if (formControl) {
      const errors = formControl.errors;

      if (this._flagCodeExist || this.clientCodeExists || this.invalidClientCode) {
        /* setting error manually for duplicate or invalid email */
        formControl.setErrors({ 'invalidClientCode': true });
      } else if (errors) {
        /* removing error */
        delete errors['invalidClientCode'];

        if (Object.keys(errors)?.length) {
          formControl.setErrors(errors);
        } else {
          formControl.setErrors(null);
        }
      }
    }
  }


  SetDefaultValue() {
    if (this.clientDataModal.title == null)
      this.clientDataModal.title = undefined;
    if (this.clientDataModal.gender == null)
      this.clientDataModal.gender = undefined;
    if (this.clientDataModal.trustType == null)
      this.clientDataModal.trustType = undefined;
    if (this.clientDataModal.partnerId == null)
      this.clientDataModal.partnerId = undefined;
    if (this.clientDataModal.managerId == null)
      this.clientDataModal.managerId = undefined;
    if (this.clientDataModal.teamId == null)
      this.clientDataModal.teamId = undefined;
    if (this.clientDataModal.addressPoolClientMapping == null)
      this.clientDataModal.addressPoolClientMapping = undefined;
    if (this.clientDataModal.divisionId == 0)
      this.clientDataModal.divisionId = undefined;
    if (this.clientDataModal.physicalstate == null)
      this.clientDataModal.physicalstate = undefined;
    if (this.clientDataModal.physicalcountry == null)
      this.clientDataModal.physicalcountry = undefined;
    if (this.clientDataModal.postalstate == null)
      this.clientDataModal.postalstate = undefined;
    if (this.clientDataModal.postalcountry == null)
      this.clientDataModal.postalcountry = undefined;
  }

  validate() {
    if (this.clientDataModal.entityTypeId == undefined) {
      return false;
    }
    else if (this.clientDataModal.clientCode == "" || this.clientDataModal.clientCode == null) {
      return false;
    }

    else if (this.clientDataModal.entityTypeId == 1 && (this.clientDataModal.firstname == undefined || this.clientDataModal.firstname == "")) {
      return false;
    }
    else if (this.clientDataModal.entityTypeId == 1 && (this.clientDataModal.lastname == undefined || this.clientDataModal.lastname == "")) {
      return false;
    }

    else if (this.clientDataModal.entityTypeId == 2 && (this.clientDataModal.companyName == undefined || this.clientDataModal.companyName == "")) {
      return false;
    }
    else if (this.clientDataModal.partnerId == undefined || this.clientDataModal.partnerId == "") {
      return false;
    }
    else if (this.clientDataModal.divisionId == undefined || this.clientDataModal.divisionId == "") {
      return false;
    }

    else if (this.clientDataModal.entityTypeId == 3 && (this.clientDataModal.trustName == undefined || this.clientDataModal.trustName == "")) {
      return false;
    }

    else if (this.clientDataModal.entityTypeId == 4 && (this.clientDataModal.partnershipname == undefined || this.clientDataModal.partnershipname == "")) {
      return false;
    }
    else if (this.clientDataModal.entityTypeId == 5 && (this.clientDataModal.smsfName == undefined || this.clientDataModal.smsfName == "")) {
      return false;
    }
    else if (this.clientDataModal.entityTypeId == 1 && (this.emails.length < 0 || this.allEmailsNotEmpty) && !this.checkbypassValidation) {
      return false;
    }
    else if (this.clientDataModal.entityTypeId == 1 && (this.phones.length < 0 || this.allPhonesNotEmpty) && !this.checkbypassValidation) {
      return false;
    }
    else {
      return true;
    }

  }

  validationReturnCheck() {
    if (this.clientDataModal.clientCode == "" || this.clientDataModal.clientCode == null) {
      return true;
    }
    else if (this.clientDataModal.entityTypeId == 1 && (this.clientDataModal.firstname == undefined || this.clientDataModal.firstname == "")) {
      return true;
    }
    else if (this.clientDataModal.entityTypeId == 1 && (this.clientDataModal.divisionId == undefined || this.clientDataModal.divisionId == "")) {
      return true;
    }
    else if (this.clientDataModal.entityTypeId == 1 && (this.clientDataModal.lastname == undefined || this.clientDataModal.lastname == "")) {
      return true;
    }
    else if (this.clientDataModal.partnerId == undefined || this.clientDataModal.partnerId == "") {
      return true;
    }
    else {
      return false;
    }
  }

  contactInform(inputForm) {
    inputForm.form.status = 'VALID';
    inputForm.submitted = false;
    this.contactHide = true;
    this.clientDataModal.contactId = 0;
    this.GetCustomFieldsforQuicklinkContactByRole(0);
    if (this.addressSetsContact.length === 0) {
      this.addAddressSetContact();
    }
  }

  openclientfilterpopup() {
    this.FilterModalPopup.show();
  }

  contactInformBack() {
    this.contactHide = false;
    this.clientDataModal.contactId = null;
  }

  WarningPopuponeClose() {
    this.modalRef?.hide();
  }

  waringpopuponeyes() {
    this.changeContactField = false;
    this.contactHide = false;
    this.modalRef?.hide();
    this.workEmailCount2 = 1;
    this.homePhoneCount2 = 1;
    this.contactDataModal = new Contact();
    this.contactsIds = null;
    this.emailstring4 = null;
    this.emailstring5 = null;
    this.emailstring6 = null;
    this.phonestring4 = null;
    this.phonestring5 = null;
    this.phonestring6 = null;
    this._phone4Validator = false;
    this._phone5Validator = false;
    this._phone6Validator = false;
    this.contactDataModal.physicalcountry = '13';
    this.contactDataModal.postalcountry = '13';
    this.onChangeContactCountry2('13');
    this.onChangeContactCountry3('13');
    this.addcontact.submitted = false;
    this.modalRef?.hide();
  }

  popUpAddClientOff() {
    this.contactHide = false;
  }

  PopUpAddClientOn(val) {
    this.getAllManagers();
    this.currentPage = 0;
    this.clientDataModal.entityTypeId = 1;
    this.GetContactforClient();

    if (val == "Add") {
      this.IseditClient = false;
      this.contactHide = false;
      this.buttontext = "Create";
      this.Showcheck = true;
      this.ShowPostal = false;
    }
    if (val == "Edit") {
      this.IseditClient = true;
      this.buttontext = "Update ";
      this.Showcheck = false;
      this.ShowPostal = true;
    }
    document.getElementById("AddClientPopup").style.display = "block";
  }

  selectEvent(item) {
    this.CcontactId = item.contactId;
  }

  ngAfterViewInit() {
    this.addQuick = this.route.snapshot.queryParams["Orgin"];
    if (this.addQuick == undefined) {
      this.popUpAddClientOff();
    }
    else if (this.addQuick = "AddQuick") {
      this.PopUpAddClientOn('Add');
    }
  }

  assigncontact() {
    let op = this.contactlist.map(function (item) {
      return item[0].contactId;
    });

    this.clientDataModal.contactIds = JSON.stringify(op);
    this._toastr.success("Contact added successful!", 'Create client');
  }

  onAddContact(item) {
    let contactId: any = item.contactId;
    let name: any = item.name;
    let email: any = item.email;
    let contactType: any = 0;
    let ContestType: any = item.contestType;
    let dateOfBirth: any = (item.dateOfBirth == '0001-01-01T00:00:00' || !item.dateOfBirth) ? null : item.dateOfBirth;
    const dateOfDeath: any = (item?.dateofDeath == '0001-01-01T00:00:00' || !item?.dateofDeath) ? null : item?.dateofDeath;
    let list = { "ContactId": contactId, "Name": name, "Emailaddress": email, "DateOfBirth": dateOfBirth, "DateOfDeath": dateOfDeath, 'ContactType': contactType, 'ContestType': ContestType };
    this.contactTable.push(list);
    this.contactdata.splice(this.contactdata.findIndex(v => v.contactId === Number(contactId)), 1);
    this.dynamicName1 = "";
  }

  RemoveContact(contactId) {
    this.contactTable.splice(this.contactTable.findIndex(v => v.ContactId === Number(contactId)), 1);
    this.GetContactforClient();
  }

  onRemoveContact(item) {
    let value = '/' + item.value.contactId + '/gi';
    this.contactsIds.replace(value, '');
  }

  onClear() {
    this.contactsIds = null;
  }

  onChangeSearch(val: string) { }

  onFocused(e) { }

  popUpShowOff() {
    this.AddOrUpdateDynamicFilter = 'Save';
    this.CheckedEntity = '';
    this.CheckedStatus = '';
    this.CheckedManager = '';
    this.CheckedConatct = '';
    this.CheckedTag = '';
    this.Checkedpartner = '';
    this.CheckedLoaction = '';
    this.CheckedIndustry = '';
    this.CheckedTaxAgent = '';
    this.dynamicfilterObj = new DynaicFilterPost();
    this.dynamicfilterObj.WIP = '0';
    this.dynamicfilterObj.AnnualIncome = '0';
    this.dynamicfilterObj.isTaxAgent = false;
    document.getElementById("Showpopup").style.display = "none";
  }

  PopUpShowOn() {
    if (this.dynamicfilterObj.SavedFilterName != undefined) {
      this.isFilterSavedName = false;
      document.getElementById("Showpopup").style.display = "block";
    }
    else {
      this.isFilterSavedName = true;
      document.getElementById("id01").style.display = "block";
    }
  }

  onChangeCountry(id) {
    this.getContactStatesData(id, 'states')
  }

  clientshow() {
    this.showclient = true;
    this.showcontact = false;
  }
  
  contact() {
    this.showclient = false;
    this.showcontact = true;
    this.GetContactList();
  }

  GetContactforClient() {
    this._clientService.GetContactforClient('').subscribe({
      next: (response: any) => {
      if (response) {
        this.contactdataval = response;
        this.contactdata = response;
        this.contactdata = [];
        for (let i = 0; i < this.contactdataval.length; i++) {
          let list1 = {
            'contactId': this.contactdataval[i].contactId, 'name': this.contactdataval[i].name, 'email': this.contactdataval[i].email,
            'dateOfBirth': this.contactdataval[i].dateOfBirth, 'physicalsuburb': this.contactdataval[i].physicalsuburb,
            'contestType': this.contactdataval[i].contestType
          };
          this.contactdata.push(list1);
        }
      }
    }, error: (error: any) => {
      this._toastr.error("some thing went wrong")
    }
  });
    return this.LocaltempclientFilter;
  }

  getTitleList() {
    this._clientService.GetTitleList().subscribe({
      next: (response: any) => {
      if (response) {
        this.titleList = response;
        if (this.stateManagement.getTitleList.value == null) {
          this.stateManagement.updateData(this.stateManagement.getTitleList, response)
        }
      }
    },
    error: (error: any) => {
        this._toastr.error("some thing went wrong", 'Create client')
      }
    });
    return this.LocaltempclientFilter;
  }

  popUpOff() {
    document.getElementById("id01").style.display = "none";
    this.AddOrUpdateDynamicFilter = 'Save';
  }
  PopUpOnBack() {
    document.getElementById("id01").style.display = "block";
  }
  
  PopUpOn() {
    if (this.AddOrUpdateDynamicFilter == 'Save') {
      this.dynamicfilterObj = new DynaicFilterPost();
      this.dynamicfilterObj.WIP = '0';
      this.dynamicfilterObj.AnnualIncome = '0';
      this.dynamicfilterObj.GstRegisted = 'No';
      this.dynamicfilterObj.isTaxAgent = false;
      this.StatusTypePost = [];
      this.entityTypePost = [];
      this.TagList = this.getTagListForDynamicFeild();
      this.staticEntityTypeList = [{ EntityTypeId: 1, Name: 'Individual' }, { EntityTypeId: 2, Name: 'Company' }, { EntityTypeId: 3, Name: 'Partnership' }, { EntityTypeId: 4, Name: 'Trust' }, { EntityTypeId: 5, Name: 'SMSF' }]
      this.staticStatusList = [{ StatusId: 1, Name: 'All' }, { StatusId: 2, Name: 'Active' }, { StatusId: 3, Name: 'Archive' }, { StatusId: 4, Name: 'Oppurtunity' }]
    }

    document.getElementById("id01").style.display = "block";
    this._clientService.GetFilterList().subscribe((response: any) => {
      if (response) {
        this.location = response.result.location;
        this.ManagerList = response.result.manager;
        this.ContactNameList = response.result.contact;
        this.partnerList = response.result.patner;

        this.TaxAgentList = response.result.taxAgent;
        this.IndustryTypeList = response.result.industry;
      }
    }, error => this._toastr.error("some thing went wrong please contact system administrator."));
  }
  getTagListForDynamicFeild() {
    this._clientService.GetTagdetailsclients(false).subscribe((res: any) => {

      this.TagList = res;
      this.TagList.forEach((item, index) => {
        let comm = {
          display: item.tagname,
          value: item.tagId,
          backgroundColor: item.colour,
        }
        this.activiesCount = this.ClientProfileActivities.push(comm);

      });
    });
    return this.TagList;
  }

  createEmailRow(emailTypeId: number) {
    return {
      emailTypeId,
      emailId: '',
      isPreferred: false,
      isFavourite: false
    };
  }

  addEmail() {
    const nextEmailTypeId = this.getNextAvailableEmailTypeId();

    if (nextEmailTypeId === null) {
      // Optional: show error or disable button
      // this._toastr.error('Maximum 5 emails reached for all email types');
      return;
    }

    this.emails.push(this.createEmailRow(nextEmailTypeId));
    this.updateFavouriteEmail();
  }

  removeEmail(index: number, emailObj: any) {
    this.emails.splice(index, 1);
    if(emailObj.isPreferred) {
      const idx = this.emails.findIndex(e => e.emailTypeId === emailObj.emailTypeId);
      if (idx !== -1) this.setPreferredEmail(idx, true);
    }
    if(emailObj.isFavourite) {
      this.setStartedEmail(0, true);
    }
    this.updateFavouriteEmail();
  }

  setPreferredEmail(index: number,canMakePreferred: boolean = true) {
    if (!this.emails[index].emailId) {
      this._toastr.error("Please enter an email before setting it as preferred.");
      this.emails[index].isPreferred = false;
      return; // or show a toast
    }

    const typeId = this.emails[index].emailTypeId;

    this.emails.forEach(e => {
      if (e.emailTypeId === typeId) {
        e.isPreferred = false;
      }
    });

    this.emails[index].isPreferred = canMakePreferred;
  }

  setStartedEmail(index: number, canMakeStarted: boolean = true) {
    if (!this.emails[index].emailId) {
      this._toastr.error("Please enter an email before setting it as started.");
      this.emails[index].isFavourite = false;
      return; // or show a toast
    }

    this.emails.forEach(e => e.isFavourite = false);
    this.emails[index].isFavourite = canMakeStarted;
  }

  get emailTypeCounts(): Record<number, number> {
    return this.emails.reduce((acc, e) => {
      acc[e.emailTypeId] = (acc[e.emailTypeId] || 0) + 1;
      return acc;
    }, {} as Record<number, number>);
  }

  getMaxAllowedEmails(): number {
    return this.emailTypes?.length * this.maxEmailsPerType;
  }

  isEmailTypeDisabled(item: any): boolean {
    if (!item) return false;

    const count = this.emailTypeCounts[item.emailTypeId] || 0;

    // Allow the currently selected value
    return (
      count >= this.maxEmailsPerType &&
      item.emailTypeId !== this.rowBeingEditedEmailTypeId
    );
  }

  getNextAvailableEmailTypeId(): number | null {
    const counts = this.getEmailTypeCounts();

    const available = this.emailTypes.find(t =>
      (counts[t.emailTypeId] || 0) < 5
    );

    return available ? available.emailTypeId : null;
  }

  onDropdownOpenEmail(row: any) {
    this.rowBeingEditedEmailTypeId = row.emailTypeId;
  }

  getEmailTypeCounts(): Record<number, number> {
    return this.emails.reduce((acc, email) => {
      acc[email.emailTypeId] = (acc[email.emailTypeId] || 0) + 1;
      return acc;
    }, {} as Record<number, number>);
  }

  createPhoneRow(phoneTypeId: number) {
    return {
      phoneTypeId,
      phoneNumber: '',
      isPreferred: false,
      isFavourite: false,
      countryRegionCode: this.defaultSelectedCountry.code,
      countryName: this.defaultSelectedCountry.name,
      countryId: this.defaultSelectedCountry.countryId,
      name: this.defaultSelectedCountry.name,
      isdCode: this.defaultSelectedCountry.isdCode
    };
  }

  addPhone() {
    const nextPhoneTypeId = this.getNextAvailablePhoneTypeId();

    if (nextPhoneTypeId === null) {
      return;
    }

    this.phones.push(this.createPhoneRow(nextPhoneTypeId));
    this.updateFavouritePhone();
  }

  removePhone(index: number, phoneObj: any) {
    this.phones.splice(index, 1);
    if(phoneObj.isPreferred) {
      const idx = this.phones.findIndex(e => e.phoneTypeId === phoneObj.phoneTypeId);
      if (idx !== -1) this.setPreferredPhone(idx, true);
    }
    if(phoneObj.isFavourite) {
      this.setStartedPhone(0, true);
    }
    this.updateFavouritePhone();
  }

  setPreferredPhone(index: number,canMakePreferred: boolean = true) {
    if (!this.phones[index].phoneNumber) {
      this._toastr.error("Please enter a phone number before setting it as preferred.");
      this.phones[index].isPreferred = false;
      return; // or show a toast
    }

    const typeId = this.phones[index].phoneTypeId;

    this.phones.forEach(e => {
      if (e.phoneTypeId === typeId) {
        e.isPreferred = false;
      }
    });

    this.phones[index].isPreferred = canMakePreferred;
  }

  setStartedPhone(index: number, canMakeStarted: boolean = true) {
    if (!this.phones[index].phoneNumber) {
      this._toastr.error("Please enter a phone number before setting it as started.");
      this.phones[index].isFavourite = false;
      return; // or show a toast
    }

    this.phones.forEach(e => e.isFavourite = false);
    this.phones[index].isFavourite = canMakeStarted;
  }

  get phoneTypeCounts(): Record<number, number> {
    return this.phones.reduce((acc, e) => {
      acc[e.phoneTypeId] = (acc[e.phoneTypeId] || 0) + 1;
      return acc;
    }, {} as Record<number, number>);
  }

  getMaxAllowedPhones(): number {
    return this.phoneTypes?.length * this.maxPhonesPerType;
  }

  isPhoneTypeDisabled(item: any): boolean {
    if (!item) return false;

    const count = this.phoneTypeCounts[item.phoneTypeId] || 0;

    // Allow the currently selected value
    return (
      count >= this.maxEmailsPerType &&
      item.phoneTypeId !== this.rowBeingEditedPhoneTypeId
    );
  }
  
  getPhoneTypeCounts(): Record<number, number> {
    return this.phones.reduce((acc, phone) => {
      acc[phone.phoneTypeId] = (acc[phone.phoneTypeId] || 0) + 1;
      return acc;
    }, {} as Record<number, number>);
  }

  getNextAvailablePhoneTypeId(): number | null {
    const counts = this.getPhoneTypeCounts();

    const available = this.phoneTypes.find(t =>
      (counts[t.phoneTypeId] || 0) < 5
    );

    return available ? available.phoneTypeId : null;
  }

  onDropdownOpenPhone(row: any) {
    this.rowBeingEditedPhoneTypeId = row.phoneTypeId;
  }

  AddEmail1() {
    if (this.workEmailCount2 < 3) { this.workEmailCount2 = this.workEmailCount2 + 1 }
  }

  AddPhone1() {
    if (this.homePhoneCount2 < 3) { this.homePhoneCount2 = this.homePhoneCount2 + 1; }
  }

  starValueone() {
    this.emailbookmark1 = true;
    this.emailbookmark2 = false;
    this.emailbookmark3 = false;
  }

  starValuetwo() {
    this.emailbookmark1 = false;
    this.emailbookmark2 = true;
    this.emailbookmark3 = false;
  }

  starValueThree() {
    this.emailbookmark1 = false;
    this.emailbookmark2 = false;
    this.emailbookmark3 = true;
  }

  starValuefour() {
    this.emailbookmark4 = true;
    this.emailbookmark5 = false;
    this.emailbookmark6 = false;
  }

  starValuefive() {
    this.emailbookmark4 = false;
    this.emailbookmark5 = true;
    this.emailbookmark6 = false;
  }

  starValuesix() {
    this.emailbookmark4 = false;
    this.emailbookmark5 = false;
    this.emailbookmark6 = true;
  }

  starPhoneAddOneValue() {
    this.phonebookmark1 = true;
    this.phonebookmark2 = false;
    this.phonebookmark3 = false;
  }

  checkValidationForContact() {
    if (this.phonestring1.length == 10) {
      this._phone1Validator = false;
    }
    else {
      this._phone1Validator = true;
    }
  }

  public checkemailChange: boolean = false;
  checkValidationForEmail() {
    this.checkemailChange = false;
    if (this.ValidateEmail(this.emailstring1) || (this.emailstring1 == "" || this.emailstring1 == undefined)) {
      this.checkemailChange = false;
    }
    else {
      this.checkemailChange = true;
    }
  }

  starPhoneAddOfourValue() {
    this.phonebookmark4 = true;
    this.phonebookmark5 = false;
    this.phonebookmark6 = false;
  }

  starPhoneAddfiveValue() {
    this.phonebookmark4 = false;
    this.phonebookmark5 = true;
    this.phonebookmark6 = false;
  }

  starPhoneAdsixValue() {
    this.phonebookmark4 = false;
    this.phonebookmark5 = false;
    this.phonebookmark6 = true;
  }

  RemoveEmailsix() {
    this.emailoption6 = undefined;
    this.emailstring6 = '';
    this.emailbookmark6 = false;
    this.workEmailCount2 = this.workEmailCount2 - 1;
  }

  RemoveEmailfive() {
    if (this.workEmailCount2 == 3) {
      this.emailoption5 = this.emailoption6;
      this.emailstring5 = this.emailstring6;
      this.emailbookmark5 = this.emailbookmark6;
      this.emailoption6 = undefined;
      this.emailstring6 = '';
      this.emailbookmark6 = false;
    } else if (this.workEmailCount2 == 2) {

      this.emailoption5 = undefined;
      this.emailstring5 = '';
      this.emailbookmark5 = false;
    }
    this.workEmailCount2 = this.workEmailCount2 - 1;
  }

  Removephonesix() {
    this.phoneoption6 = undefined;
    this.phonestring6 = '';
    this.phonebookmark6 = false;
    this.homePhoneCount2 = this.homePhoneCount2 - 1;
  }

  Removephonefive() {
    if (this.homePhoneCount2 == 3) {
      this.phoneoption5 = this.phoneoption6;
      this.phonestring5 = this.phonestring6;
      this.phonebookmark5 = this.phonebookmark6;
      this.phoneoption6 = undefined;
      this.phonestring6 = '';
      this.phonebookmark6 = false;
    }
    else if (this.homePhoneCount2 == 2) {

      this.phoneoption5 = undefined;
      this.phonestring5 = '';
      this.phonebookmark5 = false;
    }
    this.homePhoneCount2 = this.homePhoneCount2 - 1;
  }

  checkOnchangefield() {
    this.changeField = true;
  }

  cancelPopup(inputform: NgForm) {
    if (this.changeField || this.clientDataModal.clientId > 0) {
      this.modalRef = this.modalService.show(KcWarningPopupComponent, {
        class: 'modal-dialog-centered',
        backdrop: 'static',
        initialState: {
          mainContent: "All unsaved data will be lost.",
          isSaveAndCloseReq: true
        }
      });
      this.modalRef.content.event.subscribe(res => {
        if (res === this.warningPopupRes.YES) {
          this.changeField = false;
          this.clean(inputform);
          this.closeCreateclientPopup.emit()
        }
        else if (res == this.warningPopupRes.SAVE_AND_CONTINUE) {
          this.UpdateButtonClicked();
          this.modalRef?.hide();
          let element: HTMLElement = document.getElementById('buttontext1') as HTMLElement;
          element.click();
        }
        this.modalRef?.hide();
      })
    } else {
      this.changeField = false;
      this.clean(inputform);
      this.closeCreateclientPopup.emit();
    }
  }

  public makebuttondisable = false;
  clicktoDisable() {
    this._recentclientCode = this.clientDataModal.clientCode;
    if (!this.makebuttondisable) {
      this.makebuttondisable = true;
    }
  }

  public emailString: any;
  public phoneString: any;
  public checkbypassValidation: boolean = false;
  public allEmailsNotEmpty: boolean = false;
  saveClienttInfo(inputform: NgForm, IsSaveAndNext: boolean) {
    this.updateClientCodeValidation();
    this.setNormalizedMailingName();
    /* CUST-4894, Dev: Parth, 09-Sep-2024 - if form is invalid return immediately */
    if (inputform?.form?.invalid) {
      inputform.form.markAllAsTouched();
      this.commonService.focus_invalid_form_field(inputform.form, this.el);
      return;
    }
    if(!this.clientDataModal?.mailingName) { return; }
    const invalidDatePickers = (this.datePickers || []).filter(dp => dp?.invalid);
    if (invalidDatePickers?.length > 0) { return; }
    if (!this.ValidateLinked) {
      return;
    }
    this.emailString = "";
    this.phoneString = "";
    this.missingAddressString = "";
    this.missingAddresses = this.addressSets.filter(address =>
      address.addressPoolId === undefined && address.addressTypeId !== undefined
    );

    if (!this.validationReturnCheck()) {
      if (!this.validationReturnCheck() || this.missingAddresses.length > 0) {
        this.allEmailsNotEmpty = this.emails.every(e => !e.emailId || e.emailId.trim() === '');
        this.allPhonesNotEmpty = this.phones.every(e => !e.phoneNumber || e.phoneNumber.trim() === '');
        const phoneNumberValidationFailed = this.phones.some(p => p.phoneNumber && !p.isValidPhone);
        if (this.emails.length < 0 || this.allEmailsNotEmpty || this.phones.length < 0 || this.allPhonesNotEmpty || this.missingAddresses.length > 0 || phoneNumberValidationFailed) {
          if (this.allEmailsNotEmpty) {
            this.emailString = " <b>Email</b>";
          }
          if (this.allPhonesNotEmpty) {
            this.phoneString = " <b>Phone</b>";
          }
          if(phoneNumberValidationFailed) {
            this._toastr.error("Please correct the invalid phone numbers before proceeding.");
            return;
          }
          if (this.missingAddresses.length > 0) {
            this.missingAddressString = " <b>Address</b>"
          }

          let missingFields = [];
          if (this.emailString !== "") missingFields.push(this.emailString);
          if (this.phoneString !== "") missingFields.push(this.phoneString);
          if (this.missingAddressString !== "") missingFields.push(this.missingAddressString);

          if (missingFields.length === 0) {
            this.validationMessage = '';
          } else if (missingFields.length === 1) {
            this.validationMessage = missingFields[0];
          } else {
            this.validationMessage = missingFields.slice(0, -1).join(', ') + ' and ' + missingFields[missingFields.length - 1];
          }
          this.modalRef = this.modalService.show(KcWarningPopupComponent, {
            class: 'modal-dialog-centered',
            backdrop: 'static',
            initialState: {
              mainContent: "You are about to " + this.buttontext.toLocaleLowerCase() + " a client without" + this.validationMessage + ".",
              isSaveAndCloseReq: false
            }
          });
          this.modalRef.content.event.subscribe(res => {
            if (res === this.warningPopupRes.YES) {
              if (!this.makebuttondisable) {
                this.currentPage = this.currentPage + 1;
              }
              this.changeField = false;
              this.modalRef?.hide();
              this.checkbypassValidation = true;
              this.addingClientdetails(inputform, IsSaveAndNext);
            }
            if (res === this.warningPopupRes.NO) {
              if (this.makebuttondisable) {
                this.makebuttondisable = false;
              }
              this.allEmailsNotEmpty = false;
              this.allPhonesNotEmpty = false;
              this.checkChangePage = false;
              this.checkbypassValidation = false;
              this.modalRef?.hide();
            }
          })
        } else {
          this.addingClientdetails(inputform, IsSaveAndNext);
        }
      } else {
        this.addingClientdetails(inputform, IsSaveAndNext);
      }
    } else {
      this.addingClientdetails(inputform, IsSaveAndNext);
    }
  }

  isValidEmail(email: string): boolean {
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return regex.test(email);
  }

  onEmailBlur(index: number,row: any): void {
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    row.isValid = regex.test(row.emailId)
    row.touched = true;
    this.setEmailPreferredAndImportant(index, row.emailId);
    this.updateFavouriteEmail();
  }

  isValidPhoneNumber(phone: string): boolean {
    const regex = /^[0-9]{10}$/; // Assuming a 10-digit phone number format
    return regex.test(phone);
  }

  onPhoneBlur(index: number,row: any): void {
    row.touched = true;
    this.onPhoneValidation(index, row);
  }

  onPhoneValidation(index: number, row: any): void {
    if (!row.phoneNumber || !row.countryRegionCode) {
      row.isPreferred = false;
      row.isFavourite = false;
      if(row.isFavourite) {
        this.phones[index+1].isFavourite = true;
      }
      if(row.isPreferred) {
        const nextPreferred = this.phones.find(
          (p, i) =>
            i !== index &&
            p.phoneTypeId === row.phoneTypeId &&
            p.phoneNumber
        );

        // Make another one preferred
        if (nextPreferred) {
          nextPreferred.isPreferred = true;
        }
      }
      return;
    }

    const region = row.countryRegionCode;

    try {
      const parsed = this.googleUtil.parseAndKeepRawInput(row.phoneNumber, region);

      const isValid = this.googleUtil.isValidNumberForRegion(parsed, region);

      if (isValid) {
        // ✅ Format and update input
        row.phoneNumber = this.googleUtil.format(
          parsed
        );

        row.isValidPhone = true;
        row.statusText = 'Valid phone number for region ' + row.countryName;
        this.setPhonePreferredAndImportant(index, row.phoneNumber);
        this.updateFavouritePhone();
      } else {
        row.touched = true;
        row.isValidPhone = false;
        row.statusText = 'Invalid phone for region ' + row.countryName;
        row.isPreferred = false;
        row.isFavourite = false;
      }

    } catch (error) {
      row.touched = true;
      row.isValidPhone = false;
      row.statusText = 'Invalid phone for region ' + row.countryName
    }
  }

  setNormalizedMailingName() {
    this.clientDataModal.mailingName = getNormalizedMultilineText(this.clientDataModal?.mailingName);
  }

  /**
   * This method is used to set the date format of client Date of birth, date of death, formation date & deRegistration date
   * client start & end date
   */
  setClientDates() {
    this.clientDataModal.dateofbirth = getFormattedDateWithTimeZone(this.clientDataModal?.dateofbirth);
    this.clientDataModal.dateOfDeath = getFormattedDateWithTimeZone(this.clientDataModal?.dateOfDeath);
    this.clientDataModal.formationDate = getFormattedDateWithTimeZone(this.clientDataModal?.formationDate);
    this.clientDataModal.deRegistrationDate = getFormattedDateWithTimeZone(this.clientDataModal?.deRegistrationDate);
    this.clientDataModal.clientStartDate = getFormattedDateWithTimeZone(this.clientDataModal?.clientStartDate);
    this.clientDataModal.clientEndDate = getFormattedDateWithTimeZone(this.clientDataModal?.clientEndDate);
  }

  setNormalizedNames() {
    this.clientDataModal.firstname = getNormalizedName(this.clientDataModal?.firstname);
    this.clientDataModal.middlename = this.clientDataModal?.middlename ? getNormalizedName(this.clientDataModal?.middlename) : null;
    this.clientDataModal.lastname = getNormalizedName(this.clientDataModal?.lastname);
  }

  public _recentclientCode = ''; public _count = 0;
  public missingAddresses: any;
  addingClientdetails(inputform: NgForm, IsSaveAndNext: boolean) {
    if (this._abnValidateStatus || this._tfnValidateStatus || this._dinValidateStatus || this.taxValidation() || this._isABNExist || this._isACNExist) {
      return;
    }
    if (this.TFNMessage != '') {
      return;
    }
    this.currentForm = this.getFormSnapshotForChangeDetection();
    this.addressSets.forEach(address => {
      delete address.addressInput$;
    })

    if (this.tabOne || this.tabTwo || (this.tabOne && this.tabTwo)) {
      this.currentAddress = this.commonService.copyObject(this.addressSets);
      this.isAddressChanged = !_.isEqual(this.loadedAddress, this.currentAddress);
      this.addressSets.forEach((address, index) => {
        if (!address.isDeleted) {
          address.addressInput$ = new Subject<string>();
          this.sub.add(address.addressInput$.pipe(
            debounceTime(500),
            distinctUntilChanged(),
            filter(term => term.length >= 3),
            switchMap(term => this.fetchAddresses(term))
          ).subscribe((addresses: any[]) => {
            this.addressSetsContact[index].fullAddressList = addresses;
          }));
        }

      })
    }
    this.isChanged = !_.isEqual(this.loadedForm, this.currentForm);

    if (this.makebuttondisable) {
      this.checkCreateClient = true;
      if (this.currentPage == 2) {
        this.btnId = "";
      }
      if (localStorage.getItem('token') == null) { this._toastr.error("Your session has expired"); this.router.navigate(['/']); }
      if (inputform.form.invalid) {
        const firstInvalidControl: HTMLElement = this.el.nativeElement.querySelector("form .ng-invalid");
        firstInvalidControl.focus();
      }
      
      this._count += 1;
      if (this._count > 3) {
        this.checkbypassValidation = false;
        return;
      }

      this.Obj_email = [...this.emails];

      // Email Id's Dupe check
      const emailKeyMap: { [key: string]: number } = {};

      this.Obj_email = this.Obj_email.filter(item => item.emailId?.trim());

      const hasInvalid = this._clientService.emailNotEmptyAndValid(this.Obj_email);

      if (hasInvalid) {
        this._toastr.error('Email Id is not valid, please re-evaluate');
        if (this.currentPage === 1) {
          this.currentPage = 0;
        }
        return;
      }

      this.Obj_email.forEach(item => {
        const key = `${item.emailTypeId}-${item.emailId.trim().toLowerCase()}`;
        emailKeyMap[key] = (emailKeyMap[key] || 0) + 1;
      });

      const duplicateEmailEntries = Object.keys(emailKeyMap)
        .filter(key => emailKeyMap[key] > 1);

      if (duplicateEmailEntries.length > 0) {
        this._toastr.error(
          'Email Id already exists, please revaluate',
          'Create/Update Client'
        );
        return;
      }

      const normalizePhone = (phone: string | null | undefined): string =>
      (phone ?? '').replace(/\D/g, '');

      let newPhones = this.phones.map(item => ({
        phoneTypeId: item.phoneTypeId,
        phoneNumber: normalizePhone(item.phoneNumber),
        isPreferred: item.isPreferred,
        isFavourite: item.isFavourite,
        countryId: item.countryId,
        isdCode: this.normalizeIsdCode(item.isdCode)
      }));
      this.obJ_phone = [...newPhones];

      this.obJ_phone = this.obJ_phone.filter(item => item.phoneNumber);

      if(this.obJ_phone.length > 0) {
        this.obJ_phone = [...this.obJ_phone].map(item => ({
          ...item,
          countryId: String(item.countryId),
          countryName: this.contactcountries.find(c => String(c.countryId) === String(item.countryId))?.name || '',
          isValidPhone: this.checkPhoneValidOrNot(item)
        }));
      }

      const hasInvalidPhone = this._clientService.phoneNotEmptyAndValid(this.obJ_phone);

      if (hasInvalidPhone) {
        this._toastr.error('Phone number is not valid, please re-evaluate');
        if (this.currentPage === 1) {
          this.currentPage = 0;
        }
        return;
      }

      // Mobile Numbers Dupe check
      const phoneCountMap: { [key: string]: number } = {};
      this.obJ_phone.forEach(item => {
        const key = `${item.phoneTypeId}-${normalizePhone(item.phoneNumber)}`;
        phoneCountMap[key] = (phoneCountMap[key] || 0) + 1;
      });

      const duplicatePhonesEntries = Object.keys(phoneCountMap).filter(phone => phoneCountMap[phone] > 1);

      if (duplicatePhonesEntries && duplicatePhonesEntries.length > 0) {
        this._toastr.error("Phone number already exists, please revaluate", 'Update client');
        return;
      }

      if (this.contactTable != null && this.contactTable != undefined) {
        this.clientDataModal.contactIds = JSON.stringify(this.contactTable);
      }

      this.clientDataModal.physicalstate = this.clientDataModal.physicalstate != undefined || this.clientDataModal.physicalstate != null ? this.clientDataModal.physicalstate.toString() : null;
      if (this.clientDataModal.isSamePhysical) {
        this.clientDataModal.postaladdressline1 = this.clientDataModal.physicaladdressline1;
        this.clientDataModal.postaladdressline2 = this.clientDataModal.physicaladdressline2;
        this.clientDataModal.postalcountry = this.clientDataModal.physicalcountry;
        this.clientDataModal.postalcountry = this.clientDataModal.postalcountry != undefined || this.clientDataModal.postalcountry != null ? this.clientDataModal.postalcountry.toString() : null;

        if (this.clientDataModal.physicalcountry != undefined)
          this.onChangeContactCountry1(this.clientDataModal.physicalcountry);
        if (this.clientDataModal.physicalstate != null) {
          this.clientDataModal.postalstate = this.clientDataModal.physicalstate.toString();
        }
        this.clientDataModal.postalsuburb = this.clientDataModal.physicalsuburb;
        if (this.clientDataModal.physicalpostcode != undefined && this.clientDataModal.physicalpostcode != null)
          this.clientDataModal.postalpostcode = '' + this.clientDataModal.physicalpostcode;
      }

      if (this.clientDataModal.physicalpostcode != undefined && this.clientDataModal.physicalpostcode != null)
        this.clientDataModal.physicalpostcode = '' + this.clientDataModal.physicalpostcode;
      if (this.clientDataModal.postalpostcode != undefined && this.clientDataModal.postalpostcode != null)
        this.clientDataModal.postalpostcode = '' + this.clientDataModal.postalpostcode;

      this.clientDataModal.entityTypeId = Number(this.clientDataModal.entityTypeId);
      this.clientDataModal.ccontactType = Number(this.clientDataModal.ccontactType);
      this.clientDataModal.emailaddress = JSON.stringify(this.Obj_email);
      this.clientDataModal.phonenumber = JSON.stringify(this.obJ_phone);

      this.addressSets = this.addressSets.filter(address =>
        !(address.addressPoolId === undefined && address.addressTypeId !== undefined)
      );
      
      // before preparing payload, sanitize all careof values so saved model never contains "C/-"
      this.addressSets.forEach(address => {
        address.careof = this.sanitizeCareOf(address.careof);
      });
      
      this.clientDataModal.addressPoolClientMapping = this.addressSets.map(obj => {
        const { addressInput$, fullAddressList, ...clients } = obj;
        return clients;
      });;

      if (this.deletedAddressSets.length > 0) {
        this.deletedAddressSets = this.deletedAddressSets.filter(item => item.addressPoolMappingId !== 0);
        this.clientDataModal.addressPoolClientMapping.push(...this.deletedAddressSets);
      }
      this.clientDataModal.contactId = 0;
      if (this.clientDataModal.partnerId == undefined)
        this.clientDataModal.partnerId = null;
      if (this.clientDataModal.managerId == undefined)
        this.clientDataModal.managerId = null;
      if (this.clientDataModal.teamId == undefined)
        this.clientDataModal.teamId = null;
      if (this.clientDataModal.addressPoolClientMapping == undefined)
        this.clientDataModal.addressPoolClientMapping = null;
      if (this.clientDataModal.divisionId == undefined && this.clientDataModal.divisionId == null)
        this.clientDataModal.divisionId = 0;
      else
        this.clientDataModal.divisionId = Number(this.clientDataModal.divisionId);

      this.clientDataModal.officeId = this.officeData?.selectedOfficeId || null;
      this.setClientDates();

      if (this.IseditClient) {
        if (this.clientDataModal.cdateOfBirth != null) {
          this.clientDataModal.cdateOfBirth = this.clientDataModal.cdateOfBirth.toString('dd/MM/yyyy');
          let dob = this.clientDataModal.cdateOfBirth.split('/');
          let datestr = dob[2] + '-' + dob[1] + '-' + dob[0];
          this.clientDataModal.cdateOfBirth = new Date(datestr);
        }
        else
          this.clientDataModal.cdateOfBirth = undefined;
        this.clientDataModal.cphysicalcountry = (this.clientDataModal.cphysicalcountry != undefined ? this.clientDataModal.cphysicalcountry : null);
        this.clientDataModal.gender = (this.clientDataModal.gender != undefined ? this.clientDataModal.gender : null);
        this.clientDataModal.physicalstate = (this.clientDataModal.physicalstate != undefined ? this.clientDataModal.physicalstate.toString() : null);
        this.clientDataModal.title = (this.clientDataModal.title != undefined ? this.clientDataModal.title : null);
        this.clientDataModal.softwareType = (this.clientDataModal.softwareType != undefined ? this.clientDataModal.softwareType : null);
        this.clientDataModal.trustType = (this.clientDataModal.trustType != undefined ? this.clientDataModal.trustType : null);


        if (this.clientDataModal.taxAgent == undefined)
          this.clientDataModal.taxAgent = null;
        if (this.clientDataModal.annualReviewDate == '' || this.clientDataModal.annualReviewDate == null)
          this.clientDataModal.annualReviewDate = undefined;
        else {
          this.clientDataModal.annualReviewDate = this.clientDataModal.annualReviewDate.toString('dd/MM/yyyy');
          let dob = this.clientDataModal.annualReviewDate.split('/');
          let datestr = dob[2] + '-' + dob[1] + '-' + dob[0];
          this.clientDataModal.annualReviewDate = new Date(datestr);
        }
      }
      if (this.clientDataModal.dateofbirth) {
        this.clientDataModal.strdateofbirth = this.datePipe.transform(this.clientDataModal.dateofbirth, 'yyyy/MM/dd');
      }


      this.getRandomBgTextColor();


      let cfdata = [];
      for (let i in this.cfqcitem) {
        if (this.cfqcitem[i].fieldType == 'Date' && this.cfqcitem[i].value != 'Invalid Date' && this.cfqcitem[i].value != null)
          this.cfqcitem[i].value = this.datePipe.transform(this.cfqcitem[i].value, 'MM/dd/yyyy');
        if (this.cfqcitem[i].fieldType == 'Number' && this.cfqcitem[i].value != '' && this.cfqcitem[i].value != null)
          this.cfqcitem[i].value = this.cfqcitem[i].value.toString();
        if (this.cfqcitem[i].fieldType == 'Checkbox')
          this.cfqcitem[i].value = this.cfqcitem[i].customFieldValues;
        if (this.cfqcitem[i].fieldType == 'User')
          if (this.cfqcitem[i].value != "") {
            const val = this.cfqcitem[i].value;
            if (Array.isArray(val)) {
              this.cfqcitem[i].value = val.map(x => x.id).toString();
            } else if (typeof val === 'object' && val.id) {
              this.cfqcitem[i].value = val.id;
            } else {
              this.cfqcitem[i].value = val.toString();
            }
          }

        if (this.cfqcitem[i].value != null) {

          cfdata.push({ Id: this.cfqcitem[i].id, value: this.cfqcitem[i].value })
        }

        if (this.cfqcitem[i].fieldType == 'Date' && this.cfqcitem[i].value != 'Invalid Date' && this.cfqcitem[i].value != null) {
          this.cfqcitem[i].value = null
        }
      }

      if (cfdata.length > 0)
        this.clientDataModal.customfieldsData = JSON.stringify(cfdata);

      let cfcontactdata = [];
      for (let i in this.cfqlconitem) {
        if (this.cfqlconitem[i].fieldType == 'Date' && this.cfqlconitem[i].value != 'Invalid Date' && this.cfqlconitem[i].value != null)
          this.cfqlconitem[i].value = this.datePipe.transform(this.cfqlconitem[i].value, 'MM/dd/yyyy');
        if (this.cfqlconitem[i].fieldType == 'Number' && this.cfqlconitem[i].value != '' && this.cfqlconitem[i].value != null)
          this.cfqlconitem[i].value = this.cfqlconitem[i].value.toString();
        if (this.cfqlconitem[i].fieldType == 'Checkbox')
          this.cfqlconitem[i].value = this.cfqlconitem[i].customFieldValues;
        if (this.cfqlconitem[i].fieldType == 'User')
          this.cfqlconitem[i].value = this.cfqlconitem[i].value.map(x => x.id).toString();
        if (this.cfqlconitem[i].fieldType == 'Dropdown List')
          this.cfqlconitem[i].value = this.cfqlconitem[i]?.value?.toString() ?? '0';
        if (this.cfqlconitem[i].value != null) {
          if (this.cfqlconitem[i].value.length > 0)
            cfcontactdata.push({ Id: this.cfqlconitem[i].id, value: this.cfqlconitem[i].value })
        }
      }
      this.clientDataModal.physicalcountry = this.clientDataModal.physicalcountry != undefined || this.clientDataModal.physicalcountry != null ? this.clientDataModal.physicalcountry.toString() : null;

      if (cfcontactdata.length > 0)
        this.clientDataModal.concustomfieldsData = JSON.stringify(cfcontactdata);

      if (this.clientDataModal.annualReviewDate != '' || this.clientDataModal.annualReviewDate != null) { this.clientDataModal.strannualReviewDate = this.datePipe.transform(this.clientDataModal.annualReviewDate, 'yyyy/MM/dd'); }
      if (this.clientDataModal.formationDate != '' || this.clientDataModal.formationDate != null) { this.clientDataModal.strformationDate = this.datePipe.transform(this.clientDataModal.formationDate, 'yyyy/MM/dd'); }

      this.setNormalizedNames();

      let client = this.clientDataModal;
      this.setClientTagsPayload();
      if (this.clientDataModal.formationDate == "" || this.clientDataModal.formationDate == null) {
        delete client.formationDate;
      } if (this.clientDataModal.annualReviewDate == "" || this.clientDataModal.annualReviewDate == null) {
        delete client.annualReviewDate;
      }
      this.changeField = false;
      if (this.clientDataModal.postalstate == undefined || this.clientDataModal.postalstate == '') { this.clientDataModal.postalstate = null; }
      else {
        this.clientDataModal.postalstate = this.clientDataModal.postalstate.toString();
      }
      let tempPhyState = this.cstatelist.filter((item) => item.stateId == this.clientDataModal.physicalstate);
      let tempPhyCountry = this.countries.filter((item) => item.countryId == this.clientDataModal.physicalcountry);
      const newPhysicalAddress = new CmAddress()
      newPhysicalAddress.addressId = this.originalPhysicalAddress.addressId;
      newPhysicalAddress.addressline1 = this.clientDataModal.physicaladdressline1 || '';
      newPhysicalAddress.addressline2 = this.clientDataModal.physicaladdressline2 || '';
      newPhysicalAddress.suburb = this.clientDataModal.physicalsuburb || '';
      newPhysicalAddress.state = this.clientDataModal.physicalstate || '';
      newPhysicalAddress.postcode = this.clientDataModal.physicalpostcode || '';
      newPhysicalAddress.country = this.clientDataModal.physicalcountry || '';
      if (tempPhyState.length != 0)
        newPhysicalAddress.stateName = tempPhyState[0].name || '';
      if (tempPhyCountry.length != 0)
        newPhysicalAddress.countryName = tempPhyCountry[0].name || '';

      let tempPostalState;
      if (this.clientDataModal.isSamePhysical) {
        tempPostalState = this.cstatelist.filter((item) => item.stateId == this.clientDataModal.postalstate);
      } else {
        tempPostalState = this.contactstates1.filter((item) => item.stateId == this.clientDataModal.postalstate);
      }

      let tempPostalCountry = this.countries.filter((item) => item.countryId == this.clientDataModal.postalcountry);
      const newPostalAddress = new CmAddress()
      newPostalAddress.addressId = this.originalPostalAddress.addressId;
      newPostalAddress.addressline1 = this.clientDataModal.postaladdressline1 || '';
      newPostalAddress.addressline2 = this.clientDataModal.postaladdressline2 || '';
      newPostalAddress.suburb = this.clientDataModal.postalsuburb || '';
      newPostalAddress.state = this.clientDataModal.postalstate || '';
      newPostalAddress.postcode = this.clientDataModal.postalpostcode || '';
      newPostalAddress.country = this.clientDataModal.postalcountry || '';
      let oldPhysicalAddressId = 0;
      let newPhysicalAddressId = 0;
      let physicalAddressChange = false;
      let oldPhysicalAddressCareOf = "";
      let newPhysicalAddressCareOf = "";
      let oldPhysicalAddressLine = "";
      let newPhysicalAddressLine = "";
      if (this.buttontext !== 'Create') {
        oldPhysicalAddressId = this.deletedAddressSets?.find(item => (item?.addressTypeId === 1 && item?.isDeleted === true))?.addressPoolId ?? 0;
        newPhysicalAddressId = this.addressSets?.find(item => (item?.addressTypeId === 1 && item?.isDeleted === false))?.addressPoolId ?? 0;
        oldPhysicalAddressCareOf = this.deletedAddressSets?.find(item => (item?.addressTypeId === 1 && item?.isDeleted === true))?.careof ?? "";
        newPhysicalAddressCareOf = this.addressSets?.find(item => (item?.addressTypeId === 1 && item?.isDeleted === false))?.careof ?? "";
        oldPhysicalAddressLine = this.deletedAddressSets?.find(item => item?.addressPoolId === oldPhysicalAddressId)?.fullAddressList?.find(add => add?.addressPoolId === oldPhysicalAddressId)?.addressLine ?? "";
        newPhysicalAddressLine = this.addressSets?.find(item => item?.addressPoolId === newPhysicalAddressId)?.fullAddressList?.find(add => add?.addressPoolId === newPhysicalAddressId)?.addressLine ?? "";
        if ((oldPhysicalAddressId !== newPhysicalAddressId) && (this.addressSets?.find(item => item?.addressPoolId === newPhysicalAddressId)?.addressPoolMappingId === 0)) {
          physicalAddressChange = true;
        }
      }

      let oldPostalAddressId = 0;
      let newPostalAddressId = 0;
      let postalAddressChange = false;
      let oldPostalAddressCareOf = "";
      let newPostalAddressCareOf = "";
      let oldPostalAddressLine = "";
      let newPostalAddressLine = "";
      if (this.buttontext !== 'Create') {
        oldPostalAddressId = this.deletedAddressSets?.find(item => (item?.addressTypeId === 2 && item?.isDeleted === true))?.addressPoolId ?? 0;
        newPostalAddressId = this.addressSets?.find(item => (item?.addressTypeId === 2 && item?.isDeleted === false))?.addressPoolId ?? 0;
        oldPostalAddressCareOf = this.deletedAddressSets?.find(item => (item?.addressTypeId === 2 && item?.isDeleted === true))?.careof ?? "";
        newPostalAddressCareOf = this.addressSets?.find(item => (item?.addressTypeId === 2 && item?.isDeleted === false))?.careof ?? "";
        oldPostalAddressLine = this.deletedAddressSets?.find(item => item?.addressPoolId === oldPostalAddressId)?.fullAddressList?.find(add => add?.addressPoolId === oldPostalAddressId)?.addressLine ?? "";
        newPostalAddressLine = this.addressSets?.find(item => item?.addressPoolId === newPostalAddressId)?.fullAddressList?.find(add => add?.addressPoolId === newPostalAddressId)?.addressLine ?? "";
        if ((oldPostalAddressId !== newPostalAddressId) && (this.addressSets?.find(item => item?.addressPoolId === newPostalAddressId)?.addressPoolMappingId === 0)) {
          postalAddressChange = true;
        }
      }

      this.changedNewPhyAddress = newPhysicalAddressLine;
      this.newPhyAddressId = newPhysicalAddressId;
      this.newPhyAddresscareOf = newPhysicalAddressCareOf;

      if (physicalAddressChange || postalAddressChange) {
        let tempAddress = {
          clientOrContactId: this.clientDataModal.clientId,
          addressType: physicalAddressChange ? "Physical" : "postal",
          oldAddressPoolId: physicalAddressChange ? oldPhysicalAddressId : oldPostalAddressId,
          newAddressPoolId: physicalAddressChange ? newPhysicalAddressId : newPostalAddressId,
          entityType: "Client"
        }
        this._clientService.notifyAddressChange(tempAddress).subscribe((response: any) => {
        }, error => {
        })
      }
      const canEditBpay =
        this.bpayAlgorithm === 11 && this.isManageBillerReference;

      if (!this.IseditClient) {

        client.bPayReference = canEditBpay
          ? this.clientDataModal.bPayReference
          : null;
      } else {

        if (canEditBpay) {
          client.bPayReference = this.clientDataModal.bPayReference;
        } 
      }
      client.isManageBillerReference = this.isManageBillerReference;
      client.bPayAlgorithm = this.bpayAlgorithm;
      client.oldBpayReference = this.clientDataModal.oldBpayReference;
      if (this.IseditClient && !IsSaveAndNext) {
        this.handleBulkEmailBeforeSave(client, inputform, IsSaveAndNext, physicalAddressChange);
      } else {
        this._clientService.AddEditCliententity(client, this.clientGridType,this.clientGridDynamicCols, this.clientGridIsCustomFields).subscribe({
          next: (result) => {
          let _xeroFlag;
          let AccountFirmId = localStorage.getItem("AccountFirmId");
          if (result?.result?.success) {
            this.stateManagement.updateData(this.stateManagement.getClients, null);
            _xeroFlag = this.IseditClient ? false : true;
            let clientNames = '';
            if (this.clientDataModal.entityTypeId == 2)
              clientNames = this.clientDataModal.companyName;
            else if (this.clientDataModal.entityTypeId == 3)
              clientNames = this.clientDataModal.trustName;
            else if (this.clientDataModal.entityTypeId == 4)
              clientNames = this.clientDataModal.partnershipname;
            else if (this.clientDataModal.entityTypeId == 5)
              clientNames = this.clientDataModal.smsfName;
            else {
              if (this.clientDataModal.firstname != undefined && this.clientDataModal.lastname != undefined)
                clientNames = this.clientDataModal?.firstname?.trim() + " " + this.clientDataModal?.lastname?.trim();
            }
            let message = this.clientDataModal.clientCode + " " + clientNames;
            if (_xeroFlag && result?.result?.operationStatuses[0].uniqueKey) { client.clientId = result?.result?.operationStatuses[0].uniqueKey; }
            let redirectURL = window.location.origin + '/client/contact?clientId=' + client.clientId

            let clientCategory = {};
            if (this.IseditClient) {
              clientCategory = {
                'Name': clientNames?.trim(),
                'Description': clientNames?.trim(),
                'ClientId': client.clientId,
                'OldClientName': this.clientOldName?.trim(),
                'AccountingFirmId': AccountFirmId,
                'ClientCode': client.clientCode?.trim()
              };
              const isSharePoint = localStorage.getItem('DMSProviderType') === 'SharePoint';
              const request = isSharePoint
                ? this.azureService.UpdateClientFolder(clientCategory)
                : this.categoryService.CategoryUpdateClient(clientCategory)
              request.subscribe(result => {

              });
              if (this.isChanged || this.isAddressChanged) {
                this._toastr.success('<a href=\"' + redirectURL + '\" class=\"toastr-link\">' + message + '</a> updated successfully.', 'Update client', { enableHtml: true, closeButton: true, timeOut: 10000 });
              }
              this.isAddressChanged = false;
              if (this.isClickedOnUpdate) {
                this.makebuttondisable = false;
                this.getclientlistload.emit({response: result?.client[0]});
                this.closeCreateclientPopup.emit();
              }
              if (physicalAddressChange) {
                this.getClientVerifiedRelationships();
              }
            }
            else {
              this.checkbypassValidation = false;
              clientCategory = {
                'Name': clientNames.trim(),
                'Description': clientNames.trim(),
                'ClientId': client.clientId,
                'AccountingFirmId': AccountFirmId,
                'ClientCode': client.clientCode.trim()
              };
              let isSharePoint = localStorage.getItem('DMSProviderType') === 'SharePoint';
              const request = isSharePoint
                ? this.azureService.createClientFolder(clientCategory)
                : this.categoryService.CategoryCreateClient(clientCategory)
              request.subscribe(result => {
              });
              this.makebuttondisable = false;

              if (result.result.moreInfo == "Client created in Kloud Connect successfully, but could not create in XPM") {
                this._toastr.error("Client created in Kloud Connect successfully. Could not create in XPM - check connection to XPM", 'Create client');
              }
              else {
                this._toastr.success('<a href=\"' + redirectURL + '\" class=\"toastr-link\">' + message + '</a> added successfully.', 'Create client', { enableHtml: true, closeButton: true, timeOut: 10000 });
              }
              this.clientDataModal.clientId = result.result.operationStatuses[0].uniqueKey;
              this.getclientlistload.emit({response: result?.client[0]});
              this.closeCreateclientPopup.emit();
            }
            if (IsSaveAndNext) { }
            else {
              this.clean(inputform);
              this.sort('created_At');

            }
            this._flagCodeExist = false;
          }
          else if (result.result.message == "Client Exist") {
            this._flagCodeExist = true;
          }
          else {
            this._flagCodeExist = false;
            this._toastr.warning(result.result.message, 'Create client');
          }
          this.makebuttondisable = false;
        }, error: error => {
          this._toastr.error(error.message, 'Create client'); this.makebuttondisable = false;
        }
      });
      }
    }
  }

  clientData: any[] = [];
  getClientVerifiedRelationships() {
    const connectionId = "";
    const connectionType = "NowInfinity";
    this.xeroService.getClientVerifiedRelationships(connectionId, this.tempClientId, connectionType).subscribe(
      (response: any) => {
        if (response) {
          this.clientData = response;
          this.commonService.hideLoader();
          this.openGenerateFormPopup();
        }
      },
      (error) => {
        console.error("Error fetching linked software:", error);
      }
    );
  }

  openGenerateFormPopup() {
    this.modalRef = this.modalService.show(this.generateFormPopupRef, {
      backdrop: 'static',
      class: 'm-auto cmn-modal-dsgn modal-dialog-centered ni-generateform-popup-container',
    });
  }

  addingClientdetailss(inputform: NgForm) {

    if (inputform.form.invalid) {
      return
    }
    if (this.phoneValidation() || this.taxValidation() || !this.validate()) {
      return;
    }
    else {

      this.Obj_email = [...this.emails];

      const emailKeyMap: { [key: string]: number } = {};

      const hasInvalid = this._clientService.emailNotEmptyAndValid(this.Obj_email);

      if (hasInvalid) {
        this._toastr.error('Email Id is not valid, please re-evaluate');
        if (this.currentPage === 1) {
          this.currentPage = 0;
        }
        return;
      }

      this.Obj_email.forEach(item => {
        const key = `${item.emailTypeId}-${item.emailId.trim().toLowerCase()}`;
        emailKeyMap[key] = (emailKeyMap[key] || 0) + 1;
      });

      const duplicateEmailEntries = Object.keys(emailKeyMap)
        .filter(key => emailKeyMap[key] > 1);

      if (duplicateEmailEntries.length > 0) {
        this._toastr.error(
          'Email Id already exists, please revaluate',
          'Create/Update Client'
        );
        return;
      }

    const normalizePhone = (phone: string | null | undefined): string =>
      (phone ?? '').replace(/\D/g, '');

      let newPhones = this.phones.map(item => ({
        phoneTypeId: item.phoneTypeId,
        phoneNumber: normalizePhone(item.phoneNumber),
        isPreferred: item.isPreferred,
        isFavourite: item.isFavourite,
        countryId: item.countryId,
        isdCode: this.normalizeIsdCode(item.isdCode)
      }));

      this.obJ_phone = [...newPhones];

      this.obJ_phone = this.obJ_phone.filter(item => item.phoneNumber);

      if(this.obJ_phone.length > 0) {
        this.obJ_phone = [...this.obJ_phone].map(item => ({
          ...item,
          countryId: String(item.countryId),
          countryName: this.contactcountries.find(c => String(c.countryId) === String(item.countryId))?.name || '',
          isValidPhone: this.checkPhoneValidOrNot(item)
        }));
      }

      const hasInvalidPhone = this._clientService.phoneNotEmptyAndValid(this.obJ_phone);

      if (hasInvalidPhone) {
        this._toastr.error('Phone number is not valid, please re-evaluate');
        if (this.currentPage === 1) {
          this.currentPage = 0;
        }
        return;
      }

      const phoneKeyMap: { [key: string]: number } = {};

      this.obJ_phone.forEach(item => {
        const key = `${item.phoneTypeId}-${normalizePhone(item.phoneNumber)}`;
        phoneKeyMap[key] = (phoneKeyMap[key] || 0) + 1;
      });

      const duplicatePhoneEntries = Object.keys(phoneKeyMap)
        .filter(key => phoneKeyMap[key] > 1);

      if (duplicatePhoneEntries.length > 0) {
        this._toastr.error(
          'Phone Number already exists, please revaluate',
          'Create/Update Client'
        );
        return;
      }

      if (this.contactTable != null && this.contactTable != undefined) {
        this.clientDataModal.contactIds = JSON.stringify(this.contactTable);
      }

      if (this.clientDataModal.isSamePhysical) {
        this.clientDataModal.postaladdressline1 = this.clientDataModal.physicaladdressline1;
        this.clientDataModal.postaladdressline2 = this.clientDataModal.physicaladdressline2;
        this.clientDataModal.postalcountry = this.clientDataModal.physicalcountry;
        if (this.clientDataModal.physicalcountry != undefined)
          this.onChangeContactCountry1(this.clientDataModal.physicalcountry);
        this.clientDataModal.postalstate = this.clientDataModal.physicalstate;
        this.clientDataModal.postalsuburb = this.clientDataModal.physicalsuburb;
        if (this.clientDataModal.physicalpostcode != undefined && this.clientDataModal.physicalpostcode != null)
          this.clientDataModal.postalpostcode = '' + this.clientDataModal.physicalpostcode;
      }

      if (this.clientDataModal.physicalpostcode != undefined && this.clientDataModal.physicalpostcode != null)
        this.clientDataModal.physicalpostcode = '' + this.clientDataModal.physicalpostcode;
      if (this.clientDataModal.postalpostcode != undefined && this.clientDataModal.postalpostcode != null)
        this.clientDataModal.postalpostcode = '' + this.clientDataModal.postalpostcode;

      this.clientDataModal.entityTypeId = Number(this.clientDataModal.entityTypeId);
      this.clientDataModal.ccontactType = Number(this.clientDataModal.ccontactType);
      this.clientDataModal.emailaddress = JSON.stringify(this.Obj_email);
      this.clientDataModal.phonenumber = JSON.stringify(this.obJ_phone);
      this.clientDataModal.contactId = 0;
      if (this.clientDataModal.partnerId == undefined)
        this.clientDataModal.partnerId = null;
      if (this.clientDataModal.managerId == undefined)
        this.clientDataModal.managerId = null;
      if (this.clientDataModal.teamId == undefined)
        this.clientDataModal.teamId = null;
      if (this.clientDataModal.addressPoolClientMapping == undefined)
        this.clientDataModal.addressPoolClientMapping = null;
      if (this.clientDataModal.divisionId == undefined && this.clientDataModal.divisionId == null)
        this.clientDataModal.divisionId = 0;
      else
        this.clientDataModal.divisionId = Number(this.clientDataModal.divisionId);

      this.clientDataModal.officeId = this.officeData?.selectedOfficeId || null;

      if (this.IseditClient) {
        this.clientDataModal.dateofbirth = getFormattedDateWithTimeZone(this.clientDataModal?.dateofbirth);
        this.clientDataModal.dateOfDeath = getFormattedDateWithTimeZone(this.clientDataModal?.dateOfDeath);

        if (this.clientDataModal.cdateOfBirth != null) {
          this.clientDataModal.cdateOfBirth = this.clientDataModal.cdateOfBirth.toString('dd/MM/yyyy');
          let dob = this.clientDataModal.cdateOfBirth.split('/');
          let datestr = dob[2] + '-' + dob[1] + '-' + dob[0];
          this.clientDataModal.cdateOfBirth = new Date(datestr);
        }
        else
          this.clientDataModal.cdateOfBirth = undefined;
        this.clientDataModal.cphysicalcountry = (this.clientDataModal.cphysicalcountry != undefined ? this.clientDataModal.cphysicalcountry : null);
        this.clientDataModal.gender = (this.clientDataModal.gender != undefined ? this.clientDataModal.gender : null);
        this.clientDataModal.physicalstate = (this.clientDataModal.physicalstate != undefined ? this.clientDataModal.physicalstate.toString() : null);
        this.clientDataModal.title = (this.clientDataModal.title != undefined ? this.clientDataModal.title : null);
        this.clientDataModal.softwareType = (this.clientDataModal.softwareType != undefined ? this.clientDataModal.softwareType : null);
        this.clientDataModal.trustType = (this.clientDataModal.trustType != undefined ? this.clientDataModal.trustType : null);

      }
      this.clientDataModal.strdateofbirth = this.datePipe.transform(this.clientDataModal.dateofbirth, 'yyyy/MM/dd');
      this.clientDataModal.physicalcountry = this.clientDataModal.physicalcountry != undefined || this.clientDataModal.physicalcountry != null ? this.clientDataModal.physicalcountry.toString() : null;

      let cfdata = [];
      for (let i in this.cfqcitem) {
        if (this.cfqcitem[i].fieldType == 'Date' && this.cfqcitem[i].value != 'Invalid Date' && this.cfqcitem[i].value != null)
          this.cfqcitem[i].value = this.datePipe.transform(this.cfqcitem[i].value, 'MM/dd/yyyy');
        if (this.cfqcitem[i].fieldType == 'Number' && this.cfqcitem[i].value != '' && this.cfqcitem[i].value != null)
          this.cfqcitem[i].value = this.cfqcitem[i].value.toString();
        if (this.cfqcitem[i].fieldType == 'Checkbox')
          this.cfqcitem[i].value = this.cfqcitem[i].customFieldValues;
        if (this.cfqcitem[i].value != null) {
          if (this.cfqcitem[i].value.length > 0)
            cfdata.push({ Id: this.cfqcitem[i].id, value: this.cfqcitem[i].value })
        }
      }

      if (cfdata.length > 0)
        this.clientDataModal.customfieldsData = JSON.stringify(cfdata);

      let cfcontactdata = [];
      for (let i in this.cfqlconitem) {
        if (this.cfqlconitem[i].fieldType == 'Date' && this.cfqlconitem[i].value != 'Invalid Date' && this.cfqlconitem[i].value != null)
          this.cfqlconitem[i].value = this.datePipe.transform(this.cfqlconitem[i].value, 'MM/dd/yyyy');
        if (this.cfqlconitem[i].fieldType == 'Number' && this.cfqlconitem[i].value != '' && this.cfqlconitem[i].value != null)
          this.cfqlconitem[i].value = this.cfqlconitem[i].value.toString();
        if (this.cfqlconitem[i].fieldType == 'Checkbox')
          this.cfqlconitem[i].value = this.cfqlconitem[i].customFieldValues;
        if (this.cfqlconitem[i].value != null) {
          if (this.cfqlconitem[i].value.length > 0)
            cfcontactdata.push({ Id: this.cfqlconitem[i].id, value: this.cfqlconitem[i].value })
        }
      }
      if (cfcontactdata.length > 0)
        this.clientDataModal.concustomfieldsData = JSON.stringify(cfcontactdata);
      let client = this.clientDataModal;
      this.setClientTagsPayload();
      this._clientService.AddEditCliententity(client, this.clientGridType,this.clientGridDynamicCols, this.clientGridIsCustomFields).subscribe({
        next: result => {
        if (result?.result?.success) {
          if (this.IseditClient) {
            this._toastr.success('Update Client Successfully', 'Create client');
          }
          else {
            this._toastr.success('Added Client Successfully', 'Create client');
          }
          this.getclientlistload.emit({response: result?.client[0]});
          this.clean(inputform);
          this.sort('created_At'); this._flagCodeExist = false;
          this.closeCreateclientPopup.emit();
        }
        else if (result?.result?.message == "Client Exist") {
          this._flagCodeExist = true;
        }
        else {
          this._toastr.warning(result.result.message, 'Create client'); this._flagCodeExist = false;
        }

      }, error: (error) => { this._toastr.error(error.message, 'Create client') }
    });
    }
  }

  public _flagCodeExist: boolean = false;

  ChangeFlagValue() {
    this._flagCodeExist = false;
  }

  onChangeContact(value) {
    if (value == 1) {
      this.clientDataModal.isContact = true;
      this.clientDataModal.isRelationship = false;
    }
    else if (value == 2) {
      this.clientDataModal.isContact = false;
      this.clientDataModal.isRelationship = true;
    }
  }
  onXeroPosting(client) {
    client.emailaddress = this.emailstring1;
    client.phonenumber = this.phonestring1;
    this.xeroService.PostClientsFromXero(client).subscribe(result => {
      // Please handle the response if needed.
    });
  }
  clean(addClientForm) {
    addClientForm.submitted = false;
    this.workEmailCount = 1;
    this.homePhoneCount = 1;
    this.workEmailCount2 = 1;
    this.homePhoneCount2 = 1;

    this.clientDataModal = new Clientdetails();
    this.contactDataModal = new Contact();
    this.clientDataModal.contactIds = null;
    this.contactsIds = null;
    this.clientDataModal.entityTypeId = 1;

    this.dynamicobjclean();
    this.cfqcitem = [];

    this.cfqlconitem = [];

  }


  cleancotact(addcontact) {
    addcontact.submitted = false;
    this.workEmailCount2 = 1;
    this.homePhoneCount2 = 1;
    this.contactDataModal = new Contact();
    this.contactDataModal.contactIds = null;
    this.contactsIds = null;
    this.contactDataModal.physicalcountry = '13';
    this.onChangeContactCountry2('13');
    this.dynamicobjcleancont();
    this.cfqlconitem = [];
    this.GetCustomFieldsforQuicklinkContactByRole(0);

  }
  checkContactOnchangefield() {
    this.changeContactField = true;
  }
  public addcontact: any;
  WarningPopupOpen(addcontactForm) {
    this.addcontact = addcontactForm;
    if (this.changeContactField) {
      this.modelRefNew = this.modalService.show(KcWarningPopupComponent, {
        class: 'modal-dialog-centered',
        backdrop: 'static',
        initialState: {
          mainContent: 'Contact information is not saved.',
          isSaveAndCloseReq: false
        }
      });

      this.modelRefNew.content.event.subscribe(res => {
        if (res === this.warningPopupRes.YES) {
          this.waringpopuponeyes();
          this.modelRefNew?.hide();
        } else {
          this.modelRefNew?.hide();
        }

      })
    } else {
      this.changeContactField = false;
      this.contactHide = false;

      this.modelRefNew?.hide();
      this.addcontact.submitted = false;
    }
  }
  WarningPopupClose() {
    this.modalRef?.hide();

  }
  waringpopupyes() {
    this.contactHide = false;
    this.modalRef?.hide();

    this.workEmailCount2 = 1;
    this.homePhoneCount2 = 1;
    this.contactDataModal = new Contact();
    this.contactsIds = null;
    this.emailstring4 = null;
    this.emailstring5 = null;
    this.emailstring6 = null;
    this.phonestring4 = null;
    this.phonestring5 = null;
    this.phonestring6 = null;
    this._phone4Validator = false;
    this._phone5Validator = false;
    this._phone6Validator = false;
    this.contactDataModal.physicalcountry = '13';
    this.contactDataModal.postalcountry = '13';
    this.onChangeContactCountry2('13');
    this.onChangeContactCountry3('13');
    this.addcontact.submitted = false;
  }
  selectEventone(item) {

  }

  onChangeSearchone(val: string) {


  }

  onFocusedtwo(e) {

  }


  selectEventtwo(item) {

  }

  onChangeSearchtwo(val: string) {


  }

  onFocusedone(e) {

  }

  dynamicobjclean() {

    this.emailoption1 = '2';
    this.emailstring1 = '';
    this.emailbookmark1 = false;
    this.emailoption2 = '2';
    this.emailstring2 = '';
    this.emailbookmark2 = false;
    this.emailoption3 = '2';
    this.emailstring3 = '';
    this.emailbookmark3 = false;
    this.emailoption4 = '1';
    this.emailoption5 = '1';
    this.emailoption6 = '1';
    this.emailstring4 = '';
    this.emailstring5 = '';
    this.emailstring6 = '';
    this.emailbookmark4 = false;
    this.emailbookmark5 = false;
    this.emailbookmark6 = false;

    this.phoneoption1 = '1';
    this.phonestring1 = '';
    this.phonebookmark1 = false;
    this.phoneoption2 = '1';
    this.phonestring2 = '';
    this.phonebookmark2 = false;
    this.phoneoption3 = '1';
    this.phonestring3 = '';
    this.phonebookmark3 = false;
    this.phoneoption4 = '1';
    this.phoneoption5 = '1';
    this.phoneoption6 = '1';
    this.phonestring4 = '';
    this.phonestring5 = '';
    this.phonestring6 = '';
    this.phonebookmark4 = false;
    this.phonebookmark5 = false;
    this.phonebookmark6 = false;
  }

  dynamicobjcleancont() {


    this.emailoption4 = '1';
    this.emailoption5 = '1';
    this.emailoption6 = '1';
    this.emailstring4 = '';
    this.emailstring5 = '';
    this.emailstring6 = '';
    this.emailbookmark4 = false;
    this.emailbookmark5 = false;
    this.emailbookmark6 = false;


    this.phoneoption4 = '1';
    this.phoneoption5 = '1';
    this.phoneoption6 = '1';
    this.phonestring4 = '';
    this.phonestring5 = '';
    this.phonestring6 = '';
    this.phonebookmark4 = false;
    this.phonebookmark5 = false;
    this.phonebookmark6 = false;
  }
  Restoredefault() {
    this.isShowclientName = true;
    this.isShowentityType = true;
    this.isShowpartnerName = true;
    this.isShowemail = true;
    this.isShowassignTagsCount = true;
    this.isShowlastActivityDate = true;
    this.isShowcrmActivity = true;
    this.isShowannualIncome = false;
    this.isShowMeetingDate = false;
    this.isShowinTaxClient = false;
    this.isShowmanager = false;
  }

  Clientidone: any;

  masterSelected: boolean;
  checkedList: any;
  showone: boolean = false;
  isAllSelected() {

    this.showone = !this.showone;
    this.masterSelected = this.clients.every(function (item: any) {
      return item.selected == true;
    })
    this.getCheckedItemList();
  }

  checkUncheckAll() {
    for (let i = 0; i < this.clients.length; i++) {
      this.clients[i]['selected'] = this.masterSelected;
    }
    this.getCheckedItemList();
  }

  getCheckedItemList() {
    this.checkedList = [];
    for (let i = 0; i < this.clients.length; i++) {
      if (this.clients[i]['selected'])

        this.checkedList.push({ ClientId: this.clients[i].clientId });
    }
    if (this.checkedList.length > 0) {
      this.showone = true; this.isBulkOptionDisabled = false;
    } else { this.showone = false; this.isBulkOptionDisabled = true; }
    this.checkedList = JSON.stringify(this.checkedList);


  }

 GetAllClientTag() {
    this._clientService.getAllTagdetailsforclient().pipe(takeUntil(this.unsubscribe)).subscribe((res: any) => {
      this.tagListforClient = (res || [])
        .filter(m => !m.isInActive)
        .map(m => ({
          tagId: Number(m.tagId),
          tagname: m.tagname
        }))
        .sort((a, b) => (a.tagname > b.tagname) ? 1 : -1);

      if (this.selectedClientTags && this.selectedClientTags.length > 0) {
        const selectedTagIds = this.selectedClientTags
          .map(tag => Number(tag?.tagId))
          .filter(tagId => !isNaN(tagId));

        if (selectedTagIds.length > 0) {
          this.selectedClientTags = this.tagListforClient.filter(tag => selectedTagIds.includes(tag.tagId));
          this.setClientTagsPayload();
        }
      }

      sortClientTagsToTop(this.tagListforClient, this.selectedClientTags);
    });

  }
  public divList: any = [];
  getAllDivisions() {
    this.divisionManagementService.getAllActiveDivision().subscribe((res: any) => {
      this.divList = res;
    });
  }

  getActiveOfficesList() {
    this.officeService.getActiveOfficeList().subscribe({
      next: (result) => {
        this.officeData.officeList = result;
      },
      error: (err: any) => {
        this._toastr.error("Failed to fetch office list. Please try again.");
      }
    });
  }

  clearOffice() {
    this.officeData.selectedOfficeId = null;
  }

  getAllPartners() {
    this.userManagementService.getUserByRole('Partner').subscribe((res: any) => {
      let state = this.stateManagement.getUserRoles.value;
      let partners = state.filter(x => x.role == 'Partner')
      this.partnerList = partners.length == 1 ? partners[0]["data"] : res;
    });
  }
  getAllManagers() {
    this.userManagementService.getUserByRole('Manager').subscribe((res: any) => {
      let state = this.stateManagement.getUserRoles.value;
      let managers = state.filter(x => x.role == 'Manager')
      this.mgrList = managers.length == 1 ? managers[0]["data"] : res;
    });
  }
  getAllTaxAgents() {

    this.taxagentList = [
      {
        userId: 'Financial Planner',
        firstName: 'Financial Planner'
      },
      {
        userId: 'CA',
        firstName: 'CA'
      },
      {
        userId: 'Auditor for TaxAgent',
        firstName: 'Auditor for TaxAgent'
      }

    ]

  }
  GetClientContactDetails(ClientId) {
    this.contactTable = [];
    this._clientService.GetClientContactDetails(ClientId).subscribe((response: any) => {
      if (response) {
        if (response.length > 0) {
          for (let i = 0; i < response.length; i++) {
            let dob: any = null;
            if (response[i]?.dateOfBirth != '0001-01-01T00:00:00' && response[i]?.dateOfBirth)
              dob = response[i].dateOfBirth;
            let list = { 'ContactId': response[i].contactId, 'Name': response[i].name, 'Emailaddress': response[i].emailaddress, 'DateOfBirth': dob, 'ContactType': response[i].contactType, 'ContestType': response[i].contestType };
            this.contactTable.push(list);
            let contact = this.contactdata.filter(f => f.contactId == response[i].contactId);
            this.contactTable[i].Contact = contact[0];
          }
        }
        else {


          this.contactTable = [];
        }
      }
    }, error => this._toastr.error("some thing went wrong"));
  }

  onAddContactnew(item, i) {
    let result = this.contactTable.some(t => t.ContactId === item.contactId);

    if (!result) {
      this.contactTable[i].ContactId = item.contactId;
      this.contactTable[i].Emailaddress = item.email;
      this.contactTable[i].ContestType = item.contestType;
      let dateofbirth: any = null;
      if (item.dateOfBirth != '0001-01-01T00:00:00' && item.dateOfBirth != null)
        dateofbirth = item.dateOfBirth
      this.contactTable[i].DateOfBirth = dateofbirth;
      let contact = this.contactdata.filter(f => f.contactId == item.contactId);
      this.contactTable[i].Contact = contact[0];
    }
    else {

    }
  }

  public checkAddrow: boolean = false;
  AddContactRow() {
    let length = this.contactTable.length;
    this.checkAddrow = true;
    if (length == 0 || (this.contactTable[length - 1].ContactId != 0)) {
      let list = { 'ContactId': 0, 'Name': '', 'Emailaddress': '', 'DateOfBirth': '', 'ContactType': 0, 'ContestType': 'Contact' };
      this.contactTable.push(list);
    }
    else {
      this._toastr.error('Please add contact first!', 'Add contact')
    }
  }

  addEditManagerInfo(addManagerInfoForm: NgForm) {
    if (addManagerInfoForm.form.invalid)
      return;

    this.clientsDetail.clientIds = this.checkedList;
    this.clientsDetail.contextFlag = 1;
    this.clientsDetail.contextUser = this.clientsDetail.managerId;
    this.postBulkUpdate(this.clientsDetail);
  }
  addEditPartnerInfo(addPartnerInfoForm: NgForm) {
    if (addPartnerInfoForm.form.invalid)
      return;

    this.clientsDetail.clientIds = this.checkedList;
    this.clientsDetail.contextFlag = 2;
    this.clientsDetail.contextUser = this.clientsDetail.partnerId;
    this.postBulkUpdate(this.clientsDetail);

  }
  addEdittaxagentInfo(addTaxAgentInfoForm: NgForm) {
    if (addTaxAgentInfoForm.form.invalid)
      return;

    this.clientsDetail.clientIds = this.checkedList;
    this.clientsDetail.contextFlag = 3;
    this.clientsDetail.contextUser = this.clientsDetail.taxagentId;
    this.postBulkUpdate(this.clientsDetail);
  }
  addEditMeetingInfo(MeetingForm: NgForm) {
    if (MeetingForm.form.invalid)
      return;

    this.clientsDetail.clientIds = this.checkedList;
    this.clientsDetail.contextFlag = 4;
    this.postBulkUpdate(this.clientsDetail);
  }
  addEditTagInfo(addTagInfoForm: NgForm) {
    if (addTagInfoForm.form.invalid)
      return;

    this.clientsDetail.clientIds = this.checkedList;
    this.clientsDetail.contextFlag = 6;
    this.postBulkUpdate(this.clientsDetail);
  }
  addEditStatusInfo(addStatusInfoForm: NgForm) {
    if (addStatusInfoForm.form.invalid)
      return;

    this.isVisibleStatusError = (this.clientsDetail.status == 'Prospect' || this.clientsDetail.status == 'Lost' || this.clientsDetail.status == 'Active' || this.clientsDetail.status == 'Archive') ? false : true;
    if (this.isVisibleStatusError && addStatusInfoForm.submitted)
      return;



    this.clientsDetail.clientIds = this.checkedList;
    this.clientsDetail.contextFlag = 7;
    this.postBulkUpdate(this.clientsDetail);
  }

  addEditIsTaxClientInfo(addIsTaxInfoForm: NgForm) {
    if (addIsTaxInfoForm.form.invalid)
      return;

    this.isVisibleClientTaxError = (this.clientsDetail.isTaxclient != undefined || this.clientsDetail.isTaxclient != null) ? false : true;
    if (this.isVisibleClientTaxError && addIsTaxInfoForm.submitted)
      return;


    this.clientsDetail.isTaxclient = this.clientsDetail.isTaxclient == 'True' ? true : false;
    this.clientsDetail.clientIds = this.checkedList;
    this.clientsDetail.contextFlag = 5;

    this.postBulkUpdate(this.clientsDetail);
  }

  postBulkUpdate(clientsDetail: any) {
    this._clientService.postBulkClientUpdate(clientsDetail).subscribe(result => {
      if (result.success) {
        this._toastr.success("All selected clients have been updated successfully", 'Create client');
        this.clientsDetail.nextMeetingDate = '';
        this.hide();
        this._clientService.GetClientCustomListSystemFilter(this.isAllStatusSelected, this.isActiveStatusSelected, this.isArchiveStatusSelected, this.isProspectStatusSelected,
          this.isIndivisualEntitySelected, this.isCompanyEntitySelected, this.isPartnershipEntitySelected, this.isSMSFEntitySelected, this.isTustEntitySelected
        ).subscribe((response: any) => {
          if (response) {
            this.clients = response;
            this.allClientList = response;
            this.temp_clientFilter = response;
          }
        }, error => this._toastr.error("some thing went wrong please contact system administrator.", 'Create client'));

      }
      else {
        this._toastr.error(result.message, 'Create client');
      }
    }, error => { this._toastr.error(error.message) });
  }
  GetContactList() {

    let searchTxt = 'test';
    this._clientService.GetContactList(searchTxt).subscribe((response: any) => {
      if (response) {
        this.contactList = response;

      }
    }, error => this._toastr.error("some thing went wrong"));
    return this.LocaltempclientFilter;
  }
  deleteContactbyId(contactId: any, name) {
    if (confirm("Are you sure you want to delete  " + name + " ?")) {
      this._clientService.DeleteContactById(Number(contactId)).subscribe(result => {
        if (result != undefined) {
          if (result) {
            this._toastr.success("Contact Removed successfully!", 'Create client');
            this.GetContactList();
          }
          else {
            this._toastr.error("Failed to remove the contact, please try again!", 'Create client');
          }
        }
        else {
          this._toastr.error("Something went wrong, please try again!");
        }
      }, error => { this._toastr.error(error.message) });
    }
  }


  GetContactDetailsById(contactId: any) {

    this.cleanContact(this.clientcontactForm);

    this._clientService.GetContactDetailsById(contactId).subscribe((response: any) => {
      if (response) {
        this.contactDataModal = response;
        if (this.contactDataModal.physicaladdressline1 != this.contactDataModal.postaladdressline1 &&
          this.contactDataModal.physicaladdressline2 != this.contactDataModal.postaladdressline2) { this.issamephysicalcontact = false; }

        this.contactDataModal.dateOfBirth = response.dateOfBirth == "0001-01-01T00:00:00" ? undefined : new Date(response.dateOfBirth);
        this.contactDataModal.dateOfDeath = (response?.dateOfDeath == "0001-01-01T00:00:00" || !response?.dateOfDeath) ? null : new Date(response?.dateOfDeath);
        this.getContactStatesData(this.contactDataModal.physicalcountry, "contactstates", this.makestringID.bind(this));
        let emailtemp = JSON.parse(this.contactDataModal.emailaddress);
        if (emailtemp.length > 0) {
          let email1 = emailtemp.filter(x => x.sequence == 1);
          let email2 = emailtemp.filter(x => x.sequence == 2);
          let email3 = emailtemp.filter(x => x.sequence == 3);

          if (email1.length == 1) {
            this.tempcontactemail.emailoption1 = email1[0].emailoption;
            this.tempcontactemail.emailstring1 = email1[0].emailstring;
          }
          if (email2.length == 1) {
            this.tempcontactemail.emailoption2 = email2[0].emailoption;
            this.tempcontactemail.emailstring2 = email2[0].emailstring; this.AddContactEmail();
          }
          if (email3.length == 1) {
            this.tempcontactemail.emailoption3 = email3[0].emailoption;
            this.tempcontactemail.emailstring3 = email3[0].emailstring; this.AddContactEmail();
          }

        }
        let phonetemp = JSON.parse(this.contactDataModal.phonenumber);
        if (phonetemp.length > 0) {
          let phone1 = phonetemp.filter(x => x.sequence == 1);
          let phone2 = phonetemp.filter(x => x.sequence == 2);
          let phone3 = phonetemp.filter(x => x.sequence == 3);

          if (phone1.length == 1) {
            this.tempcontactphone.phoneoption1 = phone1[0].phoneoption;
            this.tempcontactphone.phonestring1 = phone1[0].phonestring;
          }
          if (phone2.length == 1) {
            this.tempcontactphone.phoneoption2 = phone2[0].phoneoption;
            this.tempcontactphone.phonestring2 = phone2[0].phonestring; this.AddContactPhone();
          }
          if (phone3.length == 1) {
            this.tempcontactphone.phoneoption3 = phone3[0].phoneoption;
            this.tempcontactphone.phonestring3 = phone3[0].phonestring; this.AddContactPhone();
          }
        }
      }
    }, error => this._toastr.error("some thing went wrong"));
  }
  tempValidateContact() {
    if (this.emailstring4 == undefined || this.emailstring4 == "") {
      return false;
    }
    else if (this.phonestring4 == undefined || this.phonestring4 == "") {
      return false;
    }
    else {
      return true;
    }
  }

  public emailmsgString: any;
  public phonemsgString: any;
  public missingAddressStringContact: string = "";
  public missingAddressesContact: any = [];
  addContactconfirm(addcontact: NgForm) {
    this.emailmsgString = "";
    this.phonemsgString = "";
    this.missingAddressStringContact = "";
    this.missingAddressesContact = this.addressSetsContact.filter(address =>
      address.addressPoolId === undefined && address.addressTypeId !== undefined
    );
    if (this.checkAddrow) {
      this.checkAddrow = false;
    } else {
      if (!this.tempValidateContact()) {
        if (!this.tempValidateContact() || this.missingAddressesContact.length > 0) {

          if (this.emailstring4 == undefined || this.emailstring4 == "" || this.phonestring4 == undefined || this.phonestring4 == "" || this.missingAddressesContact.length > 0) {
            if (this.emailstring4 == undefined || this.emailstring4 == "") {
              this.emailmsgString = " <b>Email</b>";
            }
            if (this.phonestring4 == undefined || this.phonestring4 == "") {
              this.phonemsgString = " <b>Phone</b>";
            }
            if (this.emailmsgString != "" && this.phonemsgString != "") {
              this.phonemsgString = ", <b>Phone</b>"
            }
            if (this.missingAddressesContact.length > 0 && (this.phonemsgString !== "" && this.emailmsgString !== "")) {
              this.missingAddressStringContact = " and <b>Address</b>"
            }
            if (this.missingAddressesContact.length > 0 && (this.phonemsgString == "" && this.emailmsgString == "")) {
              this.missingAddressStringContact = " <b>Address</b>"
            }
          }
          this.modalRef = this.modalService.show(KcWarningPopupComponent, {
            class: 'modal-dialog-centered',
            backdrop: 'static',
            initialState: {
              mainContent: "You are about to " + this.buttontext.toLocaleLowerCase() + " a contact without" + this.emailmsgString + this.phonemsgString + this.missingAddressStringContact + ".",
              isSaveAndCloseReq: false
            }
          });
          this.modalRef.content.event.subscribe(res => {
            if (res === this.warningPopupRes.YES) {
              this.modalRef?.hide();

              this.addingAddContact(addcontact);
            }
            if (res === this.warningPopupRes.NO) {

              this.modalRef?.hide();
            }
          })
        } else {
          this.addingAddContact(addcontact);
        }
      }
    }
  }

  addingAddContact(addcontact: NgForm) {
    if (localStorage.getItem('token') == null) { this._toastr.error("Your session has expired"); this.router.navigate(['/']); }
    if (addcontact.form.invalid) {
      const firstInvalidControl: HTMLElement = this.el.nativeElement.querySelector("form .ng-invalid");
      firstInvalidControl.focus();
      return
    }

    if (!(this.emailstring4 == "" || this.emailstring4 == undefined)) {
      if (!this.ValidateEmail(this.emailstring4)) {
        if (this.currentPage == 1) {
          this.currentPage = 0;
        }
        return;
      }
    }
    if (!(this.phonestring4 == undefined || this.phonestring4 == "")) {
      if (this.phonestring4.length != 10) {
        return;
      }

    }
    if (this.validatecontact() && this.ValidateContactLinked) {
      if (this.contactsIds != null)
        this.contactDataModal.contactIds = this.contactsIds.replace(/^[^,]+, */, '');

      this.Obj_email = [...this.emails];

      const emailKeyMap: { [key: string]: number } = {};

      const hasInvalid = this._clientService.emailNotEmptyAndValid(this.Obj_email);

      if (hasInvalid) {
        this._toastr.error('Email Id is not valid, please re-evaluate');
        if (this.currentPage === 1) {
          this.currentPage = 0;
        }
        return;
      }

      this.Obj_email.forEach(item => {
        const key = `${item.emailTypeId}-${item.emailId.trim().toLowerCase()}`;
        emailKeyMap[key] = (emailKeyMap[key] || 0) + 1;
      });

      const duplicateEmailEntries = Object.keys(emailKeyMap)
        .filter(key => emailKeyMap[key] > 1);

      if (duplicateEmailEntries.length > 0) {
        this._toastr.error(
          'Email Id already exists, please revaluate',
          'Create/Update Client'
        );
        return;
      }

      this.obJ_phone = [...this.phones];

      const phoneKeyMap: { [key: string]: number } = {};

      this.obJ_phone.forEach(item => {
        const key = `${item.phoneTypeId}-${item.phoneNumber.trim()}`;
        phoneKeyMap[key] = (phoneKeyMap[key] || 0) + 1;
      });

      const duplicatePhoneEntries = Object.keys(phoneKeyMap)
        .filter(key => phoneKeyMap[key] > 1);

      if (duplicatePhoneEntries.length > 0) {
        this._toastr.error(
          'Phone number already exists, please revaluate',
          'Create/Update Client'
        );
        return;
      }

      if (this.contactDataModal.isSamePhysical) {
        this.ShowContactPostal = false;
        this.contactDataModal.postaladdressline1 = this.contactDataModal.physicaladdressline1;
        this.contactDataModal.postaladdressline2 = this.contactDataModal.physicaladdressline2;
        this.contactDataModal.postalcountry = this.contactDataModal.physicalcountry == undefined ? '13' : this.contactDataModal.physicalcountry;
        this.onChangeContactCountry3(this.contactDataModal.postalcountry);
        this.contactDataModal.postalstate = this.contactDataModal.physicalstate;
        this.contactDataModal.postalsuburb = this.contactDataModal.physicalsuburb;
        this.contactDataModal.postalpostcode = this.contactDataModal.physicalpostcode;

      }

      this.contactDataModal.emailaddress = JSON.stringify(this.Obj_email);
      this.contactDataModal.phonenumber = JSON.stringify(this.obJ_phone);
      this.contactDataModal.physicalpostcode = this.contactDataModal.physicalpostalpostcode;

      let cfdata = [];
      for (let i in this.cfqlconitem) {
        if (this.cfqlconitem[i].fieldType == 'Date' && this.cfqlconitem[i].value != 'Invalid Date' && this.cfqlconitem[i].value != null)
          this.cfqlconitem[i].value = this.datePipe.transform(this.cfqlconitem[i].value, 'yyyy/MM/dd');
        if (this.cfqlconitem[i].fieldType == 'Number' && this.cfqlconitem[i].value != '' && this.cfqlconitem[i].value != null)
          this.cfqlconitem[i].value = this.cfqlconitem[i].value.toString();
        if (this.cfqlconitem[i].fieldType == 'Checkbox')
          this.cfqlconitem[i].value = this.cfqlconitem[i].customFieldValues;
        if (this.cfqlconitem[i].value != null) {
          if (this.cfqlconitem[i].value.length > 0)
            cfdata.push({ Id: this.cfqlconitem[i].id, value: this.cfqlconitem[i].value })
        }
      }
      if (cfdata.length > 0)
        this.contactDataModal.customfieldsData = JSON.stringify(cfdata);

      if (this.contactDataModal.dateOfBirth != null) {
        this.contactDataModal.dateOfBirth = this.contactDataModal.dateOfBirth.toString('dd/MM/yyyy');;
        let datestr = this.contactDataModal.dateOfBirth.split('/');
        let date = datestr[2] + '-' + datestr[1] + '-' + datestr[0];
        this.contactDataModal.dateOfBirth = new Date(date);
      }
      else
        this.contactDataModal.dateOfBirth = new Date('0001-01-01');

      this.clientDataModal.dateOfDeath = formateDateInYMDFormat(this.clientDataModal?.dateOfDeath);

      if (this.contactDataModal.dateOfBirth != null && this.contactDataModal.dateOfBirth != undefined)
        this.contactDataModal.strdateofbirth = this.datePipe.transform(this.contactDataModal.dateOfBirth, 'yyyy/MM/dd');

      this.contactDataModal.addressPoolContactMapping = this.addressSetsContact.map(obj => {
        const { addressInput$, fullAddressList, ...clients } = obj;
        return clients;
      });;
      if (this.deletedAddressSetsContact.length > 0) {
        this.deletedAddressSetsContact = this.deletedAddressSetsContact.filter(item => item.addressPoolMappingId !== 0);
        this.contactDataModal.addressPoolContactMapping.push(...this.deletedAddressSetsContact);
      }
      let Contact = this.contactDataModal;
      this._clientService.AddContact(Contact).subscribe(result => {
        if (result.success) {
          this._toastr.success('Added contact successfully', 'Create client');
          this.cleancotact(addcontact);
          let ContactId = result.operationStatuses[0].uniqueKey;
          this._clientService.GetContactById(ContactId).subscribe((response: any) => {
            if (response) {

              let dateofbirth: any;
              if (response.dateOfBirth != '0001-01-01T00:00:00')
                dateofbirth = response.dateOfBirth;

              let list = { 'ContactId': response.contactId, 'Name': response.name, 'Emailaddress': response.emailaddress, 'DateOfBirth': dateofbirth, 'ContactType': 0, 'ContestType': 'Contact' };
              this.contactTable.push(list);

              let list1 = { 'contactId': response.contactId, 'name': response.name, 'email': response.emailaddress, 'dateOfBirth': dateofbirth, 'physicalsuburb': response.physicalsuburb, 'contestType': 'Contact' };
              this.contactdata.push(list1);

              let contact = this.contactdata.filter(f => f.contactId == response.contactId);
              let index = this.contactTable.length - 1;
              this.contactTable[index].Contact = contact[0];

            }
          }, error => this._toastr.error("some thing went wrong", 'Create client'));
          this.contactDataModal.physicalcountry = '13';
          this.onChangeContactCountry2('13');
          this.contactHide = false;
        }
        else {
          this._toastr.warning(result.message, 'Create client');
        }

      }, error => { this._toastr.error(error.message, 'Create client') });
    }

  }

  validatecontact() {
    if (this.contactDataModal.firstName == undefined || this.contactDataModal.firstName == "") {
      return false;
    }
    else if (this.contactDataModal.lastname == undefined || this.contactDataModal.lastname == "") {
      return false;
    }
    else {
      return true;
    }
  }

  addingContactdetails(clientcontactForm: NgForm) {
    if (clientcontactForm.form.invalid) {
      return;
    }

    let cObj_email = [];
    let cObJ_phone = [];
    if (this.workContactEmailCount > 0) {
      let comm = { emailoption: this.tempcontactemail.emailoption1, emailstring: this.tempcontactemail.emailstring1, sequence: 1 }
      cObj_email.push(comm);
    } if (this.workContactEmailCount > 1) {
      let comm = { emailoption: this.tempcontactemail.emailoption2, emailstring: this.tempcontactemail.emailstring2, sequence: 2 }
      cObj_email.push(comm);
    } if (this.workContactEmailCount > 2) {
      let comm = { emailoption: this.tempcontactemail.emailoption3, emailstring: this.tempcontactemail.emailstring3, sequence: 3 }
      cObj_email.push(comm);
    }
    if (this.homeContactPhoneCount > 0) {
      let phoneo = { phoneoption: this.tempcontactphone.phoneoption1, phonestring: this.tempcontactphone.phonestring1, sequence: 1 }
      cObJ_phone.push(phoneo);
    } if (this.homeContactPhoneCount > 1) {
      let phoneo = { phoneoption: this.tempcontactphone.phoneoption2, phonestring: this.tempcontactphone.phonestring2, sequence: 2 }
      cObJ_phone.push(phoneo);
    } if (this.homeContactPhoneCount > 2) {
      let phoneo = { phoneoption: this.tempcontactphone.phoneoption3, phonestring: this.tempcontactphone.phonestring3, sequence: 3 }
      cObJ_phone.push(phoneo);
    }

    let kl = [];
    if (this.contactDataModal.physicaladdressline1 != null || this.contactDataModal.physicaladdressline1 != undefined)
      kl.push({
        addressId: this.contactDataModal.physicaladdressId,
        addressLine1: this.contactDataModal.physicaladdressline1, addressLine2: this.contactDataModal.physicaladdressline2,
        suburb: this.contactDataModal.physicalsuburb, state: this.contactDataModal.physicalstate, country: this.contactDataModal.physicalcountry,
        addressType: this.contactDataModal.physicaladdress
      });

    if (!this.issamephysicalcontact && (this.contactDataModal.contactId == undefined || this.contactDataModal.contactId > 0)) {
      if (this.contactDataModal.postaladdressline1 != null || this.contactDataModal.postaladdressline1 != undefined) {
        kl.push({
          addressId: this.contactDataModal.postaladdressId,
          addressLine1: this.contactDataModal.postaladdressline1, addressLine2: this.contactDataModal.postaladdressline2,
          suburb: this.contactDataModal.postalsuburb, state: this.contactDataModal.postalstate, country: this.contactDataModal.postalcountry,
          addressType: this.contactDataModal.postaladdress
        });
      }
    }

    this.contactDataModal.addresses = kl;

    this.contactDataModal.emailaddress = JSON.stringify(cObj_email);
    this.contactDataModal.phonenumber = JSON.stringify(cObJ_phone);
    this._clientService.AddEditContact(this.contactDataModal).subscribe(result => {

      if (result.success) {
        this._toastr.success('Added Contact Successfully', 'Create client');
        this.GetContactList();
        this.cancelContact.nativeElement.click();
        this.cleanContact(clientcontactForm);
      }
      else {
        this._toastr.warning(result.message, 'Create client');
      }
    }, error => { this._toastr.error(error.message, 'Create client') });
  }
  cleanContact(clientcontactForm) {
    clientcontactForm.submitted = false;


    this.resetContactForm();
  }
  resetContactForm() {
    this.contactDataModal = new Contact();
    this.tempcontactemail = new Tcontactworkemail();
    this.tempcontactphone = new tcontacthomephone();
    this.workContactEmailCount = 1;
    this.homeContactPhoneCount = 1;
    this.issamephysicalcontact = true;
    this.contactDataModal.contactId = this.contactId;


  }
  AddContactEmail() {
    this.workContactEmailCount = this.workContactEmailCount + 1;
  }
  AddContactPhone() {
    this.homeContactPhoneCount = this.homeContactPhoneCount + 1;
  }
  onChangeContactCountry(id) {
    if (id != undefined) {
      id = id;
    }
    if (id == null || id == undefined || !Number(id))
      id = '13';
    if (this.countries == undefined) {
      this.getContactCountries('contactcountry1');
    } else {
      let item1 = this.countries.filter(b => b.countryId == id)[0];
      this.tooltipPhysicalCountryName1 = item1.name.length >= 44 ? item1.name : '';
    }
    this.getContactStatesData(id, "contactstates", this.makestringID.bind(this))
  }

  isString(value) {

    return typeof value === 'string' || value instanceof String;
  }

  onChangeContactCountry1(id) {
    if (id != undefined) {
      id = id;
    }
    if (id == null || id == undefined || !Number(id))
      id = '13';
    if (this.countries == undefined) {
      this.getContactCountries('contactcountry1');
    }
    else {
      let item1 = this.countries.filter(b => b.countryId == id)[0];
      this.tooltipPostalCountryName1 = item1.name.length >= 44 ? item1.name : '';
    }
    this.getContactStatesData(id, "contactstates1")
  }
  onChangeContactCountry2(id) {
    if (id != undefined) {
      id = id;
    }
    if (id == null || id == undefined || !Number(id))
      id = '13';

    if (this.countries == undefined) {
      this.getContactCountries('contactcountry2');
    }
    else {
      let item1 = this.countries.filter(b => b.countryId == id)[0];
      this.tooltipPhysicalCountryName2 = item1.name.length >= 44 ? item1.name : '';
    }
    this.getContactStatesData(id.trim(), "contactstates2")
  }


  setPhysicalCountryName(id: string, targetPropertyName: string) {
    if (targetPropertyName == 'contactcountry1') {
      let item1 = this.countries?.filter(b => b.countryId == id)[0];
      this.tooltipPhysicalCountryName1 = item1?.name?.length >= 44 ? item1?.name : '';
    } else {
      let item1 = this.countries?.filter(b => b.countryId == id)[0];
      this.tooltipPhysicalCountryName2 = item1?.name?.length >= 44 ? item1?.name : '';
    }
  }

  onChangeContactCountry3(id) {
    if (id != undefined) {
      id = id;
    }
    if (id == null || id == undefined || !Number(id))
      id = '13';

    if (this.countries == undefined) {
      this.getContactCountries('contactcountry2');
    }
    else {
      let item1 = this.countries.filter(b => b.countryId == id)[0];
      this.tooltipPostalCountryName2 = item1.name.length >= 44 ? item1.name : '';
    }
    this.getContactStatesData(id.trim(), "contactstates3")
  }

  public newAddress: any = {};
  getContactCountries(targetPropertyName?: string) {
    this.userManagementService.getContactCountries().pipe(takeUntil(this.unsubscribe)).subscribe({
      next: (result) => {
      this.countries = result;
      this.countries.forEach((element, index) => {
        this.countries[index].countryId = element.countryId.toString();
      })
      this.contactcountries = this.countries;
      if (this.stateManagement.getContactCountries.value == null) {
        this.stateManagement.updateData(this.stateManagement.getContactCountries, result)
      }
      targetPropertyName ? this.setPhysicalCountryName('13', targetPropertyName) : null;
    }, 
    error: (error) => {
      this._toastr.error("Failed to load countries list");
    }
    });
  };
  public selectedCountryId: string = '13';
  public selectedStateId: number;
  public stateList: any;
  getStatesList(countryId) {
    if (countryId) {
      this.userManagementService.getStates(countryId).pipe(takeUntil(this.unsubscribe)).subscribe({
        next: (result) => {
          this.stateList = result;
        },
        error: (error) => {
          this._toastr.error("Failed to load states list");
        }
      });
    } else {
      this.stateList = [];
      this.selectedStateId = undefined;
    }
  }
  onCountryChange(countryId: number | null) {
    this.selectedStateId = undefined;
    this.getStatesList(countryId);
  };

  public cstatelist = [];
  makestringID() {
    this.cstatelist = [];
    for (let i = 0; i < this.contactstates.length; i++) {
      let obj = { stateId: this.contactstates[i].stateId.toString(), name: this.contactstates[i].name };
      this.cstatelist.push(obj);
    }
  }

  getContactStatesData(id: any, targetProperty: string, callback?: () => void) {
    this.userManagementService.getStates(id).pipe(takeUntil(this.unsubscribe)).subscribe({
        next: (result) => {
        this[targetProperty] = result;
        const propertyMap = {
          'contactstates1': 'contactstates1',
          'contactstates': 'contactstates',
          'states': 'states',
          'contactstates2': 'contactstates2',
          'contactstates3': 'contactstates3'
        };

        const propertyName = propertyMap[targetProperty];
        if (propertyName) {
          this[propertyName] = result;
        }
        if (callback) {
          callback();
        }
      },
        error: (error) => {
          this._toastr.error("Failed to load states list");
        }
      });
  }

  RemoveContactPhonethree() {
    this.tempcontactphone.phoneoption3 = undefined;
    this.tempcontactphone.phonestring3 = '';
    this.tempcontactphone.phonebookmark3 = false;
    this.homeContactPhoneCount = this.homeContactPhoneCount - 1;
  }

  RemoveContactPhonetwo() {
    if (this.homeContactPhoneCount == 3) {
      this.tempcontactphone.phoneoption2 = this.tempcontactphone.phoneoption3;
      this.tempcontactphone.phonestring2 = this.tempcontactphone.phonestring3;
      this.phonebookmark2 = this.phonebookmark3;
      this.tempcontactphone.phoneoption3 = undefined;
      this.tempcontactphone.phonestring3 = '';
      this.tempcontactphone.phonebookmark3 = false;
    }
    else if (this.homeContactPhoneCount == 2) {

      this.tempcontactphone.phoneoption2 = undefined;
      this.tempcontactphone.phonestring2 = '';
      this.tempcontactphone.phonebookmark2 = false;
    }
    this.homeContactPhoneCount = this.homeContactPhoneCount - 1;
  }

  RemoveContactPhoneone() {
    if (this.homeContactPhoneCount == 2) {
      this.tempcontactphone.phoneoption1 = this.tempcontactphone.phoneoption2;
      this.tempcontactphone.phonestring1 = this.phonestring2;
      this.phonebookmark1 = this.phonebookmark2;
      this.tempcontactphone.phoneoption2 = undefined;
      this.tempcontactphone.phonestring2 = '';
      this.tempcontactphone.phonebookmark2 = false;
    }
    else if (this.homeContactPhoneCount == 3) {
      this.tempcontactphone.phoneoption1 = this.tempcontactphone.phoneoption2;
      this.tempcontactphone.phonestring1 = this.tempcontactphone.phonestring2;
      this.tempcontactphone.phonebookmark1 = this.tempcontactphone.phonebookmark2;
      this.tempcontactphone.phoneoption2 = this.tempcontactphone.phoneoption3;
      this.tempcontactphone.phonestring2 = this.tempcontactphone.phonestring3;
      this.tempcontactphone.phonebookmark2 = this.tempcontactphone.phonebookmark3;
      this.tempcontactphone.phoneoption3 = undefined;
      this.tempcontactphone.phonestring3 = '';
      this.tempcontactphone.phonebookmark3 = false;
    }
    if (this.homeContactPhoneCount > 1) { this.homeContactPhoneCount = this.homeContactPhoneCount - 1; }

  }

  RemoveContactEmailTwo() {
    if (this.workContactEmailCount == 3) {
      this.tempcontactemail.emailoption2 = this.tempcontactemail.emailoption3;
      this.tempcontactemail.emailstring2 = this.tempcontactemail.emailstring3;
      this.tempcontactemail.emailoption3 = undefined;
      this.tempcontactemail.emailstring3 = '';
    }
    else if (this.workContactEmailCount == 2) {
      this.tempcontactemail.emailoption2 = undefined;
      this.tempcontactemail.emailstring2 = '';
    }
    this.workContactEmailCount = this.workContactEmailCount - 1;
  }

  mangerpopup() {
    if (!this.isBulkOptionDisabled) {
      document.getElementById("myForm").style.display = "block";
      this.getAllPartners();
      this.isBulkOptionDisabled = true;
    }
    this.clientsDetail.partnerId = undefined;
  }

  managerpopupClose() {
    document.getElementById("myForm").style.display = "none";
    this.isBulkOptionDisabled = false;
  }

  txagentpopup() {
    if (!this.isBulkOptionDisabled) {
      document.getElementById("myFormTaxAgent").style.display = "block";
      this.getAllTaxAgents();
      this.isBulkOptionDisabled = true;
    }
    this.clientsDetail.taxagentId = undefined;
  }

  taxagentpopupClose() {
    document.getElementById("myFormTaxAgent").style.display = "none";
    this.isBulkOptionDisabled = false;
  }

  popupOn() {
    if (!this.isBulkOptionDisabled) {
      document.getElementById("1012").style.display = "block";
      this.getAllManagers();
      this.isBulkOptionDisabled = true;
    }
    this.clientsDetail.managerId = undefined;;
  }

  popupOff() {
    document.getElementById("1012").style.display = "none";
    this.isBulkOptionDisabled = false;
  }

  meettingOn() {
    if (!this.isBulkOptionDisabled) {
      document.getElementById("1013").style.display = "block";
      let dd = new Date();
      this.minDate.setDate(dd.getDate());
      this.isBulkOptionDisabled = true;
    }
  }

  mettingOff() {
    this.clientsDetail.nextMeetingDate = '';
    document.getElementById("1013").style.display = "none";
    this.isBulkOptionDisabled = false;
  }

  tagUp() {
    if (!this.isBulkOptionDisabled) {
      document.getElementById("1014").style.display = "block";
      this.GetAllClientTag();
      this.isBulkOptionDisabled = true;
    }
    this.clientsDetail.tagsId = undefined;
  }

  tagOff() {
    document.getElementById("1014").style.display = "none";
    this.isBulkOptionDisabled = false;
  }

  statusUp() {
    if (!this.isBulkOptionDisabled) {
      document.getElementById("1015").style.display = "block";
      this.isBulkOptionDisabled = true;
    }
  }

  statusOff() {
    document.getElementById("1015").style.display = "none";
    this.isBulkOptionDisabled = false;
  }

  hide() {
    this.showone = false;
    this.masterSelected = false;
    this.checkUncheckAll();
    this.isBulkOptionDisabled = false;
  }

  IsTaxClientUp() {
    if (!this.isBulkOptionDisabled) {
      document.getElementById("myIstaxform").style.display = "block";
      this.isBulkOptionDisabled = true;
    }
  }

  IsTaxClientOff() {
    document.getElementById("myIstaxform").style.display = "none";
    this.isBulkOptionDisabled = false;
  }

  onSelectIssamephysicalcontact(event: any) {
    if (event) {
      this.contactDataModal.postaladdressId = this.contactDataModal.physicaladdressId;
      this.contactDataModal.postaladdressline1 = this.contactDataModal.physicaladdressline1;
      this.contactDataModal.postaladdressline2 = this.contactDataModal.physicaladdressline2;
      this.contactDataModal.postalsuburb = this.contactDataModal.physicalsuburb;
      this.contactDataModal.postalstate = this.contactDataModal.physicalstate;
      this.contactDataModal.postalcountry = this.contactDataModal.physicalcountry;
    }
    else {
      this.contactDataModal.postaladdressId = 0;
      this.contactDataModal.postaladdressline1 = null; this.contactDataModal.postaladdressline2 = null;
      this.contactDataModal.postalsuburb = null; this.contactDataModal.postalstate = undefined; this.contactDataModal.postalcountry = undefined;
      this.contactDataModal.postaladdress = '2';
    }
  }

  expand(index, client) {
    this.childRow[index] = !this.childRow[index];
    this.childRow[index] ? this.GetEntities(client.clientId, index) : '';
    this.Index = index;
  }

  onClientSearch(val) {
    if (val == '') {
      this.GetClientList('', false);
    }
  }

  OnClientSearchKey(keyVal) {
    if (keyVal != '') {
      this.GetClientList(keyVal, false);
    }
    else {
      this.GetClientList('', false);
    }
  }

  async GetClientList(searchTxt, isArchive, isFirstTimescreenLoad = false) {
    try {
      const response = await this._clientService.GetClientListPromiseAsync(searchTxt, isArchive, this.filterCustomStatusId, isFirstTimescreenLoad);
      if (response) {
        if (this.clientType == 'potential') {
          this.clients = response.filter(x => x.isActive == 0)
          this.allClientList = this.clients;
        } else {
          this.clients = response.filter(x => x.isActive == 1)
          this.allClientList = response;
        }
      }
    } catch (e) {
      this._toastr.error("some thing went wrong please contact system administrator.");
    }
  }

  openForm(clientId) {
    this.GetTagdetailsListbyClientid(clientId)
    this.testclient = clientId;
  }

  closeForm() {
    document.getElementById("myForm").style.display = "none";
    this.ClientTagsbyId = []
  }

  GetTagdetailsList(isArchive) {
    this._clientService.GetTagdetailsclients(isArchive).subscribe((res: any) => {
      this.TagList = res;
      this.TagList.forEach((item, index) => {
        let comm = {
          display: item.tagname,
          value: item.tagId,
          backgroundColor: item.colour,
        }
        this.activiesCount = this.ClientProfileActivities.push(comm);
      });
    });
  }

  GetTagdetailsListbyClientid(ClientId) {
    this.ClientTagsbyId = [];
    this._clientService.GetTagdetailsListbyClientid(ClientId).subscribe((res: any) => {
      this.TagIdList = res;
      this.TagIdList.forEach((item, index) => {
        let comm = {
          display: item.tagname,
          value: item.tagId,
          backgroundColor: item.colour,
        }
        this.ClientTagsbyId.push(comm);
      });
    });
  }

  GetClientDetailsById(ClientId) {
    this.currentPage = 0;
    this.GetContactforClient();
    this.IseditClient = true;
    this.contactTable = [];
    this._clientService.getClientDetailsById(ClientId).subscribe(response => {
      if (response) {
        this.clientDataModal.clientId = response.clientId;
        this.clientDataModal.entityTypeId = response.entityTypeId;
        this.clientDataModal.prospect = response?.prospect;
        this.clientDataModal.clientCode = response.clientCode;
        this.clientDataModal.title = (response?.title || null);
        this.clientDataModal.salutation = (response?.salutation || null);
        this.clientDataModal.firstname = response.firstname;
        this.clientDataModal.xeroMappingId = response?.xeroMappingId;
        this.clientDataModal.middlename = response?.middlename;
        this.clientDataModal.lastname = response.lastname;
        this.clientDataModal.preferredname = response?.preferredname;
        this.clientDataModal.mailingName = response?.mailingName;
        this.clientDataModal.companyName = response?.companyName;
        this.clientDataModal.tradingName = response?.tradingName;
        this.clientDataModal.partnershipname = response?.partnershipname;
        this.clientDataModal.smsfName = response?.smsfName;
        this.clientDataModal.trustName = response?.trustName;
        this.clientDataModal.trustType = (response?.trustType || null);
        this.clientDataModal.dateofbirth = ((response.dateofbirth == "0001-01-01T00:00:00" || !response?.dateofbirth) ? null : new Date(response?.dateofbirth));
        this.clientDataModal.dateOfDeath = ((response?.dateOfDeath == "0001-01-01T00:00:00" || !response?.dateOfDeath) ? null : new Date(response?.dateOfDeath));
        this.clientDataModal.clientStartDate = ((response?.clientStartDate == "0001-01-01T00:00:00" || !response?.clientStartDate) ? null : new Date(response?.clientStartDate));
        this.clientDataModal.clientEndDate = ((response?.clientEndDate == "0001-01-01T00:00:00" || !response?.clientEndDate) ? null : new Date(response?.clientEndDate));
        this.clientDataModal.deRegistrationDate = ((response?.deRegistrationDate == "0001-01-01T00:00:00" || !response?.deRegistrationDate) ? null : new Date(response?.deRegistrationDate));
        this.clientDataModal.annualReviewDate = (response?.annualReviewDate == "0001-01-01T00:00:00" ? '' : new Date(response?.annualReviewDate));
        this.clientDataModal.formationDate = (response?.formationDate == "0001-01-01T00:00:00" ? '' : new Date(response?.formationDate));
        this.clientDataModal.placeofbirth = response?.placeofbirth;
        this.clientDataModal.gender = (response?.gender || null);
        this.clientDataModal.emailaddress = response?.emailaddress
        this.clientDataModal.phonenumber = response?.phonenumber;
        this.clientDataModal.managerId = (response?.managerId || null);
        this.clientDataModal.teamId = (response?.teamId || null);
        this.clientDataModal.officeId = this.officeData.selectedOfficeId = response?.officeId || null;

        this.clientDataModal.addressPoolClientMapping = (response?.addressPoolClientMapping || null);
        if (!this.clientDataModal.addressPoolClientMapping) {
          this.addAddressSet();
        }
        else {
          this.addressSets = this.clientDataModal.addressPoolClientMapping.filter(item => item.isDeleted === false);
          // sanitize careof values to avoid repeated "C/-" or "Care of" prefixes
          this.addressSets.forEach(addressSet => {
            addressSet.careof = this.sanitizeCareOf(addressSet.careof);
          });
          for (let i = 0; i < this.addressSets.length; i++) {
            this.addressTypeList[i] = this.addressTypes;
            this.addressSets[i].fullAddressList = response?.addressPoolForComboDTOs;
          }
        }

        this.addressSets.forEach(address => {
          delete address.addressInput$;
        })
        this.loadedAddress = this.commonService.copyObject(this.addressSets);
        this.addressSets.forEach((address, index) => {
          address.addressInput$ = new Subject<string>();
          this.sub.add(address.addressInput$.pipe(
            debounceTime(500),
            distinctUntilChanged(),
            filter(term => term.length >= 3),
            switchMap(term => this.fetchAddresses(term))
          ).subscribe((addresses: any[]) => {
            this.addressSetsContact[index].fullAddressList = addresses;
          }));
        })
        this.setLoadedForm();
        const validEmailPoolClientMapping = (response.emailPoolClientMapping || []).filter(item =>
          item?.emailId !== null &&
          item?.emailId !== undefined &&
          item.emailId.toString().trim() !== ''
        );
        this.backUpEmailPoolIds = validEmailPoolClientMapping;
        if (validEmailPoolClientMapping.length > 0) {
          this.clientDataModal.emailPoolClientMapping = validEmailPoolClientMapping;
          this.clientDataModal.emailPoolClientMapping = this.clientDataModal.emailPoolClientMapping.map(item => ({
            ...item,
            emailTypeName: this.emailTypes.find(
              t => t.emailTypeId === item.emailTypeId
            )?.emailTypeName || ''
          }));
          this.emails = this.clientDataModal.emailPoolClientMapping;
          this.emails.sort((x, y) =>
            x.emailTypeName.localeCompare(y.emailTypeName)
          );
          this.PrasingEmailjson(this.clientDataModal.emailPoolClientMapping);
        }
        // Dev Surya L - CUST-6897 Date: June 10 2025
          const validPhonePoolClientMapping = (response.phonePoolClientMapping || []).filter(item =>
            item?.phoneNumber !== null &&
            item?.phoneNumber !== undefined &&
            item.phoneNumber.toString().trim() !== ''
          );
          this.backUpPhonePoolIds = validPhonePoolClientMapping;
          if (validPhonePoolClientMapping.length > 0) {
          this.clientDataModal.phonePoolClientMapping = [...validPhonePoolClientMapping].map(item => ({
            ...item,
            countryId: String(item.countryId),
            countryName: this.contactcountries.find(c => String(c.countryId) === String(item.countryId))?.name || '',
            isValidPhone: this.checkPhoneValidOrNot(item),
            phoneTypeName: this.phoneTypes.find(t => t.phoneTypeId === item.phoneTypeId)?.phoneTypeName || '',
            countryRegionCode: this.contactcountries.find(c => String(c.countryId) === String(item.countryId))?.code || '',
            phoneNumber: item.phoneNumber ? this.googleUtil.format(this.googleUtil.parseAndKeepRawInput(item.phoneNumber, this.contactcountries.find(
              c => String(c.countryId) === String(item.countryId)
            )?.code || '')) : item.phoneNumber
          }));
          this.phones = this.clientDataModal.phonePoolClientMapping;
          this.phones.sort((x, y) =>
            x.phoneTypeName.localeCompare(y.phoneTypeName)
          );
          this.phones.forEach((phone, index) => {
            this.onPhoneValidation(index, phone);
          });
          this.PrasingPhonejson(this.clientDataModal.phonePoolClientMapping);
        } 
        this.selectedClientTags = this.getSelectedClientTagsFromResponse(response);
        this.setClientTagsPayload();
        this.clientDataModal.partnerId = (response?.partnerId || null);
        this.clientDataModal.divisionId = (response?.divisionId || null);
        this.clientDataModal.linkedinprofileID = response?.linkedinprofileID;
        this.clientDataModal.physicaladdress = response?.physicaladdress;
        this.clientDataModal.physicaladdressline1 = response?.physicaladdressline1;
        this.clientDataModal.physicaladdressline2 = response?.physicaladdressline2;
        this.clientDataModal.physicalsuburb = response?.physicalsuburb;
        this.clientDataModal.physicalpostcode = response?.physicalpostcode;
        this.clientDataModal.postaladdressline1 = response?.postaladdressline1;
        this.clientDataModal.postaladdressline2 = response?.postaladdressline2;
        this.clientDataModal.postalsuburb = response?.postalsuburb;
        this.clientDataModal.postalpostcode = response?.postalpostcode;
        this.clientDataModal.industry = response?.industry || null;
        this.clientDataModal.role = response?.role;
        this.clientDataModal.salary = response?.salary;
        this.clientDataModal.annualincome = response?.annualincome;
        this.clientDataModal.physicalstate = (response?.physicalstate || null);
        this.clientDataModal.postalstate = (response?.postalState ? Number(response?.postalState) : null);
        this.clientDataModal.istaxclient = response?.istaxclient;
        this.clientDataModal.islodgeactivity = response?.islodgeactivity
        this.clientDataModal.tFN = (response?.tfn == undefined ? "" : response?.tfn);
        this.clientDataModal.aBN = (response?.abn == undefined ? "" : response?.abn);
        this.clientDataModal.dIN = (response?.din == undefined ? "" : response?.din);
        this.clientDataModal.aCN = (response?.acn == undefined ? "" : response?.acn);
        this.clientDataModal.taxAgent = (response?.taxAgent || null);
        this.clientDataModal.gST = response?.gst;
        this.clientDataModal.resident = response?.resident;
        this.clientDataModal.bankname = response?.bankname;
        this.clientDataModal.bankaccountname = response?.bankaccountname;
        this.clientDataModal.bankBSB = response?.bankBSB;
        this.clientDataModal.bankAccountnumber = response?.bankAccountnumber;
        this.clientDataModal.website = response?.website;
        this.clientDataModal.softwareType = (response?.softwareType || null);
        this.clientDataModal.softwareName = response?.softwareName;
        this.clientDataModal.accountingfirmmid = response?.accountingfirmmid;
        this.clientDataModal.isContact = response?.isContact;
        this.clientDataModal.isRelationship = response?.isRelationship;
        this.clientDataModal.contactId = response?.contactId;
        this.clientDataModal.isSamePhysical = response?.isSamePhysical;
        if (this.buttontext == 'Update ') {
          this.clientDataModal.isSamePhysical = false;
        }
        this.originalPhysicalAddress.addressId = response?.physicaladdressId || '';
        this.originalPhysicalAddress.addressline1 = response?.physicaladdressline1 || '';
        this.originalPhysicalAddress.addressline2 = response?.physicaladdressline2 || '';
        this.originalPhysicalAddress.suburb = response?.physicalsuburb || '';
        this.originalPhysicalAddress.state = response?.physicalstate || '';
        this.originalPhysicalAddress.postcode = response?.physicalpostcode || '';
        this.originalPhysicalAddress.country = response?.physicalcountry || '';
        this.originalPhysicalAddress.stateName = response?.stateName || '';
        this.originalPhysicalAddress.countryName = response?.countryName || '';
        this.originalPostalAddress.addressId = response?.postaladdressId || '';
        this.originalPostalAddress.addressline1 = response?.postaladdressline1 || '';
        this.originalPostalAddress.addressline2 = response?.postaladdressline2 || '';
        this.originalPostalAddress.suburb = response?.postalsuburb || '';
        this.originalPostalAddress.state = response?.postalState || '';
        this.originalPostalAddress.postcode = response?.postalpostcode || '';
        this.originalPostalAddress.country = response?.postalcountry || '';
        this.originalPostalAddress.countryName = response?.pCountryName || '';
        this.originalPostalAddress.stateName = response?.pStateName || '';
        this.contactHide = false;
        this.ShowPostal = true;
        this.Showcheck = false;
        this.clientDataModal.physicalcountry = (response?.physicalcountry || null);
        this.onChangeContactCountry(this.clientDataModal.physicalcountry);
        this.clientDataModal.postalcountry = (response?.postalcountry || null);
        this.onChangeContactCountry1(this.clientDataModal.postalcountry);
        this.GetClientContactDetails(ClientId);
        this.GetCustomFieldsforClientinQuicklinkByRole(this._TempClientId);
        this._CurrentTFNData = this.clientDataModal.tFN;
        this._CurrentDINData = this.clientDataModal.dIN;
        this._CurrentBSBData = this.clientDataModal.bankBSB;
        this._CurrentAccountNumberData = this.clientDataModal.bankAccountnumber;
        if (response.entityTypeId == 2)
          this.clientOldName = response.companyName;
        else if (response.entityTypeId == 3)
          this.clientOldName = response.trustName;
        else if (response.entityTypeId == 4)
          this.clientOldName = response.partnershipname;
        else if (response.entityTypeId == 5)
          this.clientOldName = response.smsfName;
        else
          this.clientOldName = response.firstname.trim() + " " + response.lastname.trim();

        // Re-validate partner/manager lists now that partnerId and managerId are available
        if (this.partnerAndManagerList) {
          this.validatePartnersAndManagerList();
        }
        this.clientDataModal.bPayReference = response?.bPayReference;
        this.clientDataModal.oldBpayReference = response?.bPayReference;
      }
    }, error => console.error(error));
  }
  PrasingEmailjson(emailArray) {
    if (!emailArray) { return; }
    emailArray.slice(0, 3).forEach((item, index) => {
      const i = index + 1;

      this[`emailoption${i}`] = item.emailTypeId || item.emailoption || '';
      this[`emailstring${i}`] = item.emailId || item.emailstring || '';
      this[`emailbookmark${i}`] = item.isFavourite ?? item.isemailbookmarked ?? false;
    });
    if (this.emailstring3 != undefined && this.emailstring3 != '') {
      this.workEmailCount = 3;
    }
    else if (this.emailstring2 != undefined && this.emailstring2 != '') {
      this.workEmailCount = 2;
    }
    else {
      this.workEmailCount = 1;
    }
  }


  PrasingPhonejson(phoneArray) {
    if (!phoneArray) { return; }
    phoneArray.slice(0, 3).forEach((item, index) => {
      const i = index + 1;

      this[`phoneoption${i}`] = item.phoneTypeId || item.phoneoption || '';
      this[`phonestring${i}`] = item.phoneNumber || item.phonestring || '';
      this[`phonebookmark${i}`] = item.isFavourite ?? item.isphonebookmarked ?? false;
    });

    if (this.phonestring3 != '' && this.phonestring3 != undefined) {
      this.homePhoneCount = 3;
    }
    else if (this.phonestring2 != '' && this.phonestring2 != undefined) {
      this.homePhoneCount = 2;
    }
    else {
      this.homePhoneCount = 1;
    }
  }

  getasignstaff(contId, flag) {
    this._clientService.GetAssignStaffListByContext(contId, flag).subscribe(result => {
      this.asignstaff = result;
    })
  }

  GetEntityType() {
    this.entityService.GetEntityTypes().subscribe(result => {
      this.entitytype = result;
    });
  }

  Giveclientid(client) {
    this.cid = client.clientId;
    this.clientName = client.fullName;
    this.assignEntitydata.clientId = client.clientId;
    this.cid = client;
    this.GetEntityType();
    this.isremove = false;
    this.getLinkedEntityLists(client);
  }

  entitySelectChangeHandler(event: any) {
    this.selectedEntityTypeId = +event.target.value;
    this.entityService.GetEntityName(this.selectedEntityTypeId, this.cid).subscribe(result => {
      this.entitynm = result;
    });
  }

  assignEntityToClient(assignEntityForm: NgForm) {
    if (assignEntityForm.form.invalid)
      return;
    if (this.isremove == false) {
      if (this.assignEntity.entityid == undefined) {
        ;
        this._toastr.warning("select Entity Type", 'Create client');
        return;
      }
      else {
        let selectedEntites = [];
        selectedEntites = this.selectedItems.map(({ entityId }) => { return { entityId: entityId } })
        if (selectedEntites.length > 0) {
          this.assignEntity.assignEntityIds = JSON.stringify(selectedEntites);
          this.assignEntity.clientId = Number(this.cid);
          this.assignEntity.id = 0;
          this.assignEntity.entityid = Number(this.assignEntity.entityid);
          this._clientService.PostAddAssignEntityToClient(this.assignEntity).subscribe(result => {
            if (result.success) {
              this._toastr.success(result.message, 'Create client');
              this.GetClientList("", this.isArchive);
              this.cancel1.nativeElement.click();
              this.refreshForm();
            }
            else {
              this._toastr.error(result.message, 'Create client');
            }

          }, error => { this._toastr.error(error.message, 'Create client') });
        } else {
          this._toastr.warning('Select the entity name first');
        }
      }
    }
  }

  getLinkedEntityLists(client) {
    this.Entities = [];
    this._clientService.GetAllEntityforClient(client).subscribe((data) => {
      this.isLinkedEntitesAvailable = data["length"] == 0 ? this.isLinkedEntitesAvailable = false : this.isLinkedEntitesAvailable = true;
      this.Entities = data;
    })
  }

 onItemSelect(item: any) {
    this.setClientTagsPayload();
    this.checkOnchangefield();
    sortClientTagsToTop(this.tagListforClient, this.selectedClientTags);
  }

  onSelectAll(items: any) {
    this.setClientTagsPayload();
    this.checkOnchangefield();
    sortClientTagsToTop(this.tagListforClient, this.selectedClientTags);
  }

  onItemDeSelect(item: any) {
    this.setClientTagsPayload();
    this.checkOnchangefield();
     sortClientTagsToTop(this.tagListforClient, this.selectedClientTags);
  }

  onItemDeSelectAll(items: any) {
    this.setClientTagsPayload();
    this.checkOnchangefield();
    sortClientTagsToTop(this.tagListforClient, this.selectedClientTags);
  }

  private setClientTagsPayload() {

  if (this.selectedClientTags && this.selectedClientTags.length > 0) {
    const idArray = this.selectedClientTags
      .map(tag => tag?.tagId)
      .filter(id => id !== undefined && id !== null);

    const singleWrapperObject = {
      TagIds: idArray
    };

    this.clientDataModal.tagIdsJson = JSON.stringify(singleWrapperObject);
    
    if ((this.clientDataModal as any).tagsId) {
      delete (this.clientDataModal as any).tagsId;
    }
  } else {
    this.clientDataModal.tagIdsJson = JSON.stringify({ TagIds: [] });
  }
}
onTagSelectionChange(event: any) {
  this.setClientTagsPayload();
}

  private getSelectedClientTagsFromResponse(response: any): Array<{ tagId: number; tagname: string }> {
    if (response?.tagIdsJson) {
      try {
        const parsedTags = typeof response.tagIdsJson === 'string' ? JSON.parse(response.tagIdsJson) : response.tagIdsJson;
        const primitiveIds = (parsedTags.TagIds || parsedTags.tagIds || [])
          .map((id: any) => Number(id))
          .filter((id: number) => !isNaN(id));

        if (this.tagListforClient && this.tagListforClient.length > 0) {
          return this.tagListforClient.filter((tag: any) => primitiveIds.includes(Number(tag.tagId)));
        }

        return primitiveIds.map((tagId: number) => ({ tagId, tagname: '' }));
      } catch (e) {
        this._toastr.error('Error parsing tag state payload string:', e);
      }
    }

    if (Array.isArray(response?.tagName)) {
      const selectedTags = response.tagName
        .map((tag: any) => ({
          tagId: Number(tag?.tagId),
          tagname: tag?.tagName ?? tag?.tagname ?? ''
        }))
        .filter(tag => !isNaN(tag.tagId));

      if (this.tagListforClient && this.tagListforClient.length > 0) {
        const selectedTagIds = selectedTags.map(tag => tag.tagId);
        return this.tagListforClient.filter((tag: any) => selectedTagIds.includes(Number(tag.tagId)));
      }

      return selectedTags;
    }

    if (Array.isArray(response?.tags)) {
      const selectedTags = response.tags
        .map((tag: any) => ({
          tagId: Number(tag?.tagId ?? tag),
          tagname: tag?.tagName ?? tag?.tagname ?? ''
        }))
        .filter(tag => !isNaN(tag.tagId));

      if (this.tagListforClient && this.tagListforClient.length > 0) {
        const selectedTagIds = selectedTags.map(tag => tag.tagId);
        return this.tagListforClient.filter((tag: any) => selectedTagIds.includes(Number(tag.tagId)));
      }

      return selectedTags;
    }

    return [];
  }
  onAdded($event: any, clientId) {
    this._clientService.Addtagclient($event.value, clientId)
      .subscribe(result => {
        if (result != undefined) {
          if (result) {
            this._toastr.success("Tag added successfully!", 'Create client');
          }
          else {
            this._toastr.error("Failed to add the Tag, please try again!", 'Create client');
          }
        }
        else {
          this._toastr.error("Something went wrong, please try again!");
        }
      }, error => { this._toastr.error(error.message) });
  }

  onSelected($event: any) {
    alert("Fire selected" + $event);
  }

  onItemRemoved($event: any, clientId) {
    this._clientService.DeleteTagById($event.value, clientId).subscribe(result => {
      if (result != undefined) {
        if (result) {
          this._toastr.success("Tag removed successfully!", 'Create client');
        }
        else {
          this._toastr.error("Failed to removes the Tag, please try again!", 'Create client');
        }
      }
      else {
        this._toastr.error("Something went wrong, please try again!");
      }
    }, error => { this._toastr.error(error.message) });
  }

  RemoveLinkEntity(id, name) {
    this.isremove = true;
    if (confirm("Are you sure you want to delete" + " " + name + " ?")) {
      this.entityService.DeleteEntityMappingById(id).subscribe(result => {
        if (result.success) {
          this._toastr.success(name + " " + "Entity is sucessfully removed", 'Create client');
          this.GetClientList("", this.isArchive);
          this.cancel1.nativeElement.click();
        }
        else {
          this._toastr.error(result.message, 'Create client');
          this.isremove = false;
        }
      });
    }
  }

  clientview(clientId) {
    this.router.navigate([`/client/clientview`], { queryParams: { Id: clientId } });
  }

  clientedit(clientId) {
    this.router.navigate([`/client/editclient`], { queryParams: { clientId: clientId } });
  }

  openclientprofile(clientId) {
    this.router.navigate(['/client/contact/'], { queryParams: { clientId: clientId } });
  }

  GetEntities(clientId, i) {
    this.entityService.GetEntitiesByClientId(clientId).subscribe(response => {
      if (response) {
        this.entities[i] = response;
      }
    }, error => error => this._toastr.error("some thing went wrong please contact system administrator."));
  }
  captureLogTime(client) {

    this.logTime.clientName = client.fullName;
    this.logTime.clientId = client.clientId;
    this.clienttolog = client.clientId;
    this.capturelogTimeModel.show();
  }
  logTimeMethod(entity) {
    this._clientService.GetClientById(entity.clientId).subscribe(response => {
      if (response) {
        this.client = response;
      }
      this.logTime.clientName = response.fullName;
      this.logTime.clientId = response.clientId;
      this.logTime.entityId = entity.entityId;
      this.logTime.entityName = entity.entityName;
    })
  }
  showcapuretime(entity) {
    this.logTimeMethod(entity);
    this.capturelogTimeModel.show();
  }
  onCloseLogTime() {
    this.capturelogTimeModel.hide();
  }
  importbox() {
    this.importModel.hide();
  }
  Addtask() {
    this.addjob.hide();
  }
  closePopUp() {
    this.addJobModal.hide();
  }
  openAddPopUp() {

    this.addjob.show();
  }
  subTabSetting(_tabnav) {
    this.sub_tabno = _tabnav;
    if (_tabnav == 2)
      this.subadd_tabno = 1;
  }

  subAddTabSetting(_tabaddnav) {
    this.subadd_tabno = _tabaddnav;
  }

  subanTabSetting(_tabnav) {
    this.suban_tabno = _tabnav;
    if (_tabnav == 2)
      this.subaddan_tabno = 1;
  }

  subanAddTabSetting(_tabaddnav) {
    this.subaddan_tabno = _tabaddnav;
  }

  CheckIsContact(val) {
    if (val == "IsContact") {
      this.clientDataModal.isContact = true;
      this.clientDataModal.isRelationship = false;
    }
    else if (val == "isRelationship") {
      this.clientDataModal.isContact = false;
      this.clientDataModal.isRelationship = true;
    }
  }

  searchClientList($event) {
    this.GetClientList($event.toLowerCase(), this.isArchive);
    if (this.clients.length != 0) {
      let sai = [];
      sai = JSON.parse(this.clients.toString())

      this.temp_client = this.clients;
    } else {
      this._toastr.warning("No result found", 'Create client');
      this.clients = this.temp_client;
    }
  }


  addEntity(clientId, clientmaritalstatus) {
    this.router.navigate([`/client/addEntity`], { queryParams: { Id: clientId, Status: clientmaritalstatus } });
  }


  addAssignStaff(clientId) {
    ;
    this.cid = clientId;
    this.templateservice.clientId = clientId;
    localStorage.setItem('clined', clientId);
    this.assignStaff.show();
  }
  addclientpop() {

    this.addClientModal.show();
  }
  closePopUpAssignStaff() {
    this.assignStaff.hide();
  }

  addJob(clientId) {
    this.clid = clientId;

    this.addJobModal.show();
  }

  onSelect(event) {

    this.files.push(...event.addedFiles);
  }

  onRemove(event) {

    this.files.splice(this.files.indexOf(event), 1);
  }
  removefiles(files) {

    let formData = new FormData();
    if (this.files.length > 1) {
      for (let x = 0; x < this.files.length; x++) {
        formData.append('rec', this.files[x], this.files[x].name);
      }
    }

    let n = this.files.length
    this.files.splice(this.files.indexOf(files), n + 1);
  }

  reset(documentForm) {


  }
  key: string = 'clientName';
  reverse: boolean = false;
  sort(key) {

    this.key = key;
    this.reverse = !this.reverse;
  }

  ArchiveClient(Client) {
    if (window.confirm("Are you sure you to want archive '" + Client.fullName + "' ?")) {
      this._clientService.ArchiveClients(Client.clientId)
        .subscribe(result => {
          if (result != undefined) {
            if (result) {
              if (result.operationStatuses[0].operationAction == "Exists") {
                this._toastr.error("This client cannot be archived. Please archive all related clients or move the the related clients to a different debtor!");
              } else {
                this._toastr.success(Client.fullName + " " + "Archived successfully!");
              }
            }
            else {
              this._toastr.error("Failed to archive the client, please try again!", 'Create client');
            }
          }
          else {
            this._toastr.error("Something went wrong, please try again!", 'Create client');
          }
        }, error => { this._toastr.error(error.message, 'Create client') });
    }
  }
  refreshForm() {
    this.assignEntity.entityid = undefined;
    this.selectedItems = [];
  }
  refresh(assignEntityForm) {
    this.selectedItems = [];
    this.assignEntitydata = new assignEntity();
    assignEntityForm.submitted = false;


  }
  shownotes() {

    this.hideNotes = !this.hideNotes;
  }

  onShowArchiveClients(archive) {

    if (archive) {

      this.GetClientList("", archive);
      this.show = !this.show;
      this.isArchive = !this.isArchive
      this.isClickedFilter = true;
    } else {

      this.GetClientList("", archive);
      this.show = !this.show;
      this.isArchive = !this.isArchive;
      this.isClickedFilter = false;
    }

  }

  toggle() {
    this.show = !this.show
    if (this.show && !this.isClickedFilter) {
      this.isArchive = true;

    }
  }


  UploadDocument(documentForm: NgForm) {

    if (documentForm.invalid || this.files.length == 0) {
      if (this.files.length == 0) {
        this._toastr.warning('Please upload documents', 'Create client');
      }
      return;
    }
    let formData = new FormData();
    let n = this.files.length
    if (this.files.length > 1) {
      for (let x = 0; x < this.files.length; x++) {
        formData.append('files', this.files[x], this.files[x].name);
      }
    } else {
      formData.append('files', this.files[0]);
    }
    this.fileManagerService.UploadClientBlobFiles(documentForm, formData).subscribe(result => {
      if (result.success) {
        this._toastr.success(result.operationStatuses[0].uniqueKey + ' File uploaded successful', 'Create client');
        this.resetUploadForm(documentForm);
        this.uploadDocModal.hide();
      }
      else {
        this._toastr.error(result.message, 'Create client');
      }
    });

  }
  resetUploadForm(documentForm) {

    documentForm.submitted = false;
    this.files = [];
  }

  GetCustomClientList() {
    this._clientService.GetCustomClientList().subscribe((response: any) => {
      if (response) {
        this.clients = response;
      }
    }, error => this._toastr.error("some thing went wrong"));
  }
  setdefaultcoloumns() {
    this.dynamicfilter.clientName = this.isShowclientName; this.dynamicfilter.entityType = this.isShowentityType;
    this.dynamicfilter.location = this.isShowlocation; this.dynamicfilter.isShowpartnerName = this.isShowpartnerName;
    this.dynamicfilter.isShowcontactName = this.isShowcontactName; this.dynamicfilter.isShowemail = this.isShowemail;
    this.dynamicfilter.isShowassignTagsCount = this.isShowassignTagsCount;
    this.dynamicfilter.isShowclientCode = this.isShowclientCode; this.dynamicfilter.isShowmanager = this.isShowmanager;
    this.dynamicfilter.isShowinTaxClient = this.isShowinTaxClient; this.dynamicfilter.isShowtaxAgent = this.isShowtaxAgent;
    this.dynamicfilter.isShowcrmActivity = this.isShowcrmActivity; this.dynamicfilter.isShowworkPhone = this.isShowworkPhone;
    this.dynamicfilter.isShowstatus = this.isShowstatus; this.dynamicfilter.isShowabn = this.isShowabn;
    this.dynamicfilter.isShowopenJobs = this.isShowopenJobs; this.dynamicfilter.isShowwip = this.isShowwip;
    this.dynamicfilter.isShowfollowUpDate = this.isShowfollowUpDate; this.dynamicfilter.isShowlastActivityDate = this.isShowlastActivityDate;
    this.dynamicfilter.isShowindustry = this.isShowindustry; this.dynamicfilter.isShowacn = this.isShowacn;
    this.dynamicfilter.isShowgstRegistered = this.isShowgstRegistered; this.dynamicfilter.isShowopportunityJobs = this.isShowopportunityJobs;
    this.dynamicfilter.isShowlastInvoiceSent = this.isShowlastInvoiceSent; this.dynamicfilter.isShowannualIncome = this.isShowannualIncome;
    this.dynamicfilter.isShowassigneeCount = this.isShowassigneeCount; this.dynamicfilter.isShowMeetingDate = this.isShowMeetingDate;


  }
  DynamicForm(dynamicfilterForm) {

    this.validation();
    if (this.invalidselect) {
      this.isVisibleError = true;
      return;
    }
    else {
      this.isVisibleError = false;
      this.isShowclientName = this.dynamicfilter.clientName; this.isShowentityType = this.dynamicfilter.entityType;
      this.isShowlocation = this.dynamicfilter.location; this.isShowpartnerName = this.dynamicfilter.isShowpartnerName;
      this.isShowcontactName = this.dynamicfilter.isShowcontactName; this.isShowemail = this.dynamicfilter.isShowemail;
      this.isShowassignTagsCount = this.dynamicfilter.isShowassignTagsCount;
      this.isShowclientCode = this.dynamicfilter.isShowclientCode; this.isShowmanager = this.dynamicfilter.isShowmanager;
      this.isShowinTaxClient = this.dynamicfilter.isShowinTaxClient; this.isShowtaxAgent = this.dynamicfilter.isShowtaxAgent;
      this.isShowcrmActivity = this.dynamicfilter.isShowcrmActivity; this.isShowworkPhone = this.dynamicfilter.isShowworkPhone;
      this.isShowstatus = this.dynamicfilter.isShowstatus; this.isShowabn = this.dynamicfilter.isShowabn;
      this.isShowopenJobs = this.dynamicfilter.isShowopenJobs; this.isShowwip = this.dynamicfilter.isShowwip;
      this.isShowfollowUpDate = this.dynamicfilter.isShowfollowUpDate; this.isShowlastActivityDate = this.dynamicfilter.isShowlastActivityDate;
      this.isShowindustry = this.dynamicfilter.isShowindustry; this.isShowacn = this.dynamicfilter.isShowacn;
      this.isShowgstRegistered = this.dynamicfilter.isShowgstRegistered; this.isShowopportunityJobs = this.dynamicfilter.isShowopportunityJobs;
      this.isShowlastInvoiceSent = this.dynamicfilter.isShowlastInvoiceSent; this.isShowannualIncome = this.dynamicfilter.isShowannualIncome;
      this.isShowassigneeCount = this.dynamicfilter.isShowassigneeCount; this.isShowMeetingDate = this.dynamicfilter.isShowMeetingDate;
      document.getElementById('close_btn').click();

    }


  }
  validation() {

    this.validatecount = 0;
    if (this.validatecount == 0) {
      if (this.dynamicfilter.clientName) {
        this.validatecount = this.validatecount + 1
      }
      if (this.dynamicfilter.entityType) {
        this.validatecount = this.validatecount + 1
      }
      if (this.dynamicfilter.location) { this.validatecount = this.validatecount + 1 }
      ; if (this.dynamicfilter.isShowpartnerName) { this.validatecount = this.validatecount + 1 };
      if (this.dynamicfilter.isShowcontactName) { this.validatecount = this.validatecount + 1 };
      if (this.dynamicfilter.isShowemail) { this.validatecount = this.validatecount + 1 };
      if (this.dynamicfilter.isShowassignTagsCount) { this.validatecount = this.validatecount + 1 };
      if (this.dynamicfilter.isShowclientCode) { this.validatecount = this.validatecount + 1 }; if (this.dynamicfilter.isShowmanager) { this.validatecount = this.validatecount + 1 };
      if (this.dynamicfilter.isShowinTaxClient) { this.validatecount = this.validatecount + 1 }; if (this.dynamicfilter.isShowtaxAgent) { this.validatecount = this.validatecount + 1 };
      if (this.dynamicfilter.isShowcrmActivity) { this.validatecount = this.validatecount + 1 }; if (this.dynamicfilter.isShowworkPhone) { this.validatecount = this.validatecount + 1 };
      if (this.dynamicfilter.isShowstatus) { this.validatecount = this.validatecount + 1 }; if (this.dynamicfilter.isShowabn) { this.validatecount = this.validatecount + 1 };
      if (this.dynamicfilter.isShowopenJobs) { this.validatecount = this.validatecount + 1 }; if (this.dynamicfilter.isShowwip) { this.validatecount = this.validatecount + 1 };
      if (this.dynamicfilter.isShowfollowUpDate) { this.validatecount = this.validatecount + 1 }; if (this.dynamicfilter.isShowlastActivityDate) { this.validatecount = this.validatecount + 1 };
      if (this.dynamicfilter.isShowindustry) { this.validatecount = this.validatecount + 1 }; if (this.dynamicfilter.isShowacn) { this.validatecount = this.validatecount + 1 };
      if (this.dynamicfilter.isShowgstRegistered) { this.validatecount = this.validatecount + 1 }; if (this.dynamicfilter.isShowopportunityJobs) { this.validatecount = this.validatecount + 1 };
      if (this.dynamicfilter.isShowlastInvoiceSent) { this.validatecount = this.validatecount + 1 }; if (this.dynamicfilter.isShowannualIncome) { this.validatecount = this.validatecount + 1 };
      if (this.dynamicfilter.isShowassigneeCount) { this.validatecount = this.validatecount + 1 }; if (this.dynamicfilter.isShowMeetingDate) { this.validatecount = this.validatecount + 1 };
    }
    if (this.validatecount <= 7) {
      this.invalidselect = false
    }
    else {
      this.invalidselect = true
    }

  }

  getAllFolderType() {
    this.folderTypeService.getAllFolderType().subscribe((res: any) => {

      this.allFolderTypeList = res;

    })
  }
  GetCustomClientListForFilter() {
    this._clientService.GetCustomClientList().subscribe((response: any) => {
      if (response) {
        this.LocaltempclientFilter = response;
      }
    }, error => this._toastr.error("some thing went wrong"));
    return this.LocaltempclientFilter;
  }



  callClientListFilter() {
    this.GetClientList('', false);
  }
  onSelectStatusFilter(filterType: any) {

    this.cutomeFilterName = '';

    if (filterType == 'All' || filterType == 'Prospect' || filterType == 'Active' || filterType == 'Lost' || filterType == 'Archive') {
      if (filterType == 'All') {
        this.isAllStatusSelected = !this.isAllStatusSelected;
        if (this.isAllStatusSelected) {
          this.filterTypeList = [];
          this.filterName = '';
          this.filterName = 'All';
          this.filterCustomStatusId = 5;

        }
        else {
          this.filterName = '';

        }

      }
      if (filterType == 'Archive') {
        this.filterCustomStatusId = 4;
        this.isArchiveStatusSelected = !this.isArchiveStatusSelected;
        if (this.isArchiveStatusSelected) {
          this.filterName = this.filterName + ' + Archive';
          this.temp_clientFilter.push('Archive');
        }
        else {
          this.filterName = this.filterName.replace(' + Archive', '');
          this.filterName = this.filterName.replace('Archive', '');
        }
      }

      if (filterType == 'Lost') {
        this.filterCustomStatusId = 3;
        this.isLostStatusSelected = !this.isLostStatusSelected;
        if (this.isLostStatusSelected) {
          this.filterName = this.filterName + ' + Lost';
          this.temp_clientFilter.push('Lost');
        }
        else {
          this.filterName = this.filterName.replace(' + Lost', '');
          this.filterName = this.filterName.replace('Lost', '');
        }

      }
      if (filterType == 'Active') {
        this.filterCustomStatusId = 1;
        this.isActiveStatusSelected = !this.isActiveStatusSelected;
        if (this.isActiveStatusSelected) {
          this.filterName = this.filterName + ' + Active';
          this.temp_clientFilter.push('Active');
        }
        else {
          this.filterName = this.filterName.replace(' + Active', '');
          this.filterName = this.filterName.replace('Active', '');
        }
      }
      if (filterType == 'Prospect') {
        this.filterCustomStatusId = 2;
        this.isProspectStatusSelected = !this.isProspectStatusSelected;
        if (this.isProspectStatusSelected) {
          this.filterName = this.filterName + ' + Prospect';
          this.temp_clientFilter.push('Prospect');
        }
        else {
          this.filterName = this.filterName.replace(' + Prospect', '');
          this.filterName = this.filterName.replace('Prospect', '');
        }

      }
    }
    if (filterType == 'Individual' || filterType == 'Company' || filterType == 'Partnership' || filterType == 'Trust' || filterType == 'SMSF') {
      if (filterType == 'Individual') {
        this.isIndivisualEntitySelected = !this.isIndivisualEntitySelected;
        if (this.isIndivisualEntitySelected) {
          this.filterName = this.filterName + ' + Individual';
          this.temp_clientFilter.push('Individual');
        }
        else {
          this.filterName = this.filterName.replace(' + Individual', '');
          this.filterName = this.filterName.replace('Individual', '');
        }
      }
      if (filterType == 'Company') {
        this.isCompanyEntitySelected = !this.isCompanyEntitySelected;
        if (this.isCompanyEntitySelected) {
          this.filterName = this.filterName + ' + Company';
          this.temp_clientFilter.push('Company');
        }
        else {
          this.filterName = this.filterName.replace(' + Company', '');
          this.filterName = this.filterName.replace('Company', '');
        }

      }
      if (filterType == 'Partnership') {
        this.isPartnershipEntitySelected = !this.isPartnershipEntitySelected;
        if (this.isPartnershipEntitySelected) {
          this.filterName = this.filterName + ' + Partnership';
          this.temp_clientFilter.push('Partnership');
        }
        else {
          this.filterName = this.filterName.replace(' + Partnership', '');
          this.filterName = this.filterName.replace('Partnership', '');
        }
      }
      if (filterType == 'Trust') {
        this.isTustEntitySelected = !this.isTustEntitySelected;
        if (this.isTustEntitySelected) {
          this.filterName = this.filterName + ' + Trust';
          this.temp_clientFilter.push('Trust');
        }
        else {
          this.filterName = this.filterName.replace(' + Trust', '');
          this.filterName = this.filterName.replace('Trust', '');
        }
      }
      if (filterType == 'SMSF') {
        this.isSMSFEntitySelected = !this.isSMSFEntitySelected;
        if (this.isSMSFEntitySelected) {
          this.filterName = this.filterName + ' + SMSF';
          this.temp_clientFilter.push('SMSF');
        }
        else {
          this.filterName = this.filterName.replace(' + SMSF', '');
          this.filterName = this.filterName.replace('SMSF', '');
        }

      }

    }
    if (this.isAllStatusSelected || this.isArchiveStatusSelected || this.isLostStatusSelected || this.isActiveStatusSelected || this.isProspectStatusSelected || this.isIndivisualEntitySelected || this.isCompanyEntitySelected || this.isPartnershipEntitySelected || this.isTustEntitySelected || this.isSMSFEntitySelected) {
      this.ShowStaticSaveFilter = true;
    }
    else {
      this.ShowStaticSaveFilter = false;
    }
    this.showFilterCount(filterType);
    this.callClientListFilter();
  }


  closeSaveStaticFilterOption() {
    this.ShowStaticSaveFilter = false;
  }
  popUpOffDynamicFilterProfile() {
    document.getElementById("dynamicFilterProfile").style.display = "none";
  }
  PopUpOnDynamicFilterProfile() {
    document.getElementById("dynamicFilterProfile").style.display = "block";

  }
  showStaticFilter() {
    document.getElementById("ShowpopupStaticFilter").style.display = "block";
  }
  onAddStaticFilter() {
    if (this.isActiveStatusSelected) {
      this.onAddStatus(2);
    }
    if (this.isProspectStatusSelected) {
      this.onAddStatus(3);
    }
    if (this.isLostStatusSelected) {
      this.onAddStatus(4);
    }
    if (this.isArchiveStatusSelected) {
      this.onAddStatus(5);
    }
    if (this.isIndivisualEntitySelected) {
      this.onAddEntityType(1);
    }

    if (this.isCompanyEntitySelected) {
      this.onAddEntityType(2);
    }
    if (this.isPartnershipEntitySelected) {
      this.onAddEntityType(4);
    }
    if (this.isSMSFEntitySelected) {
      this.onAddEntityType(3);
    }
    if (this.isTustEntitySelected) {
      this.onAddEntityType(5);
    }
    if (this.dynamicfilterObj.SavedFilterName != undefined) {
      this.isFilterSavedName = false;
      this.dynamicfilterObj.Status = JSON.stringify(this.StatusTypePost);
      this.dynamicfilterObj.EntityTypeName = JSON.stringify(this.entityTypePost);
      this.dynamicfilterObj.WIP = this.dynamicfilterObj.WIP;
      this.dynamicfilterObj.AnnualIncome = this.dynamicfilterObj.AnnualIncome;
      this.dynamicfilterObj.GstRegisted = this.GSTRegisteredPost;
      this.dynamicfilterObj.isTaxAgent = this.TaxClientPost;
      this.dynamicfilterObj.FilterId = this.dynamicfilterObj.FilterId == 0 ? 0 : this.dynamicfilterObj.FilterId;
      this.dynamicfilterObj.isFavorite = this.dynamicfilterObj.isFavorite;
      this._clientService.PostDynamicFilter(this.dynamicfilterObj).subscribe(result => {
        if (result.success) {
          let filterId = result.operationStatuses[0].uniqueKey;
          this._toastr.success(result.message, 'Create client');
          this.AddOrUpdateDynamicFilter = 'Save';
          this.cutomeFilterName = this.dynamicfilterObj.SavedFilterName;
          this.OnOpenClientList(filterId, this.cutomeFilterName);
          this.getSavedDynamicFilterNameList()
          this.onClearDynamicFilter();
          document.getElementById("ShowpopupStaticFilter").style.display = "none";
          this.ShowStaticSaveFilter = false;
          this.clearAllStaticFilter();
        }
        else {
          this._toastr.error(result.message, 'Create client');
        }
      }, error => { this._toastr.error(error.message, 'Create client') });
    }
    else {
      this.isFilterSavedName = true;
    }

  }
  closeStaticFilter() {
    document.getElementById("ShowpopupStaticFilter").style.display = "none";
  }

  showFilterCount(filterType) {
    if (this.filterName.substring(0, 3) == ' + ') {
      this.filterName = this.filterName.substring(3, this.filterName.length)
    }
    filterType = filterType.replace(' + ', '');
  }

  onSelectAllFilter() {

    this.isAllStatusSelected = true;
    this.isProspectStatusSelected = true
    this.isActiveStatusSelected = true
    this.isArchiveStatusSelected = true
    this.isLostStatusSelected = true
    this._clientService.GetClientCustomListSystemFilter(this.isAllStatusSelected, !this.isActiveStatusSelected, !this.isArchiveStatusSelected, !this.isProspectStatusSelected,
      this.isIndivisualEntitySelected, this.isCompanyEntitySelected, this.isPartnershipEntitySelected, this.isSMSFEntitySelected, this.isTustEntitySelected
    ).subscribe((response: any) => {
      if (response) {
        this.clients = response;
        this.allClientList = response;
        this.temp_clientFilter = response;
      }
    }, error => this._toastr.error("some thing went wrong please contact system administrator."));

  }
  onSelectDefaultFilter() {
    this.isAllStatusSelected = false;
    this.isProspectStatusSelected = false;
    this.isActiveStatusSelected = false;
    this.isArchiveStatusSelected = false;
    this.isLostStatusSelected = false;
    this._clientService.GetClientCustomListSystemFilter(true, false, false, false, false, false, false, false, false
    ).subscribe((response: any) => {
      if (response) {
        this.clients = response;
        this.allClientList = response;
        this.temp_clientFilter = response;
      }
    }, error => this._toastr.error("some thing went wrong please contact system administrator."));

  }

  onSelectPageLoadFilter() {
    this.isAllStatusSelected = false;
    this.isProspectStatusSelected = false;
    this.isActiveStatusSelected = true;
    this.isArchiveStatusSelected = false;
    this.isLostStatusSelected = false;
    this.filterName = 'Active';
    this._clientService.GetClientCustomListSystemFilter(true, true, false, false, false, false, false, false, false
    ).subscribe((response: any) => {
      if (response) {
        this.clients = response;
        this.allClientList = response;
        this.temp_clientFilter = response; this.sort('created_At');
      }
    }, error => this._toastr.error("some thing went wrong please contact system administrator."));
  }
  clearAllStaticFilter() {
    this.isActiveStatusSelected = false;
    this.isProspectStatusSelected = false;
    this.isLostStatusSelected = false;
    this.isArchiveStatusSelected = false;
    this.isCompanyEntitySelected = false;
    this.isIndivisualEntitySelected = false;
    this.isTustEntitySelected = false;
    this.isPartnershipEntitySelected = false;
    this.isSMSFEntitySelected = false;
  }


  getTagName(tagId) {
    const index = this.TagList.findIndex(x => x.tagId === tagId);

    let result = this.TagList[index].tagname;
    return result;
  }
  getLocationName(locId) {
    const index = this.location.findIndex(x => x.addressId === locId);

    let result = this.location[index].locationName;
    return result;
  }
  getPartnerName(partnerId) {
    const index = this.partnerList.findIndex(x => x.userId === partnerId);

    let result = this.partnerList[index].partnerName;
    return result;
  }
  getManagerName(managerId) {
    const index = this.ManagerList.findIndex(x => x.userId === managerId);

    let result = this.ManagerList[index].managerName;
    return result;
  }
  getContactName(contactId) {
    const index = this.ContactNameList.findIndex(x => x.contactId === contactId);

    let result = this.ContactNameList[index].contactName;
    return result;
  }
  getIndustryName(industryId) {
    const index = this.IndustryTypeList.findIndex(x => x.industryID === industryId);

    let result = this.IndustryTypeList[index].industryType;
    return result;
  }
  getTaxAgentName(taxAgentId) {
    const index = this.TaxAgentList.findIndex(x => x.taxAgentId === taxAgentId);

    let result = this.TaxAgentList[index].fullName;
    return result;
  }

  onAddLocation(locationId: any) {
    let isFoundDuplicate = false;
    if (this.LocationListPost.length != 0) {
      for (let i = 0; i < this.LocationListPost.length; i++) {
        if (locationId == this.LocationListPost[i].LocationID) {
          isFoundDuplicate = true;
          const index = this.LocationListPost.findIndex(x => x.LocationID === locationId);

          if (index > -1) {
            this.LocationListPost.splice(index, 1);
            break;
          }
        }
      }
    }

    else {
      this.LocationListPost.push({ LocationID: locationId });
    }

    if (!isFoundDuplicate) {
      this.LocationListPost.push({ LocationID: locationId });
    }
    this.LocationListPost = this.getUniqueListBy(this.LocationListPost, 'LocationID');

  }
  onCheckUncheckLoaction(locationId) {
    let result = false;
    for (let i = 0; i < this.CheckedLoaction.length; i++) {
      if (this.CheckedLoaction[i].LocationID == locationId) {
        result = true;
      }

    }
    return result;
  }

  onAddTag(TagId: any) {
    let isFoundDuplicate = false;
    if (this.TagListPost.length != 0) {
      for (let i = 0; i < this.TagListPost.length; i++) {
        if (TagId == this.TagListPost[i].TagId) {
          isFoundDuplicate = true;
          const index = this.TagListPost.findIndex(x => x.TagId === TagId);

          if (index > -1) {
            this.TagListPost.splice(index, 1);
            break;
          }
        }
      }
    }

    else {
      this.TagListPost.push({ TagId: TagId });
    }

    if (!isFoundDuplicate) {
      this.TagListPost.push({ TagId: TagId });
    }
    this.TagListPost = this.getUniqueListBy(this.TagListPost, 'TagId');


  }
  checkOrUnckeckTag(tagId) {
    let result = false
    for (let i = 0; i < this.CheckedTag.length; i++) {
      if (this.CheckedTag[i].TagId == tagId) {
        result = true
      }

    }
    return result;
  }

  onAddPartner(partnerId: any) {
    let isFoundDuplicate = false;
    if (this.partnerListPost.length != 0) {
      for (let i = 0; i < this.partnerListPost.length; i++) {
        if (partnerId == this.partnerListPost[i].PartnerId) {
          isFoundDuplicate = true;
          const index = this.partnerListPost.findIndex(x => x.PartnerId === partnerId);

          if (index > -1) {
            this.partnerListPost.splice(index, 1);
            break;
          }
        }
      }
    }

    else {
      this.partnerListPost.push({ PartnerId: partnerId });
    }

    if (!isFoundDuplicate) {
      this.partnerListPost.push({ PartnerId: partnerId });
    }
    this.partnerListPost = this.getUniqueListBy(this.partnerListPost, 'PartnerId');

  }
  checkOrUnckeckPartner(partnerId) {
    let result = false;
    for (let i = 0; i < this.Checkedpartner.length; i++) {
      if (this.Checkedpartner[i].PartnerId == partnerId) {
        result = true;
      }
    }
    return result;
  }

  onAddManager(ManagerId: any) {
    let isFoundDuplicate = false;
    if (this.ManagerListPost.length != 0) {
      for (let i = 0; i < this.ManagerListPost.length; i++) {
        if (ManagerId == this.ManagerListPost[i].ManagerID) {
          isFoundDuplicate = true;
          const index = this.ManagerListPost.findIndex(x => x.ManagerID === ManagerId);

          if (index > -1) {
            this.ManagerListPost.splice(index, 1);
            break;
          }
        }
      }
    }

    else {
      this.ManagerListPost.push({ ManagerID: ManagerId });
    }

    if (!isFoundDuplicate) {
      this.ManagerListPost.push({ ManagerID: ManagerId });
    }
    this.ManagerListPost = this.getUniqueListBy(this.ManagerListPost, 'ManagerID');
  }
  checkOrUnckeckManager(ManagerId: any) {
    let result = false;
    for (let i = 0; i < this.CheckedManager.length; i++) {
      if (this.CheckedManager[i].ManagerID == ManagerId) {
        result = true;
      }
    }
    return result;
  }

  onAddConatact(ConatctId: any) {
    let isFoundDuplicate = false;
    if (this.ContactNameListPost.length != 0) {
      for (let i = 0; i < this.ContactNameListPost.length; i++) {
        if (ConatctId == this.ContactNameListPost[i].ConatactID) {
          isFoundDuplicate = true;
          const index = this.ContactNameListPost.findIndex(x => x.ConatactID === ConatctId);

          if (index > -1) {
            this.ContactNameListPost.splice(index, 1);
            break;
          }
        }
      }
    }

    else {
      this.ContactNameListPost.push({ ConatactID: ConatctId });
    }

    if (!isFoundDuplicate) {
      this.ContactNameListPost.push({ ConatactID: ConatctId });
    }
    this.ContactNameListPost = this.getUniqueListBy(this.ContactNameListPost, 'ConatactID');
  }
  checkOrUnckeckContact(ConatctId: any) {
    let result = true;
    for (let i = 0; i < this.CheckedConatct.length; i++) {
      if (this.CheckedConatct[i].ConatctID == ConatctId) {
        result = true;
      }

    }
    return result;
  }

  onAddIndustry(industryId: any) {
    let isFoundDuplicate = false;
    if (this.IndustryTypeListPost.length != 0) {
      for (let i = 0; i < this.IndustryTypeListPost.length; i++) {
        if (industryId == this.IndustryTypeListPost[i].IndustryID) {
          isFoundDuplicate = true;
          const index = this.IndustryTypeListPost.findIndex(x => x.IndustryID === industryId);

          if (index > -1) {
            this.IndustryTypeListPost.splice(index, 1);
            break;
          }
        }
      }
    }

    else {
      this.IndustryTypeListPost.push({ IndustryID: industryId });
    }

    if (!isFoundDuplicate) {
      this.IndustryTypeListPost.push({ IndustryID: industryId });
    }
    this.IndustryTypeListPost = this.getUniqueListBy(this.IndustryTypeListPost, 'IndustryID');
  }
  checkOrUnckeckIndustry(industryId: any) {
    let result = false;
    for (let i = 0; i < this.CheckedIndustry.length; i++) {
      if (this.CheckedIndustry[i].IndustryID == industryId) {
        result = true;
      }

    }
    return result;
  }

  onAddTaxAgent(taxAgentId: any) {
    if (this.TaxAgentListPost.length != 0) {
      let isFoundDuplicate = false;
      if (this.TaxAgentListPost.length != 0) {
        for (let i = 0; i < this.TaxAgentListPost.length; i++) {
          if (taxAgentId == this.TaxAgentListPost[i].TaxAgentID) {
            isFoundDuplicate = true;
            const index = this.TaxAgentListPost.findIndex(x => x.TaxAgentID === taxAgentId);

            if (index > -1) {
              this.TaxAgentListPost.splice(index, 1);
              break;
            }
          }
        }
      }

      else {
        this.TaxAgentListPost.push({ TaxAgentID: taxAgentId });
      }

      if (!isFoundDuplicate) {
        this.TaxAgentListPost.push({ TaxAgentID: taxAgentId });
      }
      this.TaxAgentListPost = this.getUniqueListBy(this.TaxAgentListPost, 'TaxAgentID');
    }
  }
  checkOrUnckeckTaxAgent(taxAgentId: any) {
    let result = false;
    for (let i = 0; i < this.CheckedManager.length; i++) {
      if (this.CheckedManager[i].TaxAgentID == taxAgentId) {
        result = false;
      }

    }
    return result;
  }

  onAddStatus(StatusId: any) {
    let isFoundDuplicate = false;
    if (this.StatusTypePost.length != 0) {
      for (let i = 0; i < this.StatusTypePost.length; i++) {
        if (StatusId == this.StatusTypePost[i].StatusID) {
          isFoundDuplicate = true;
          const index = this.StatusTypePost.findIndex(x => x.StatusID === StatusId);

          if (index > -1) {
            this.StatusTypePost.splice(index, 1);
            break;
          }
        }
      }
    }

    else {
      this.StatusTypePost.push({ StatusID: StatusId });
    }

    if (!isFoundDuplicate) {
      this.StatusTypePost.push({ StatusID: StatusId });
    }
    this.StatusTypePost = this.getUniqueListBy(this.StatusTypePost, 'StatusID');


  }
  checkOrUncheckStatus(StatusId: any) {
    let result = false;
    for (let i = 0; i < this.CheckedStatus.length; i++) {
      if (this.CheckedStatus[i].StatusID == StatusId) {
        result = true;
        break;
      }

    }
    return result;
  }

  onAddEntityType(EntityTypeId: any) {
    let isFoundDuplicate = false;
    if (this.entityTypePost.length != 0) {
      for (let i = 0; i < this.entityTypePost.length; i++) {
        if (EntityTypeId == this.entityTypePost[i].EntityTypeID) {
          isFoundDuplicate = true;
          const index = this.entityTypePost.findIndex(x => x.EntityTypeID === EntityTypeId);

          if (index > -1) {
            this.entityTypePost.splice(index, 1);
            break;
          }
        }
      }
    }

    else {
      this.entityTypePost.push({ EntityTypeID: EntityTypeId });
    }

    if (!isFoundDuplicate) {
      this.entityTypePost.push({ EntityTypeID: EntityTypeId });
    }
    this.entityTypePost = this.getUniqueListBy(this.entityTypePost, 'EntityTypeID');

  }
  checkOrUncheckEntityType(EntityTypeId: any) {
    let result = false
    for (let i = 0; i < this.CheckedEntity.length; i++) {
      if (this.CheckedEntity[i].EntityTypeID == EntityTypeId) {
        result = true;
      }

    }
    return result;
  }
  getUniqueListBy(arr, key) {
    return [...new Map(arr.map(item => [item[key], item])).values()]
  }

  captureRangeValueOfWIP(event) {

    this.dynamicfilterObj.WIP = (event.target.value);
  }

  captureRangeValueOfAnnualIncome(event) {

    this.dynamicfilterObj.AnnualIncome = (event.target.value);
  }

  onAddFollowupDate(Date: any) {
    if (Date == 'today') {
      this.dynamicfilterObj.FollowupDate = '';
      let date = new Date();
      let latest_date = this.datePipe.transform(date, 'yyyy-MM-dd');
      this.NextFollowupDatePost.push({ DateRange: 'Today', StartDate: latest_date, EndDate: latest_date });

    }
    if (Date == 'yesterday') {
      this.dynamicfilterObj.FollowupDate = '';
      let StrDate = new Date();
      StrDate = this.datePipe.transform(StrDate, 'yyyy-MM-dd');
      let date = new Date();
      date.setDate(date.getDate() - 1);

      date = this.datePipe.transform(date, 'yyyy-MM-dd');
      this.NextFollowupDatePost.push({ DateRange: 'yesterday', StartDate: StrDate, EndDate: date });
    }
    if (Date == 'Currentmonth') {
      this.dynamicfilterObj.FollowupDate = '';

    }
    if (Date == 'PastMonth') {
      this.dynamicfilterObj.FollowupDate = '';

    }
    if (Date == 'PastMonthThreeMonth') {
      this.dynamicfilterObj.FollowupDate = '';
    }
  }

  onAddGSTRegistred(value: any) {
    if (value == 'yes') {
      this.GSTRegisteredPost = 'Yes';
    }
    if (value == 'no') {
      this.GSTRegisteredPost = 'No';
    }
    if (value == 'na') {
      this.GSTRegisteredPost = 'NA';
    }
    this.dynamicfilterObj.GstRegisted = this.GSTRegisteredPost;
  }

  onCheckIsTaxAgent(value: any) {
    this.TaxClientPost = value == 'yes' ? true : false;
    this.dynamicfilterObj.isTaxAgent = this.TaxClientPost;
  }
  AddFilterName(event) {
    this.dynamicfilterObj.SavedFilterName = (event.target.value);
  }

  getSavedDynamicFilterNameList() {
    this._clientService.GetCustomeDynamicFilterList().subscribe(result => {
      if (result) {
        this.SavedDynamicFilterList = result

      }
      else {
        this._toastr.error(result.message, 'Create client');
      }
    })
  }

  onBookMarkDynamicFilter(filterId, isBookmarked) {
    let isDeleted = false;
    isBookmarked = !(isBookmarked == 0 ? false : true);
    this._clientService.DeleteAndUpdateDynamicFilter(filterId, false, isBookmarked).subscribe(result => {
      if (result) {
        this.getSavedDynamicFilterNameList();
        if (isBookmarked) {
          this._toastr.success("Filter name saved as favroite", 'Create client');
        } else {
          this._toastr.success("Filter name removed as favroite", 'Create client');
        }
      }
      else {
        this._toastr.error(result.message);
      }
    })
  }

  onDeleteDynamicFiletr(filterId, isBookmarked, name) {
    isBookmarked = isBookmarked == '0' ? false : true;
    if (confirm("Are you sure you want to delete" + " '" + name + "' ?")) {
      this._clientService.DeleteAndUpdateDynamicFilter(filterId, true, isBookmarked).subscribe(result => {
        if (result) {
          this.getSavedDynamicFilterNameList();
        }
        else {
          this._toastr.error(result.message);
        }
      })
    }
  }

  onClearDynamicFilter() {
    this.CheckedLoaction = [];
    this.CheckedTag = [];
    this.CheckedStatus = [];
    this.CheckedEntity = [];
    this.CheckedManager = [];
    this.Checkedpartner = [];
    this.CheckedConatct = [];
    this.CheckedIndustry = [];
    this.CheckedTaxAgent = [];
    this.CheckedLoaction = [];
    this.CheckedTag = [];
    this.CheckedStatus = [];
    this.CheckedEntity = [];
    this.CheckedManager = [];
    this.Checkedpartner = [];
    this.CheckedConatct = [];
    this.CheckedIndustry = [];
    this.CheckedTaxAgent = [];

    this.dynamicfilterObj = new DynaicFilterPost();

  }

  onEditDynamicFilter(filterId) {
    this.DynamicfilterId = filterId;
    this.AddOrUpdateDynamicFilter = 'Update';
    this._clientService.GetCustomeDynamicFilterListByFilterId(Number(filterId)).subscribe(result => {
      if (result) {
        let response = result;
        this.dynamicfilterObj.FilterId = result[0].filterId;
        this.LocationListPost = JSON.parse(result[0].location);
        this.CheckedLoaction = JSON.parse(result[0].location);
        this.dynamicfilterObj.SavedFilterName = (result[0].savedFilterName)
        this.TagListPost = JSON.parse(result[0].tag);
        this.CheckedTag = JSON.parse(result[0].tag);

        this.partnerListPost = JSON.parse(result[0].partner);
        this.Checkedpartner = JSON.parse(result[0].partner);
        this.ManagerListPost = JSON.parse(result[0].manager);
        this.CheckedManager = JSON.parse(result[0].manager);
        this.ContactNameListPost = JSON.parse(result[0].contact);
        this.CheckedConatct = JSON.parse(result[0].contact);
        this.IndustryTypeListPost = JSON.parse(result[0].industry);
        this.CheckedIndustry = JSON.parse(result[0].industry);
        this.TaxAgentListPost = JSON.parse(result[0].taxAgent);
        this.CheckedTaxAgent = JSON.parse(result[0].taxAgent);
        this.StatusTypePost = JSON.parse(result[0].status);
        this.CheckedStatus = JSON.parse(result[0].status);
        this.NextFollowupDatePost = JSON.parse(result[0].followupDate)
        this.entityTypePost = JSON.parse(result[0].entityTypeName);
        this.CheckedEntity = JSON.parse(result[0].entityTypeName);
        this.WIPPost = result[0].wip == '' ? '0' : result[0].wip;
        this.dynamicfilterObj.WIP = result[0].wip == '' ? '0' : result[0].wip;
        this.AnnualIncomePost = result[0].annualIncome == '' ? '0' : result[0].annualIncome;
        this.dynamicfilterObj.AnnualIncome = result[0].annualIncome == '' ? '0' : result[0].annualIncome;
        this.GSTRegisteredPost = result[0].gstRegisted;
        this.dynamicfilterObj.GstRegisted = result[0].gstRegisted;
        this.TaxClientPost = result[0].isTaxAgent;
        this.dynamicfilterObj.isTaxAgent = result[0].isTaxAgent;
        this.dynamicfilterObj.isFavorite = result[0].isFavroite;
        this.PopUpOn();
      }
      else {
        this._toastr.error(result.message);
      }
    })
  }

  onShowList() {
    if (this.dynamicfilterObj.SavedFilterName != undefined) {
      this.isFilterSavedName = false;
      this.LocationListPost = JSON.stringify(this.LocationListPost);
      this.dynamicfilterObj.Location = this.LocationListPost;
      this.dynamicfilterObj.Tag = JSON.stringify(this.TagListPost);
      this.dynamicfilterObj.Partner = JSON.stringify(this.partnerListPost);
      this.dynamicfilterObj.Manager = JSON.stringify(this.ManagerListPost);
      this.dynamicfilterObj.Contact = JSON.stringify(this.ContactNameListPost);
      this.dynamicfilterObj.Industry = JSON.stringify(this.IndustryTypeListPost);
      this.dynamicfilterObj.TaxAgent = JSON.stringify(this.TaxAgentListPost);
      this.dynamicfilterObj.Industry = JSON.stringify(this.IndustryTypeListPost);
      this.dynamicfilterObj.Status = JSON.stringify(this.StatusTypePost);
      this.dynamicfilterObj.FollowupDate = JSON.stringify(this.NextFollowupDatePost)
      this.dynamicfilterObj.EntityTypeName = JSON.stringify(this.entityTypePost);
      this.dynamicfilterObj.WIP = this.dynamicfilterObj.WIP;
      this.dynamicfilterObj.AnnualIncome = this.dynamicfilterObj.AnnualIncome;
      this.dynamicfilterObj.GstRegisted = this.GSTRegisteredPost;
      this.dynamicfilterObj.isTaxAgent = this.TaxClientPost;
      this.dynamicfilterObj.FilterId = this.dynamicfilterObj.FilterId == 0 ? 0 : this.dynamicfilterObj.FilterId;
      this.dynamicfilterObj.isFavorite = this.dynamicfilterObj.isFavorite;
      this._clientService.PostDynamicFilter(this.dynamicfilterObj).subscribe(result => {
        if (result.success) {
          let filterId = result.operationStatuses[0].uniqueKey;
          this._toastr.success(result.message, 'Create client');
          this.AddOrUpdateDynamicFilter = 'Save';
          this.cutomeFilterName = this.dynamicfilterObj.SavedFilterName;
          this.OnOpenClientList(filterId, this.cutomeFilterName);
          this.getSavedDynamicFilterNameList()
          this.onClearDynamicFilter();
          this.clearAllStaticFilter();
        }
        else {
          this._toastr.error(result.message, 'Create client');
        }
      }, error => { this._toastr.error(error.message) });
    }
    else {
      this.isFilterSavedName = true;
    }
  }
  onShowSelectedFilter() {
    document.getElementById("id01").style.display = "none";
    document.getElementById("Showpopup").style.display = "none";

  }

  OnOpenClientList(filterId: any, filter) {
    this.isActiveStatusSelected = false;
    this._clientService.getClientListByCustomeFilter(filterId).subscribe(result => {
      if (result) {
        this.clients = result;
      }
      else {
        this._toastr.error(result.message, 'Create client');
      }
    })
    this.cutomeFilterName = filter;
    this.filterName = ''
  }

  removeAllStatusFileter() {
    this.isAllStatusSelected = false;
    this.isActiveStatusSelected = false;
    this.isProspectStatusSelected = false;
    this.isArchiveStatusSelected = false;
    this.isLostStatusSelected = false;
  }
  removeAllEntityFileter() {
    this.isIndivisualEntitySelected = false;
    this.isCompanyEntitySelected = false;
    this.isPartnershipEntitySelected = false;
    this.isTustEntitySelected = false;
    this.isSMSFEntitySelected = false;
  }
  closetags() {
    document.getElementById('close_btags').click();
    this.ClientTagsbyId = [];
  }


  exportClientToCsv() {
    let _filename = 'ClientList.csv';
    this._clientService.GetCustomClientListExport().subscribe((response: any) => {
      if (response) {
        this.exportToCsv(_filename, response);
      }
    }, error => this._toastr.error("some thing went wrong"));
  }

  exportToCsv(filename: string, rows: object[]) {
    if (!rows || !rows.length) {
      return;
    }
    const separator = ',';
    const keys = Object.keys(rows[0]);
    const csvData =
      keys.join(separator) +
      '\n' +
      rows.map(row => {
        return keys.map(k => {
          let cell = row[k] === null || row[k] === undefined ? '' : row[k];
          cell = cell instanceof Date
            ? cell.toLocaleString()
            : cell.toString().replace(/"/g, '""');
          if (cell.search(/("|,|\n)/g) >= 0) {
            cell = `"${cell}"`;
          }
          return cell;
        }).join(separator);
      }).join('\n');
    const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
    if (navigator.msSaveBlob) {
      navigator.msSaveBlob(blob, filename);
    } else {
      const link = document.createElement('a');
      if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', filename);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  }

  onPhoneValidate() {



    if (this.phonestring1 != undefined && this.phonestring1 != '') {
      if (this.phonestring1.length == 10) {
        this._phone1Validator = false;
        if (this.phonebookmark2 || this.phonebookmark3) {
          this.phonebookmark1 = false;
        }
        else {
          this.phonebookmark1 = true;
        }
      }
      else {
        this._phone1Validator = true;
      }
    } else {
      this._phone1Validator = false;
    }


    if (this.phonestring2 != undefined && this.phonestring2 != '') {
      if (this.phonestring2.length == 10) {
        this._phone2Validator = false;
      }
      else {
        this._phone2Validator = true;
      }
    } else {
      this._phone2Validator = false;
    }


    if (this.phonestring3 != undefined && this.phonestring3 != '') {
      if (this.phonestring3.length == 10) {
        this._phone3Validator = false;
      }
      else {
        this._phone3Validator = true;
      }
    } else {
      this._phone3Validator = false;
    }
    return true;
  }
  public _phone4Validator: boolean = false;
  public _phone5Validator: boolean = false;
  public _phone6Validator: boolean = false;

  onPhoneValidatecontact() {

    if (this.phonestring4 != undefined && this.phonestring4 != '') {
      if (this.phonestring4.length == 10) {
        this._phone4Validator = false;
      }
      else {
        this._phone4Validator = true;
      }
    } else {
      this._phone4Validator = false;
    }


    if (this.phonestring5 != undefined && this.phonestring5 != '') {
      if (this.phonestring5.length == 10) {
        this._phone5Validator = false;
      }
      else {
        this._phone5Validator = true;
      }
    } else {
      this._phone5Validator = false;
    }


    if (this.phonestring6 != undefined && this.phonestring6 != '') {
      if (this.phonestring6.length == 10) {
        this._phone6Validator = false;
      }
      else {
        this._phone6Validator = true;
      }
    } else {
      this._phone6Validator = false;
    }
    return true;
  }

  phoneValidation() {
    return (this._phone1Validator || this._phone2Validator || this._phone3Validator);
  }

  phoneValidationcontact() {
    return (this._phone4Validator || this._phone5Validator || this._phone6Validator);
  }
  onChangeEType(etype) {
    if (!this.IseditClient) {
      if (etype != undefined && etype != null && etype > 0 && !this.IseditClient) {
        this.clientDataModal.resident = true;
      }
      else {
        this.IsIndividual = false;
      }
    }
    if (etype != undefined && etype != null && etype > 0) {
      if (etype == "1") {
        this.IsIndividual = true;
      }
      else {
        this.IsIndividual = false;
      }
    }
    this.ValidateEmail1();
  }

  taxValidation() {
    return (this._tfnValidateStatus || this._abnValidateStatus || this._acnValidateStatus);
  }

  tfnValidate() {
    this.TFNMessage = '';

    const raw = String(this.clientDataModal?.tFN ?? '');
    const cleanTFN = raw.replace(/\D/g, '');

    if (cleanTFN === '') {
      this._tfnValidateStatus = false;
      return;
    }

    if (cleanTFN.length > 0 && cleanTFN.length !== 8 && cleanTFN.length !== 9) {
      this._tfnValidateStatus = true;
      this.TFNMessage = 'TFN must be 8 or 9 digits.';
      return;
    }


    if (cleanTFN.length > 0 && (!/^\d+$/.test(cleanTFN) || /^0+$/.test(cleanTFN))) {
      this._tfnValidateStatus = true;
      this.TFNMessage = 'Invalid TFN.';
      return;
    }

    const digits = cleanTFN.split('').map(d => parseInt(d, 10));
    let sum = 0;

    if (digits.length === 8 || digits.length === 9) {
      sum = (digits[0] * 10)
        + (digits[1] * 7)
        + (digits[2] * 8)
        + (digits[3] * 4)
        + (digits[4] * 6)
        + (digits[5] * 3)
        + (digits[6] * 5)
        + (digits[7] * (digits.length === 8 ? 1 : 2));

      if (digits.length === 9) {
        sum += digits[8] * 1;
      }

      const isValid = sum % 11 === 0 && sum !== 0;
      this._tfnValidateStatus = !isValid;

      if (isValid) {
        this.validateTFN(this.clientDataModal.clientId, cleanTFN);
      } else {
        this.TFNMessage = 'Invalid TFN checksum.';
      }
    }
  }

  public TFNMessage: string = '';

  tfnValidateInNoPriacyPermission() {
    this.TFNMessage = '';

    const raw = String(this.noPermissionTFNData ?? '').replace(/\s+/g, '');


    if (!raw) {
      this._tfnValidateStatus = false;
      this.clientDataModal.tFN = this._CurrentTFNData;
      return;
    }


    if (!/^\d+$/.test(raw)) {
      this._tfnValidateStatus = true;
      this.TFNMessage = 'Invalid TFN format.';
      return;
    }


    if (/^0+$/.test(raw)) {
      this._tfnValidateStatus = true;
      this.TFNMessage = 'Invalid TFN.';
      return;
    }

    const digits = raw.split('').map(d => parseInt(d, 10));


    if (digits.length !== 8 && digits.length !== 9) {
      this._tfnValidateStatus = true;
      this.TFNMessage = 'TFN must be 8 or 9 digits.';
      return;
    }

    const weights = digits.length === 8 ? [10, 7, 8, 4, 6, 3, 5, 1] : [10, 7, 8, 4, 6, 3, 5, 2, 1];


    let sum =
      digits[0] * weights[0] +
      digits[1] * weights[1] +
      digits[2] * weights[2] +
      digits[3] * weights[3] +
      digits[4] * weights[4] +
      digits[5] * weights[5] +
      digits[6] * weights[6] +
      digits[7] * weights[7];

    if (digits.length === 9) {
      sum += digits[8] * weights[8];
    }

    const isValid = sum % 11 === 0 && sum !== 0;

    this._tfnValidateStatus = !isValid;

    if (isValid) {
      this.clientDataModal.tFN = raw;
      this.validateTFN(this.clientDataModal.clientId, raw);
    } else {
      this.TFNMessage = 'Invalid TFN checksum.';
    }
  }

  validateTFN(clientId, tfn) {

    if (!this.isEditMode && clientId == undefined) {
      clientId = 0;
    }
    this._clientService.ValidateFinancialData('TFN', clientId, tfn).subscribe((response: any) => {

      if (response != undefined && response.length > 0) {
        this.TFNMessage = 'TFN already in use for "' + response[0].clientName + '" client';
      }
    })
  }
  BSBValidateInNoPriacyPermission() {
    if (this.noPermissionBSBData != undefined && this.noPermissionBSBData != null && this.noPermissionBSBData != '') {
      this.clientDataModal.bankBSB = this.noPermissionBSBData;
    }
  }
  BankAccNoValidateInNoPriacyPermission() {
    if (this.noPermissionAccountNumberData != undefined && this.noPermissionAccountNumberData != null && this.noPermissionAccountNumberData != '') {
      this.clientDataModal.bankAccountnumber = this.noPermissionAccountNumberData;
    }
  }
  abnValidate() {
    this._abnValidateStatus = false;
    this._isABNExist = false;
    if (this.clientDataModal.aBN != undefined && this.clientDataModal.aBN != '') {
      let _abnNuber = this.clientDataModal.aBN.replace(' ', '').replace(' ', '').replace(' ', '').replace(' ', '');

      let isNumber = /^[0-9]+$/.test(_abnNuber);
      if (!isNumber) {
        this._abnValidateStatus = true;
      }
      let digits = _abnNuber.split('');
      if (digits.length == 11) {
        let sum = ((parseInt(digits[0]) > 0 ? parseInt(digits[0]) - 1 : parseInt(digits[0])) * 10)
          + (parseInt(digits[1]) * 1)
          + (parseInt(digits[2]) * 3)
          + (parseInt(digits[3]) * 5)
          + (parseInt(digits[4]) * 7)
          + (parseInt(digits[5]) * 9)
          + (parseInt(digits[6]) * 11)
          + (parseInt(digits[7]) * 13)
          + (parseInt(digits[8]) * 15)
          + (parseInt(digits[9]) * 17)
          + (parseInt(digits[10]) * 19);

        let remainder = sum % 89;

        if (remainder == 0 && digits.length == 11 && sum != 0) {
          this._abnValidateStatus = false;
          this.checkABNExist(this._TempClientId, _abnNuber);
        } else {
          this._abnValidateStatus = true;
          this._isABNExist = false;
        }
        return;
      }

      if (digits.length != 11) {
        this._abnValidateStatus = true;
        this._isABNExist = false;
      }
      else {
        this._abnValidateStatus = false;
      }
    }
    else {
      this._abnValidateStatus = false;
    }
  }

  dinValidate() {
    let sum;
    if (this.clientDataModal.dIN != undefined && this.clientDataModal.dIN != '') {
      let _dinNumber = this.clientDataModal.dIN.replace(' ', '').replace(' ', '');
      let isNumber = /^[0-9]+$/.test(_dinNumber);
      let digits = _dinNumber.split('');
      if (digits.length == 15) {
        sum = ((parseInt(digits[0]) > 0 ? parseInt(digits[0]) - 1 : parseInt(digits[0])) * 10)
          + (parseInt(digits[1]) * 1)
          + (parseInt(digits[2]) * 3)
          + (parseInt(digits[3]) * 5)
          + (parseInt(digits[4]) * 7)
          + (parseInt(digits[5]) * 9)
          + (parseInt(digits[6]) * 11)
          + (parseInt(digits[7]) * 13)
          + (parseInt(digits[8]) * 15);
      }
      if (!isNumber || sum == 0 || digits.length != 15) {
        this._dinValidateStatus = true;
        return;
      } else {
        this._dinValidateStatus = false;
      }
    }
    else {
      this._dinValidateStatus = false;
    }
  }
  dinValidateInNoPriacyPermission() {
    let tempdata = this.noPermissionDINData;
    let sum;
    if (this.noPermissionDINData != undefined && this.noPermissionDINData != '') {
      let _dinNumber = this.noPermissionDINData.replace(' ', '').replace(' ', '');
      this.clientDataModal.dIN = tempdata;
      let isNumber = /^[0-15]+$/.test(_dinNumber);
      let digits = _dinNumber.split('');
      if (digits.length == 15) {
        sum = ((parseInt(digits[0]) > 0 ? parseInt(digits[0]) - 1 : parseInt(digits[0])) * 10)
          + (parseInt(digits[1]) * 1)
          + (parseInt(digits[2]) * 3)
          + (parseInt(digits[3]) * 5)
          + (parseInt(digits[4]) * 7)
          + (parseInt(digits[5]) * 9)
          + (parseInt(digits[6]) * 11)
          + (parseInt(digits[7]) * 13)
          + (parseInt(digits[8]) * 15);
      }
      if (!isNumber || sum == 0) {
        this._dinValidateStatus = true;
        return;
      }
      else {
        this._dinValidateStatus = false;
      }
    }
    else {
      this._dinValidateStatus = false;
      this.clientDataModal.dIN = this._CurrentDINData;
    }
  }

  acnValidate() {
    if (this.clientDataModal.aCN != undefined && this.clientDataModal.aCN != '') {
      let _acnNuber = this.clientDataModal.aCN.replace(' ', '').replace(' ', '').replace(' ', '');
      let isNumber = /^[0-8]+$/.test(_acnNuber);
      if (!isNumber) {
        this._acnValidateStatus = true;
      }

      let digits = _acnNuber.split('');
      if (digits.length == 9) {
        let sum = (parseInt(digits[0]) * 8)
          + (parseInt(digits[1]) * 7)
          + (parseInt(digits[2]) * 6)
          + (parseInt(digits[3]) * 5)
          + (parseInt(digits[4]) * 4)
          + (parseInt(digits[5]) * 3)
          + (parseInt(digits[6]) * 2)
          + (parseInt(digits[7]) * 1);

        let _lastDigit = parseInt(digits[8]);


        let remainder = sum % 10;

        let _complementVal = remainder === 0 ? 0 : 10 - remainder;

        if (_lastDigit == _complementVal && digits.length == 9) {
          this._acnValidateStatus = false;
          this.checkACNExist(this._TempClientId, _acnNuber);
        } else {
          this._acnValidateStatus = true;
          this._isACNExist = false;
        }
        return;
      }

      if ((digits.length != 9)) {
        this._acnValidateStatus = true;
        this._isACNExist = false;
      }
      else {
        this._acnValidateStatus = false;
      }
    }
    else {
      this._acnValidateStatus = false;
    }
  }

  setPhonePreferredAndImportant(index: number, phone: string) {
    if(phone !== '') {
      if(this.phones.length != 0 && index == 0) {
        this.setPreferredPhone(index, true);
      if(!this.phones.some(i => i.isFavourite)) {
        this.setStartedPhone(index, true);
      }
      }
    } else {
      if(this.phones.length != 0 && index == 0) {
        this.setPreferredPhone(index, false);
        this.setStartedPhone(index, false);
      }
    }
    const validPhones = this.phones.filter(item => item.isValidPhone);
    if(validPhones.length > 1) {
      const typeMap = new Map<string, Set<string>>();
      const preferredByType = new Map<string, boolean>();

      for (const item of validPhones) {

        const typeId = String(item.phoneTypeId);
        const phone = item.phoneNumber?.trim().toLowerCase();

        if (!phone) {
          continue;
        }

        // ---------- Point 2: Duplicate phone check per phoneTypeId ----------
        if (!typeMap.has(typeId)) {
          typeMap.set(typeId, new Set());
        }

        const phoneSet = typeMap.get(typeId)!;

        if (phoneSet.has(phone)) {
          this._toastr.error(
            `Duplicate phone "${item.phoneNumber}" found for the same Phone Type.`,
            'Create/Update client'
          );
          this.phones = this.phones.map(current =>
            current === item
              ? {
                ...current,
                phoneNumber: '',
                isPreferred: false,
                isFavourite: false
              }
              : current
          );
          if(!this.phones.some(e => e.isFavourite)) {
            this.setStartedPhone(0, true);
          }
          return;
        }

        phoneSet.add(phone);

        // ---------- Point 1: Only first preferred per phoneTypeId ----------
        if (!preferredByType.has(typeId)) {
          if (item.isPreferred) {
            preferredByType.set(typeId, true);
          } else {
            // assign only if none marked preferred yet
            const hasAnyPreferred = validPhones.some(
              e => String(e.phoneTypeId) === typeId && e.isPreferred
            );

            if (!hasAnyPreferred) {
              item.isPreferred = true;
              preferredByType.set(typeId, true);
            } else {
              item.isPreferred = false;
            }
          }
        } else {
          item.isPreferred = false;
        }
      }
    }
  }

  setEmailPreferredAndImportant(index: number, email: string) {
    if(email !== '') {
      if(this.emails.length != 0 && index == 0) {
        if(!this.emails.some(e => e.isPreferred)) {
          this.setPreferredEmail(index, true);
        }
        if(!this.emails.some(e => e.isFavourite)) {
          this.setStartedEmail(index, true);
        }
      }
    } else {
      if(this.emails.length != 0) {
        this.setPreferredEmail(index, false);
        this.setStartedEmail(index, false);
      }
    }
    if(this.emails.length > 1) {
      const typeMap = new Map<string, Set<string>>();
      const preferredByType = new Map<string, boolean>();

      for (const item of this.emails) {

        const typeId = String(item.emailTypeId);
        const email = item.emailId?.trim().toLowerCase();

        if (!email) {
          continue;
        }

        // ---------- Point 2: Duplicate email check per emailTypeId ----------
        if (!typeMap.has(typeId)) {
          typeMap.set(typeId, new Set());
        }

        const emailSet = typeMap.get(typeId)!;

        if (emailSet.has(email)) {
          this._toastr.error(
            `Duplicate email "${item.emailId}" found for the same Email Type.`,
            'Create/Update client'
          );
          item.emailId = '';
          item.isPreferred = false;
          item.isFavourite = false;
          if(!this.emails.some(e => e.isFavourite)) {
            this.setStartedEmail(0, true);
          }
        }

        emailSet.add(email);

        // ---------- Point 1: Only first preferred per emailTypeId ----------
        if (!preferredByType.has(typeId)) {
          if (item.isPreferred) {
            preferredByType.set(typeId, true);
          } else {
            // assign only if none marked preferred yet
            const hasAnyPreferred = this.emails.some(
              e => String(e.emailTypeId) === typeId && e.isPreferred
            );

            if (!hasAnyPreferred) {
              item.isPreferred = true;
              preferredByType.set(typeId, true);
            } else {
              item.isPreferred = false;
            }
          }
        } else {
          item.isPreferred = false;
        }
      }
    }
  }

  updateFavouriteEmail() {
    // get all valid emails
    const validEmails = this.emails.filter(e => e.emailId && e.emailId.trim() !== '');

    // check if any valid email is already favourite
    const hasValidFavourite = validEmails.some(e => e.isFavourite);

    if (hasValidFavourite) return;

    // reset all favourites
    this.emails.forEach(e => e.isFavourite = false);

    // assign to first valid email
    if (validEmails.length > 0) {
      const firstValid = this.emails.find(e => e.emailId && e.emailId.trim() !== '');
      if (firstValid) {
        firstValid.isFavourite = true;
      }
    }
  }

  updateFavouritePhone() {
    const validPhones = this.phones.filter(e => e.phoneNumber && e.phoneNumber.trim() !== '' && e.isValidPhone);
    const hasValidFavourite = validPhones.some(e => e.isFavourite);
    if (hasValidFavourite) return;
    this.phones.forEach(e => e.isFavourite = false);
    if (validPhones.length > 0) {
      const firstValid = this.phones.find(e => e.phoneNumber && e.phoneNumber.trim() !== '' && e.isValidPhone);
      if (firstValid) {
        firstValid.isFavourite = true;
      }
    }
  }

  ValidateEmail1() {
    if (this.ValidateEmail(this.emailstring1)) {
      if (this.emailbookmark2 || this.emailbookmark3) {
        this.emailbookmark1 = false;
      }
      else {
        this.emailbookmark1 = true;
      }
      return true
    }
    else if (this.emailstring1 == undefined) {
      this.emailstring1 = '';
    }
    else {
      this.emailbookmark1 = false;
    }
  }
  
  ValidateEmail2() {
    if (this.ValidateEmail(this.emailstring2))
      return true
    else {

      this.emailstring2 = '';
    }
  }
  ValidateEmail3() {
    if (this.ValidateEmail(this.emailstring3))
      return true
    else {
      this.emailstring3 = '';
    }
  }

  ValidateEmail4() {
    if (this.ValidateEmail(this.emailstring4))
      return true
    else {
      this._toastr.error("Please enter valid email address.");
      this.emailstring4 = '';
    }
  }

  ValidateEmail5() {
    if (this.ValidateEmail(this.emailstring5))
      return true
    else {
      this._toastr.error("Please enter valid email address.");
      this.emailstring5 = '';
    }
  }

  ValidateEmail6() {
    if (this.ValidateEmail(this.emailstring6))
      return true
    else {
      this._toastr.error("Please enter valid email address.");
      this.emailstring6 = '';
    }
  }

  public pattern: any = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  ValidateEmail(email) {
    if (/(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/.test(email)) {
      return (true)
    }
    return (false)
  }

  public ValidateLinked = true;
  ValidateLinkedinUrl() {
    let linkedin_url: string = '';
    if (this.clientDataModal.linkedinprofileID != '' && this.clientDataModal.linkedinprofileID != undefined) {
      linkedin_url = this.clientDataModal.linkedinprofileID;
      if (/(ftp|http|https):\/\/?(?:www\.)?au.linkedin.com(\w+:{0,1}\w*@)?(\S+)(:([0-9])+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/.test(this.clientDataModal.linkedinprofileID)) {
        this.ValidateLinked = true
      }
      else if (/au.linkedin.com(\w+:{0,1}\w*@)?(\S+)(:([0-9])+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/.test(linkedin_url)) {
        this.ValidateLinked = true
      }
      else if (/linkedin.com(\w+:{0,1}\w*@)?(\S+)(:([0-9])+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/.test(linkedin_url)) {
        this.ValidateLinked = true
      }
      else if (/(ftp|http|https):\/\/?(?:www\.)?linkedin.com(\w+:{0,1}\w*@)?(\S+)(:([0-9])+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/.test(linkedin_url)) {
        this.ValidateLinked = true
      }
      else {
        this.ValidateLinked = false
      }
    }
    else {
      this.ValidateLinked = true
    }
  }

  public ValidateContactLinked = true;
  ValidateContactLinkedinUrl() {
    let linkedin_url: string = '';
    if (this.contactDataModal.linkedinprofileID != '' && this.contactDataModal.linkedinprofileID != undefined) {
      linkedin_url = this.contactDataModal.linkedinprofileID;
      if (/(ftp|http|https):\/\/?(?:www\.)?au.linkedin.com(\w+:{0,1}\w*@)?(\S+)(:([0-9])+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/.test(this.contactDataModal.linkedinprofileID)) {
        this.ValidateContactLinked = true
      }
      else if (/au.linkedin.com(\w+:{0,1}\w*@)?(\S+)(:([0-9])+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/.test(linkedin_url)) {
        this.ValidateContactLinked = true
      }
      else if (/linkedin.com(\w+:{0,1}\w*@)?(\S+)(:([0-9])+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/.test(linkedin_url)) {
        this.ValidateContactLinked = true
      }
      else if (/(ftp|http|https):\/\/?(?:www\.)?linkedin.com(\w+:{0,1}\w*@)?(\S+)(:([0-9])+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/.test(linkedin_url)) {
        this.ValidateContactLinked = true
      }
      else {
        this.ValidateContactLinked = false
      }
    }
    else {
      this.ValidateContactLinked = true
    }
  }

  public ShowPostal: boolean;
  ShowPostalAddress() {
    this.clientDataModal.isSamePhysical = !this.clientDataModal.isSamePhysical;
    if (this.clientDataModal.isSamePhysical) {
      this.ShowPostal = false;
      this.clientDataModal.postaladdressline1 = this.clientDataModal.physicaladdressline1;
      this.clientDataModal.postaladdressline2 = this.clientDataModal.physicaladdressline2;
      this.clientDataModal.postalcountry = this.clientDataModal.physicalcountry == undefined ? '13' : this.clientDataModal.physicalcountry;
      this.onChangeContactCountry1(this.clientDataModal.postalcountry);
      this.clientDataModal.postalstate = this.clientDataModal.physicalstate;
      this.clientDataModal.postalsuburb = this.clientDataModal.physicalsuburb;
      this.clientDataModal.postalpostcode = this.clientDataModal.physicalpostcode;
    }
    else {
      this.ShowPostal = true;
      this.clientDataModal.postaladdressline1 = null;
      this.clientDataModal.postaladdressline2 = null;
      this.clientDataModal.postalcountry = this.clientDataModal.physicalcountry == undefined ? '13' : this.clientDataModal.physicalcountry;
      this.onChangeContactCountry1(this.clientDataModal.postalcountry);
      this.clientDataModal.postalstate = undefined;
      this.clientDataModal.postalsuburb = null;
      this.clientDataModal.postalpostcode = null;
    }
  }

  public ShowContactPostal: boolean;
  ShowPostalForAddress() {
    this.contactDataModal.isSamePhysical = !this.contactDataModal.isSamePhysical;
    if (this.contactDataModal.isSamePhysical) {
      this.ShowContactPostal = false;
      this.contactDataModal.postaladdressline1 = this.contactDataModal.physicaladdressline1;
      this.contactDataModal.postaladdressline2 = this.contactDataModal.physicaladdressline2;
      this.contactDataModal.postalcountry = this.contactDataModal.physicalcountry == undefined ? '13' : this.contactDataModal.physicalcountry;
      this.onChangeContactCountry3(this.contactDataModal.postalcountry);
      this.contactDataModal.postalstate = this.contactDataModal.physicalstate;
      this.contactDataModal.postalsuburb = this.contactDataModal.physicalsuburb;
      this.contactDataModal.postalpostcode = this.contactDataModal.physicalpostcode;
    }
    else {
      this.ShowContactPostal = true;
      this.contactDataModal.postaladdressline1 = null;
      this.contactDataModal.postaladdressline2 = null;
      this.contactDataModal.postalcountry = this.contactDataModal.physicalcountry == undefined ? '13' : this.contactDataModal.physicalcountry;
      this.onChangeContactCountry3(this.clientDataModal.postalcountry);
      this.contactDataModal.postalstate = undefined;
      this.contactDataModal.postalsuburb = null;
      this.contactDataModal.postalpostcode = null;
    }
  }

  GetCustomFieldsforClientinQuicklinkByRole(JobId: any) {
    if (JobId == undefined)
      JobId = 0
    this.jobService.GetCustomFieldsByRole(1, JobId).subscribe(result => {
      result = this.organizeHeadersAndItems(result);
      this.tempqccfitem = result;
      let jobitem = [];
      this.tempqccfitem.forEach(function (childobj) {
        if (childobj.customFieldValues.length > 0) {

          if (childobj.fieldType == 'Date') {
            jobitem.push({
              id: childobj.id, fieldType: childobj.fieldType, datatype: childobj.datatype, fieldLabel: childobj.fieldLabel, description: childobj.description,
              helpText: childobj.helpText, placeHolder: childobj.placeHolder, isFirstdefault: childobj.isFirstdefault, isorderedAlphabetically: childobj.isorderedAlphabetically,
              sections: childobj.sections, isReadOnly: childobj.isReadOnly, isVisible: childobj.isVisible, value: (childobj.value === null || childobj.value === "" || childobj.value === "undefined") ? undefined : new Date(childobj.value), customFieldValues: childobj.customFieldValues,
              cfdropdown: JSON.parse(childobj.customFieldValues)
            });
          }
          else if (childobj.fieldType == 'Checkbox' && JobId != 0 && childobj.value != '') {
            jobitem.push({
              id: childobj.id, fieldType: childobj.fieldType, datatype: childobj.datatype, fieldLabel: childobj.fieldLabel, description: childobj.description,
              helpText: childobj.helpText, placeHolder: childobj.placeHolder, isFirstdefault: childobj.isFirstdefault, isorderedAlphabetically: childobj.isorderedAlphabetically,
              sections: childobj.sections, isReadOnly: childobj.isReadOnly, isVisible: childobj.isVisible, value: childobj.value, customFieldValues: childobj.customFieldValues,
              cfdropdown: JSON.parse(childobj.value)
            });
          }
          else if (childobj.fieldType == 'User') {
            jobitem.push({
              id: childobj.id, fieldType: childobj.fieldType, datatype: childobj.datatype, fieldLabel: childobj.fieldLabel, description: childobj.description,
              helpText: childobj.helpText, placeHolder: childobj.placeHolder, isFirstdefault: childobj.isFirstdefault, isorderedAlphabetically: childobj.isorderedAlphabetically,
              sections: childobj.sections, isReadOnly: childobj.isReadOnly, isVisible: childobj.isVisible, value: childobj.value ? childobj.value.split(',')?.filter(x => x).map(x => ({ id: x })) : [], customFieldValues: childobj.customFieldValues, cfdropdown: [], _userInfo: []
            });
          }
          else {
            if (childobj.fieldType == "Dropdown List" && childobj.value == "" && childobj.isFirstdefault) {
              let darray = JSON.parse(childobj.customFieldValues);
              childobj.value = darray[0]["dropvalueId"].toString();
            }
            if (childobj.fieldType == "Dropdown List" && childobj.value == "" && childobj.isFirstdefault == false) {
              childobj.value = 0;
            }

            const options = JSON.parse(childobj.customFieldValues);

            if (childobj.fieldType == "Dropdown List") {
              childobj.value = isNaN(+childobj.value) ? 0 : +childobj.value;
              options.unshift({ dropvalueId: 0, dropvalue: childobj.placeHolder, isHidden: true });
            }

            jobitem.push({
              id: childobj.id, fieldType: childobj.fieldType, datatype: childobj.datatype, fieldLabel: childobj.fieldLabel, description: childobj.description,
              helpText: childobj.helpText, placeHolder: childobj.placeHolder, isFirstdefault: childobj.isFirstdefault, isorderedAlphabetically: childobj.isorderedAlphabetically,
              sections: childobj.sections, isReadOnly: childobj.isReadOnly, isVisible: childobj.isVisible, value: childobj.value, customFieldValues: childobj.customFieldValues,
              cfdropdown: options
            });
          }
        }
        else {
          if (childobj.fieldType == 'Date') {
            jobitem.push({
              id: childobj.id, fieldType: childobj.fieldType, datatype: childobj.datatype, fieldLabel: childobj.fieldLabel, description: childobj.description,
              helpText: childobj.helpText, placeHolder: childobj.placeHolder, isFirstdefault: childobj.isFirstdefault, isorderedAlphabetically: childobj.isorderedAlphabetically,
              sections: childobj.sections, isReadOnly: childobj.isReadOnly, isVisible: childobj.isVisible, value: (childobj.value === null || childobj.value === "" || childobj.value === "undefined") ? undefined : new Date(childobj.value), customFieldValues: childobj.customFieldValues
            });
          }
          else {
            if (childobj.fieldType == "Dropdown List" && childobj.value == "" && childobj.isFirstdefault) {
              let darray = JSON.parse(childobj.customFieldValues);
              childobj.value = darray[0]["dropvalueId"].toString();
            }
            if (childobj.fieldType == "Dropdown List" && childobj.value == "" && childobj.isFirstdefault == false) {
              childobj.value = 0;
            }

            if (childobj.fieldType == "Dropdown List") {
              childobj.value = isNaN(+childobj.value) ? 0 : +childobj.value;
              const options = JSON.parse(childobj.customFieldValues);
              options.unshift({ dropvalueId: 0, dropvalue: childobj.placeHolder, isHidden: true });
              childobj.customFieldValues = JSON.stringify(options);
            }
            jobitem.push({
              id: childobj.id, fieldType: childobj.fieldType, datatype: childobj.datatype, fieldLabel: childobj.fieldLabel, description: childobj.description,
              helpText: childobj.helpText, placeHolder: childobj.placeHolder, isFirstdefault: childobj.isFirstdefault, isorderedAlphabetically: childobj.isorderedAlphabetically,
              sections: childobj.sections, isReadOnly: childobj.isReadOnly, isVisible: childobj.isVisible, value: childobj.value, customFieldValues: childobj.customFieldValues
            });
          }
        }
      });

      jobitem.forEach((element, index) => {
        if (element.fieldType == "Checkbox" && (!(element.value == "" || element.value == undefined))) {
          let resdate = this.cfqcitem.filter(obj => obj.fieldLabel == element.fieldLabel);
          let Arr = JSON.parse(element.value);
          let cfvArr = JSON.parse(element.customFieldValues);
          cfvArr.forEach((res, i) => {
            let resData = Arr.filter(p => p.dropvalue == res.dropvalue);
            if (resData.length != 0)
              cfvArr[i] = resData[0];
          })
          jobitem[index].cfdropdown = cfvArr;
          jobitem[index].customFieldValues = element.value;
        }
      })

      this.cfqcitem = jobitem;
      this.createCFUserDropdowns();
      this.setLoadedForm();
    }, error => console.error(error));
  }

  setLoadedForm() {
    timer(200).pipe(takeUntil(this.unsubscribe)).subscribe(() => {
      this.loadedForm = this.getFormSnapshotForChangeDetection();
    });
  }

  private getFormSnapshotForChangeDetection(): any {
    const formSnapshot = this.commonService.copyObject(this.addClientForm?.value || {});
    const selectedTagIds = (this.selectedClientTags || [])
      .map((tag: any) => Number(tag?.tagId))
      .filter((tagId: number) => !isNaN(tagId))
      .sort((a: number, b: number) => a - b);

    formSnapshot.tagIdsJson = JSON.stringify({ TagIds: selectedTagIds });
    return formSnapshot;
  }

  chkqccustomfield(event: any, Id: number, i: any, j: any) {
    let Arr = JSON.parse(this.cfqcitem[i].customFieldValues);
    if (event.target.checked) {

      for (let val of Arr) {
        if (val.dropvalueId === Id) {
          val.status = true;
          this.checkBoxIds.push(val);
        }
      }
      this.cfqcitem[i].customFieldValues = JSON.stringify(Arr);
    }
    else {
      if (Arr.length > 0) {
        let checkeditem = Arr.filter(obj => obj.dropvalueId === Id);
        if (checkeditem) {
          checkeditem[0].status = false;
          this.checkBoxIds.push(checkeditem[0]);
        }
        Arr[j].status = false;
        this.cfqcitem[i].customFieldValues = JSON.stringify(Arr);
      }
    }
  }

  organizeHeadersAndItems(result: any[]): any[] {
    const Headers = result.filter(x => x.fieldType === 'Header');
    const HeaderIds = Headers.map(y => y.id);

    const finalList = result.filter(x => x.fieldType !== 'Header' && (x.groupbyHeader === 0 || !HeaderIds.includes(x.groupbyHeader)));

    Headers.forEach(header => {
      finalList.push(header, ...result.filter(x => x.fieldType !== 'Header' && x.groupbyHeader === header.id));
    });

    return finalList;
  }


  GetCustomFieldsforQuicklinkContactByRole(JobId: any) {
    this.jobService.GetCustomFieldsByRole(2, JobId).subscribe(result => {
      this.tempqlcfconitem = result;
      let jobitem = [];
      this.tempqlcfconitem.forEach(function (childobj) {
        if (childobj.customFieldValues.length > 0) {

          if (childobj.fieldType == 'Date') {
            jobitem.push({
              id: childobj.id, fieldType: childobj.fieldType, datatype: childobj.datatype, fieldLabel: childobj.fieldLabel, description: childobj.description,
              helpText: childobj.helpText, placeHolder: childobj.placeHolder, isFirstdefault: childobj.isFirstdefault, isorderedAlphabetically: childobj.isorderedAlphabetically,
              sections: childobj.sections, isReadOnly: childobj.isReadOnly, isVisible: childobj.isVisible, value: (childobj.value === null || childobj.value === "" || childobj.value === "undefined") ? undefined : new Date(childobj.value), customFieldValues: childobj.customFieldValues,
              cfdropdown: JSON.parse(childobj.customFieldValues)
            });
          }
          else if (childobj.fieldType == 'Checkbox' && JobId != 0 && childobj.value != '') {
            jobitem.push({
              id: childobj.id, fieldType: childobj.fieldType, datatype: childobj.datatype, fieldLabel: childobj.fieldLabel, description: childobj.description,
              helpText: childobj.helpText, placeHolder: childobj.placeHolder, isFirstdefault: childobj.isFirstdefault, isorderedAlphabetically: childobj.isorderedAlphabetically,
              sections: childobj.sections, isReadOnly: childobj.isReadOnly, isVisible: childobj.isVisible, value: childobj.value, customFieldValues: childobj.customFieldValues,
              cfdropdown: JSON.parse(childobj.value)
            });
          }
          else if (childobj.fieldType == 'User') {
            jobitem.push({
              id: childobj.id, fieldType: childobj.fieldType, datatype: childobj.datatype, fieldLabel: childobj.fieldLabel, description: childobj.description,
              helpText: childobj.helpText, placeHolder: childobj.placeHolder, isFirstdefault: childobj.isFirstdefault, isorderedAlphabetically: childobj.isorderedAlphabetically,
              sections: childobj.sections, isReadOnly: childobj.isReadOnly, isVisible: childobj.isVisible, value: childobj.value ? childobj.value.split(',')?.filter(x => x).map(x => ({ id: x })) : [], customFieldValues: childobj.customFieldValues, cfdropdown: [], _userInfo: []
            });
          }
          else {
            if (childobj.fieldType == "Dropdown List" && childobj.value == "" && childobj.isFirstdefault) {
              let darray = JSON.parse(childobj.customFieldValues);
              childobj.value = darray[0]["dropvalueId"].toString();
            }
            if (childobj.fieldType == "Dropdown List" && childobj.value == "" && childobj.isFirstdefault == false) {
              childobj.value = 0;
            }

            if (childobj.fieldType == "Dropdown List") {
              childobj.value = isNaN(+childobj.value) ? 0 : +childobj.value;
              const options = JSON.parse(childobj.customFieldValues);
              options.unshift({ dropvalueId: 0, dropvalue: childobj.placeHolder, isHidden: true });
              childobj.customFieldValues = JSON.stringify(options);
            }
            jobitem.push({
              id: childobj.id, fieldType: childobj.fieldType, datatype: childobj.datatype, fieldLabel: childobj.fieldLabel, description: childobj.description,
              helpText: childobj.helpText, placeHolder: childobj.placeHolder, isFirstdefault: childobj.isFirstdefault, isorderedAlphabetically: childobj.isorderedAlphabetically,
              sections: childobj.sections, isReadOnly: childobj.isReadOnly, isVisible: childobj.isVisible, value: childobj.value, customFieldValues: childobj.customFieldValues,
              cfdropdown: JSON.parse(childobj.customFieldValues)
            });
          }
        }
        else {
          if (childobj.fieldType == 'Date') {
            jobitem.push({
              id: childobj.id, fieldType: childobj.fieldType, datatype: childobj.datatype, fieldLabel: childobj.fieldLabel, description: childobj.description,
              helpText: childobj.helpText, placeHolder: childobj.placeHolder, isFirstdefault: childobj.isFirstdefault, isorderedAlphabetically: childobj.isorderedAlphabetically,
              sections: childobj.sections, isReadOnly: childobj.isReadOnly, isVisible: childobj.isVisible, value: (childobj.value === null || childobj.value === "" || childobj.value === "undefined") ? undefined : new Date(childobj.value), customFieldValues: childobj.customFieldValues
            });
          }
          else {
            if (childobj.fieldType == "Dropdown List" && childobj.value == "" && childobj.isFirstdefault) {
              let darray = JSON.parse(childobj.customFieldValues);
              childobj.value = darray[0]["dropvalueId"].toString();
            }
            if (childobj.fieldType == "Dropdown List" && childobj.value == "" && childobj.isFirstdefault == false) {
              childobj.value = 0;
            }
            if (childobj.fieldType == "Dropdown List") {
              childobj.value = isNaN(+childobj.value) ? 0 : +childobj.value;
              const options = JSON.parse(childobj.customFieldValues);
              options.unshift({ dropvalueId: 0, dropvalue: childobj.placeHolder, isHidden: true });
              childobj.customFieldValues = JSON.stringify(options);
            }
            jobitem.push({
              id: childobj.id, fieldType: childobj.fieldType, datatype: childobj.datatype, fieldLabel: childobj.fieldLabel, description: childobj.description,
              helpText: childobj.helpText, placeHolder: childobj.placeHolder, isFirstdefault: childobj.isFirstdefault, isorderedAlphabetically: childobj.isorderedAlphabetically,
              sections: childobj.sections, isReadOnly: childobj.isReadOnly, isVisible: childobj.isVisible, value: childobj.value, customFieldValues: childobj.customFieldValues
            });
          }
        }
      });
      this.cfqlconitem = jobitem;
      this.createCFUserDropdowns();
    }, error => console.error(error));
  }

  chkcustomqlConfield(event: any, Id: number, i: any) {
    let Arr = JSON.parse(this.cfqlconitem[i].customFieldValues);
    if (event.target.checked) {

      for (let val of Arr) {
        if (val.dropvalueId === Id)
          val.status = true;
      }
      this.cfqlconitem[i].customFieldValues = JSON.stringify(Arr);
    }
    else {
      if (Arr.length > 0) {
        let checkeditem = Arr.findIndex(obj => obj.dropvalueId === Id);
        if (checkeditem)
          checkeditem.status = false;
        this.cfqlconitem[i].customFieldValues = JSON.stringify(Arr);
      }
    }

  }
  public checkLstResData = [];
  ediCheckBoxData() {
    let indexData = this.cfqcitem.findIndex(obj => obj.fieldType === 'Checkbox');
    let cfqldata = this.cfqcitem.filter(obj => obj.fieldType === 'Checkbox');
    if (cfqldata.length > 0) {
      this.checkLstResData = cfqldata[0].cfdropdown;
      for (let val of this.checkBoxIds) {
        this.checkLstResData.forEach((element, index) => {
          if (element.dropvalueId === val.dropvalueId) {
            this.checkLstResData[index] = val;
          }
        });
      }
      this.cfqcitem[indexData].customFieldValues = JSON.stringify(this.checkLstResData);
    }
    this.checkBoxIds = [];
  }
  getRandomBgTextColor() {
    const ProfileColor = [{ bg: "#EFD8D8", text: "#5B1010" }, { bg: "#EFE2D8", text: "#633919" }, { bg: "#EFEBD8", text: "#625514" }, { bg: "#E8EFD8", text: "#553505" }, { bg: "#DEEFD8", text: "#1A410C" }
      , { bg: "#D8EFDF", text: "#185C2D" }, { bg: "#D8EFEA", text: "#0E4E40" }, { bg: "#D8ECEF", text: "#0B4953" }, { bg: "#D8E8EF", text: "#144A61" }, { bg: "#D8E4EF", text: "#113557" }
      , { bg: "#D8DFEF", text: "#091C48" }, { bg: "#DDD8EF", text: "#1C0C55" }, { bg: "#E2D8EF", text: "#34155B" }, { bg: "#ECD8EF", text: "#530F5F" }, { bg: "#EFD8E3", text: "#661515" }, { bg: "#EFEFD7", text: "#474705" }];
    const random = Math.floor(Math.random() * ProfileColor.length);
    this.clientDataModal.backgroundColor = ProfileColor[random].bg;
    this.clientDataModal.textColor = ProfileColor[random].text;
  }

  GetUserPermissions() {
    const userPermissionsParsed = JSON.parse(localStorage.getItem('UserPermissions'));
    const privilegeArr = userPermissionsParsed.filter(x => x.area === 'Clients');
    const privilege = JSON.parse(privilegeArr[0].privilege)
    const tempPrivacy = privilege.filter(item => item.Key == 'Privacy');
    if (tempPrivacy.length > 0) {
      this.IsclientPrivacy = (tempPrivacy[0].Value == "True" ? true : false);
    }
    const settingsArea = userPermissionsParsed.filter(x => x.area === 'Settings');

    if (settingsArea.length > 0 && settingsArea[0].privilege) {

      const privilegesetting = JSON.parse(settingsArea[0].privilege);

      const tempBillerReference = privilegesetting.filter(
        item => item.Key == 'ManageBillerReference'
      );

      if (tempBillerReference.length > 0) {
        this.isManageBillerReference =
          tempBillerReference[0].Value == "True";
      }
    }
  }

  ShowTFN() {
    if (this.isEditMode && this.IsclientPrivacy && (this.clientDataModal.tFN != "" && this.clientDataModal.tFN != undefined && this.clientDataModal.tFN != null)) {
      this._clientService.GetDecryptedData('TFN', this._TempClientId).subscribe(response => {
        if (response == null) {
          this.clientDataModal.tFN = '';
          this.isShowTFN = true;
        }
        else if (response != '') {
          this.clientDataModal.tFN = response.toString();
          this.isShowTFN = true;
        }
      });
    }
    else {
      this.isShowTFN = true;
    }
  }

  ShowBSB() {
    if (this.isEditMode && this.IsclientPrivacy && (this.clientDataModal.bankBSB != "" && this.clientDataModal.bankBSB != undefined && this.clientDataModal.bankBSB != null)) {
      this._clientService.GetDecryptedData('BSB', this._TempClientId).subscribe(response => {
        if (response == null) {
          this.clientDataModal.bankBSB = '';
          this.isShowBSB = true;
        }
        else if (response != '') {
          this.clientDataModal.bankBSB = response.toString();
          this.isShowBSB = true;
        }
      });
    }
    else {
      this.isShowBSB = true;
    }

  }

  ShowBankAccountNo() {
    if (this.isEditMode && this.IsclientPrivacy && (this.clientDataModal.bankAccountnumber != "" && this.clientDataModal.bankAccountnumber != undefined && this.clientDataModal.bankAccountnumber != null)) {
      this._clientService.GetDecryptedData('BankAccountNumber', this._TempClientId).subscribe(response => {
        if (!response) {
          this.clientDataModal.bankAccountnumber = this.clientDataModal.bankAccountnumber ?? '';
          this.isShowBankAccountnumber = true;
        }
        else if (response != '') {
          this.clientDataModal.bankAccountnumber = response.toString();
          this.isShowBankAccountnumber = true;
        }
      });
    }
    else {
      this.isShowBankAccountnumber = true;
    }
  }

  ShowDIN() {
    if (this.isEditMode && this.IsclientPrivacy && (this.clientDataModal.dIN != "" && this.clientDataModal.dIN != undefined && this.clientDataModal.dIN != null)) {
      this._clientService.GetDecryptedData('DIN', this._TempClientId).subscribe(response => {
        if (response == null) {
          this.clientDataModal.dIN = '';
          this.isShowDIN = true;
        }
        else if (response != '') {
          this.clientDataModal.dIN = response.toString();
          this.isShowDIN = true;
        }
      });
    }
    else {
      this.isShowDIN = true;
    }
  }

  countrySearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.name.toLocaleLowerCase().indexOf(term) > -1 || item.oldName1.toLocaleLowerCase().indexOf(term) > -1 || item.aliasName.toLocaleLowerCase().indexOf(term) > -1;
  }


  /* #region - Dev: Parth, CUST-4084, 27-06-2024  */
  getStaffs() {
    this.users$.subscribe(users => {
      if (users) {
        this.allUsers = users?.filter(user => user.inviteStatus === 'Accepted') || [];
        this.createCFUserDropdowns();
      }
    });
  }
  createCFUserDropdowns() {
    [this.cfqlconitem, this.cfqcitem]?.forEach(list => {
      list.forEach(field => {
        if (field.fieldType == 'User') {
          field.value = field.value || [];

          if (field.customFieldValues === 'Users') {
            field.cfdropdown = this.allUsers.map(x => ({
              id: x.userId,
              text: `${x.fullName} - ${x.email}`
            }))

            field.value.forEach(x => {
              const user = this.allUsers.find(u => u.userId === x.id)
              x.text = user?.fullName || '';
            })
            this.onCFUserDropdownChange(field);
          }

        }
      })
    })
  }
  getShortName(fullName: string): string {
    let words = fullName.trim().split(" ");
    let shortname = "";
    if (words.length === 1) {
      shortname = words[0].slice(0, 2);
    } else {
      shortname = words[0].slice(0, 1) + words[1].slice(0, 1);
    }
    return shortname.toUpperCase();
  }

  showCFUserDropdown(event: any) {
    event._isVisibleInput = true;
  }
  hideCFUserDropdown(field: any) {
    /* need to maintain this flag in the field because onDropDownClose is getting called all the time */
    if (field._isDropdownInteracted) {
      field._isVisibleInput = !field._isVisibleInput;
      field._isDropdownInteracted = false;
    } else {
      field._isDropdownInteracted = true;
    }
  }
  onCFUserDropdownChange(field: any) {
    field.value = field.value || [];

    field._userInfo = field.value.map(x => {
      const user = this.allUsers.find(u => u.userId === x.id)
      if (user) {
        return {
          fullName: user.fullName,
          shortName: this.getShortName(user.fullName),
          textColor: user.textColor,
          backgroundColor: user.backgroundColor
        }
      }
    })?.filter(x => x)
  }
  /* #endregion */
  public fullAddress: any;
  public addressTypes: any;


  getAddressTypes() {
    this._clientService.getAddressTypes().subscribe(
      response => {
        this.addressTypes = response;
        this.initData();
        if (this.buttontext !== 'Update ') {
          this.addAddressSet();
          this.addAddressSetContact();
        }
      }
    )
  }

  getEmailTypes() {
    this._clientService.getEmailTypes().pipe((takeUntil(this.unsubscribe))).subscribe({
      next: (response: any) => {
        this.emailTypes = response.sort((a, b) => a.emailTypeName.localeCompare(b.emailTypeName));
        const firstTypeId = this.getNextAvailableEmailTypeId();
        if (firstTypeId !== null) {
          this.emails.push(this.createEmailRow(firstTypeId));
        }
      }, error: (err: any) => {
        this._toastr.error('Failed to load email types. Please try again later.', 'Error');
      }
  });
  }

  getPhoneTypes() {
    this._clientService.getPhoneTypes().subscribe({
      next: (response: any) => {
      this.phoneTypes = response.sort((a, b) => a.phoneTypeName.localeCompare(b.phoneTypeName));
      const firstTypeId = this.getNextAvailablePhoneTypeId();
        if (firstTypeId !== null) {
          this.phones.push(this.createPhoneRow(firstTypeId));
        }
      }, error: (err: any) => {
        this._toastr.warning('Failed to get phone types',err?.message);
      }
    });
  }

  public addressIndex: number = undefined;
  public type: string = "";
  createAddressPopupOpen(index, type) {
    this.getStatesList(13);
    this.modalRef = this.modalService.show(this.CreateNewAddress, { backdrop: 'static', class: 'm-auto cmn-modal-dsgn modal-dialog-centered modal-add-address-popup' });
    this.addressIndex = index;
    this.type = type;
  }

  createAddressPopupclose() {
    this.modalRef.hide();
    this.selectedStateId = undefined;
    this.selectedCountryId = '13';
    this.addressData.unit = undefined;
    this.addressData.addressLine1 = undefined;
    this.addressData.addressLine2 = undefined;
    this.addressData.suburb = undefined;
    this.addressData.postcode = undefined;
  }

  onClearCustomFieldDropdown(field: any) {
    field.value = 0;
  }

  checkABNExist(clientId, abn) {
    this._clientService.VerifyABNOrACNExistsInClients(clientId, abn, 'ABN').subscribe(result => {
      this._isABNExist = result;
    }
    );
  }

  checkACNExist(clientId, acn) {
    this._clientService.VerifyABNOrACNExistsInClients(clientId, acn, 'ACN').subscribe(result => {
      this._isACNExist = result;
    }
    );
  }

  clearPrefilledNames() {
    this.clientDataModal.preferredname = null;
    this.clientDataModal.mailingName = null;
  }

  prefillPreferredName(event: any) {
    event?.preventDefault();
    this.clientDataModal.preferredname = getNormalizedName(this.clientDataModal.firstname);
  }

  prefillMailingName() {
    const enitityType = this.clientDataModal.entityTypeId;
    switch (enitityType) {
      case 1:
        this.clientDataModal.mailingName = getNormalizedFullName(this.clientDataModal?.firstname, this.clientDataModal?.lastname);
        break;
      case 2:
        this.clientDataModal.mailingName = getNormalizedName(this.clientDataModal?.companyName);
        break;
      case 3:
        this.clientDataModal.mailingName = getNormalizedName(this.clientDataModal?.trustName);
        break;
      case 4:
        this.clientDataModal.mailingName = getNormalizedName(this.clientDataModal?.partnershipname);
        break;
      case 5:
        this.clientDataModal.mailingName = getNormalizedName(this.clientDataModal?.smsfName);
        break;
      default:
        break;
    }
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
    this.sub.unsubscribe();
  }

  handleBulkEmailBeforeSave(client: any, inputform: NgForm, IsSaveAndNext: boolean, physicalAddressChange: boolean) {
    const normalizeEmail = (email: string | null | undefined): string =>
      (email ?? '').toLowerCase().trim();
    const oldEmailMap = new Map<number, string>();
    (this.backUpEmailPoolIds ?? []).forEach(item => {
      if (item?.emailPoolId && item?.emailId) {
        oldEmailMap.set(
          Number(item.emailPoolId),
          normalizeEmail(item.emailId)
        );
      }
    });

    const changeList: {
      fromEmail: string;
      toEmail: string;
      emailPoolId: number;
    }[] = [];

    const removeList: {
      fromEmail: string;
      toEmail: string;
      emailPoolId: number;
    }[] = [];

    const processedOldIds = new Set<number>();
    (this.emails ?? []).forEach(newItem => {
      const emailPoolId = Number(newItem?.emailPoolId);
      const newEmail = normalizeEmail(newItem?.emailId);

      if (emailPoolId && oldEmailMap.has(emailPoolId)) {
        processedOldIds.add(emailPoolId);
        const oldEmail = oldEmailMap.get(emailPoolId)!;
        if (oldEmail !== newEmail) {
          changeList.push({
            fromEmail: oldEmail,
            toEmail: newEmail,
            emailPoolId
          });
        }
      }
    });
    const currentEmailPoolIds = new Set<number>(
      (this.emails ?? [])
        .filter(x => x?.emailPoolId)
        .map(x => Number(x.emailPoolId))
    );
    oldEmailMap.forEach((oldEmail, emailPoolId) => {
      if (!currentEmailPoolIds.has(emailPoolId)) {
        removeList.push({
          fromEmail: oldEmail,
          toEmail: 'Removed',
          emailPoolId
        });
      }
    });

    const hasEmailChanged = changeList.length > 0 || removeList.length > 0;
    if (hasEmailChanged) {
      const emailPoolIds = [
        ...new Set([
          ...changeList.map(x => x.emailPoolId),
          ...removeList.map(x => x.emailPoolId)
        ])
      ];

      const request = {
        emailPoolIds,
        contextId: this.clientDataModal?.clientId
      };

      this._clientService.checkSharedEmail(request)
        .subscribe(res => {
          if (res?.entities?.length > 0) {
            const grouped = new Map<
              string,
              {
                fromEmail: string;
                toEmail: string;
                entities: any[];
              }
            >();

            const changeMap = new Map(changeList.map(x => [x.fromEmail, x]));
            const removeMap = new Map(removeList.map(x => [x.fromEmail, x]));
            res.entities.forEach(entity => {
              const oldEmail = normalizeEmail(entity?.emailId);
              if (!oldEmail) return;
              const changeItem = changeMap.get(oldEmail);
              const removeItem = removeMap.get(oldEmail);
              if (!grouped.has(oldEmail)) {
                grouped.set(oldEmail, {
                  fromEmail: oldEmail,
                  toEmail: changeItem
                    ? changeItem.toEmail
                    : removeItem
                      ? 'Removed'
                      : oldEmail,
                  entities: []
                });
              }
              grouped.get(oldEmail)!.entities.push(entity);
            });

            this.bulkEmailGroups = Array.from(grouped.values()).map(group => ({
              ...group,
              entities: group.entities.filter(e => e?.name)
            }));

            const hasValidEntities = this.bulkEmailGroups.some(
              g => g.entities.length > 0
            );
            if (hasValidEntities) {
              this._clientData = client;
              this._inputForm = inputform;
              this._isSaveAndNext = IsSaveAndNext;
              this._physicalAddressChange = physicalAddressChange;
              this.childModalRef = this.modalService.show(this.BulkEmailUpdate, {
                backdrop: 'static',
                class:
                  'modal-lg modal-dialog-centered cmn-modal-dsgn editAddressPopup m-auto'
              });
              return;
            }
          }
          this.saveClient(client, inputform, IsSaveAndNext, physicalAddressChange);
        });
    }
    else {
      this.saveClient(client, inputform, IsSaveAndNext, physicalAddressChange);
    }
  }

  toggleAllEmails(group: any) {
    group.entities.forEach(e => e._isChecked = group._isCheckAll);
  }

  onCancel() {
    this.childModalRef?.hide();
  }

  onSubmitBulkEmailUpdate() {
    const emailUpdates: any[] = [];
    this.bulkEmailGroups.forEach(group => {
      const selectedEntities = group.entities
        .filter(e => e._isChecked)
        .map(e => e.contextId);
      if (selectedEntities.length > 0) {
        emailUpdates.push({
          oldEmailPoolId: group.entities?.[0]?.emailPoolId,
          newEmail: group.toEmail === "Removed" ? null : group.toEmail,
          selectedContextIds: selectedEntities
        });
      }
    });
    if (!emailUpdates.length) {
      this.saveClient(
        this._clientData,
        this._inputForm,
        this._isSaveAndNext,
        this._physicalAddressChange
      );
      return;
    }
    const request = {
      emailUpdates: emailUpdates
    };

    this._clientService.bulkUpdateSharedEmails(request)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({

        next: () => {
          this.saveClient(
            this._clientData,
            this._inputForm,
            this._isSaveAndNext,
            this._physicalAddressChange
          );
        },
        error: () => {
          this._toastr.error("Bulk update failed");
        }
      });
  }

  validatePartnersAndManagerList() {                            //Developer: Sasmit, Ticket: CUST-11033, Date: 27-May-2026
    this.validPartnersList = this.commonService.validateUserList(
      this.partnerAndManagerList.displayPartners ?? [],
      [this.clientDataModal.partnerId].filter(Boolean),
      {
        userIdKey: 'userId',
        statusKey: 'inviteStatus',
        isEditMode: this.IseditClient
      }
    );

    this.validManagersList = this.commonService.validateUserList(
      this.partnerAndManagerList.displayManagers ?? [],
      [this.clientDataModal.managerId].filter(Boolean),
      {
        userIdKey: 'userId',
        statusKey: 'inviteStatus',
        isEditMode: this.IseditClient
      }
    );
  }

  saveClient(client: any, inputform: NgForm, IsSaveAndNext: boolean, physicalAddressChange: boolean) {
    this._clientService.AddEditCliententity(client, this.clientGridType,this.clientGridDynamicCols, this.clientGridIsCustomFields).subscribe({
      next: (result) => {
      let _xeroFlag;
      let AccountFirmId = localStorage.getItem("AccountFirmId");
      if (result?.result?.success) {
        this.stateManagement.updateData(this.stateManagement.getClients, null);
        _xeroFlag = this.IseditClient ? false : true;
        let clientNames = '';
        if (this.clientDataModal.entityTypeId == 2)
          clientNames = this.clientDataModal.companyName;
        else if (this.clientDataModal.entityTypeId == 3)
          clientNames = this.clientDataModal.trustName;
        else if (this.clientDataModal.entityTypeId == 4)
          clientNames = this.clientDataModal.partnershipname;
        else if (this.clientDataModal.entityTypeId == 5)
          clientNames = this.clientDataModal.smsfName;
        else {
          if (this.clientDataModal.firstname != undefined && this.clientDataModal.lastname != undefined)
            clientNames = this.clientDataModal?.firstname?.trim() + " " + this.clientDataModal?.lastname?.trim();
        }
        let message = this.clientDataModal.clientCode + " " + clientNames;
        if (_xeroFlag && result?.result?.operationStatuses[0].uniqueKey) { client.clientId = result?.result?.operationStatuses[0].uniqueKey; }
        let redirectURL = window.location.origin + '/client/contact?clientId=' + client.clientId

        let clientCategory = {};
        if (this.IseditClient) {
          clientCategory = {
            'Name': clientNames?.trim(),
            'Description': clientNames?.trim(),
            'ClientId': client.clientId,
            'OldClientName': this.clientOldName?.trim(),
            'AccountingFirmId': AccountFirmId,
            'ClientCode': client.clientCode?.trim()
          };
          const isSharePoint = localStorage.getItem('DMSProviderType') === 'SharePoint';
          const request = isSharePoint
            ? this.azureService.UpdateClientFolder(clientCategory)
            : this.categoryService.CategoryUpdateClient(clientCategory)
          request.subscribe(result => {

          });
          if (this.isChanged || this.isAddressChanged) {
            this._toastr.success('<a href=\"' + redirectURL + '\" class=\"toastr-link\">' + message + '</a> updated successfully.', 'Update client', { enableHtml: true, closeButton: true, timeOut: 10000 });
          }
          this.isAddressChanged = false;
          if (this.isClickedOnUpdate) {
            this.makebuttondisable = false;
            this.closeCreateclientPopup.emit();
            this.getclientlistload.emit({response: result?.client[0]});
            this.childModalRef?.hide();
          }
          if (physicalAddressChange) {
            this.getClientVerifiedRelationships();
          }
        }
        else {
          this.checkbypassValidation = false;
          clientCategory = {
            'Name': clientNames.trim(),
            'Description': clientNames.trim(),
            'ClientId': client.clientId,
            'AccountingFirmId': AccountFirmId,
            'ClientCode': client.clientCode.trim()
          };
          let isSharePoint = localStorage.getItem('DMSProviderType') === 'SharePoint';
          const request = isSharePoint
            ? this.azureService.createClientFolder(clientCategory)
            : this.categoryService.CategoryCreateClient(clientCategory)
          request.subscribe(result => {
          });
          this.makebuttondisable = false;
          this.closeCreateclientPopup.emit();

          if (result?.result?.moreInfo == "Client created in Kloud Connect successfully, but could not create in XPM") {
            this._toastr.error("Client created in Kloud Connect successfully. Could not create in XPM - check connection to XPM", 'Create client');
          }
          else {
            this._toastr.success('<a href=\"' + redirectURL + '\" class=\"toastr-link\">' + message + '</a> added successfully.', 'Create client', { enableHtml: true, closeButton: true, timeOut: 10000 });
          }
          this.clientDataModal.clientId = result?.result?.operationStatuses?.[0]?.uniqueKey;

          this.getclientlistload.emit({response: result?.client[0]});
        }
        if (IsSaveAndNext) { }
        else {
          this.clean(inputform);
          this.sort('created_At');

        }
        this._flagCodeExist = false;
      }
      else if (result?.result?.message == "Client Exist") {
        this._flagCodeExist = true;
      }
      else {
        this._flagCodeExist = false;
        this._toastr.warning(result?.result?.message, 'Create client');
      }
      this.makebuttondisable = false;
    }, error: error => {
      this._toastr.error(error.message, 'Create client'); this.makebuttondisable = false;
    }
  });
  }

  updateCheckAllStatus(group: any) {
    group._isCheckAll = group.entities.every(e => e._isChecked);
  }

  selectedCountry: any;
  selectedCountryCode: any;
  selectedCountryISDCode: any;
  phoneInput = '';
  phoneDigits = '';
  maxDigits = 15;
  normalizationNote = '';
  private readonly googleUtil = PhoneNumberUtil.getInstance();
  onCountryCodeChange(index: number, event: any, row: any): void {
    this.selectedCountry = event.itemData.name;
    this.selectedCountryCode = event.itemData.code;
    this.selectedCountryISDCode = event.itemData.isdCode;
    row['countryRegionCode'] = event.itemData.code;
    row['countryName'] = event.itemData.name;
    row['countryId'] = event.itemData.countryId;
    row['isdCode'] = event.itemData.isdCode;
    this.sanitizePhone(index, row);
  }

  onPhoneInput(index: number, event: Event, row: any): void {
    const target = event.target as HTMLInputElement;
    this.phoneInput$.next({ value: target.value, row });
    row.isValidPhone = null;
    this.sanitizePhone(index, row);
  }

  private sanitizePhone(index: number, row: any): void {
    const hasLetters = /[a-z]/i.test(row.phoneNumber);
    let digits = this.normalizeToDigits(row.phoneNumber);
    this.normalizationNote = '';

    if (
      hasLetters &&
      row.countryRegionCode === 'AU' &&
      digits.length > 10 &&
      (digits.startsWith('1800') || digits.startsWith('1300'))
    ) {
      digits = digits.slice(0, 10);
      this.normalizationNote = 'Phoneword trimmed to 10 digits for AU 1800/1300 numbers.';
    }

    this.phoneDigits = digits.slice(0, this.maxDigits);
    row.phoneNumber = this.phoneDigits;
    this.onPhoneValidation(index, row);
  }

  private normalizeIsdCode(isdCode: string): string {
    return (isdCode || '').replace(/\D/g, '');
  }

  private get parsedPhone() {
    if (!this.phoneDigits || !this.selectedCountry) return null;
    const country = this.selectedCountryCode as CountryCode;
    return parsePhoneNumberFromString(this.phoneDigits, country) || null;
  }

  get isValid(): boolean {
    const phoneNumber = this.parsedPhone;
    return !!phoneNumber && phoneNumber.isValid();
  }

  get statusText(): string {
    if (!this.phoneDigits) return 'Enter a phone number to validate.';
    if (!this.selectedCountry) return 'Select a country code first.';
    if (this.isValid) return `Looks valid for ${this.selectedCountry}.`;
    return `Not a valid number for ${this.selectedCountry}.`;
  }

  private normalizeToDigits(value: string): string {
    let normalized = '';
    const upper = value.toUpperCase();
    for (const ch of upper) {
      if (ch >= '0' && ch <= '9') {
        normalized += ch;
        continue;
      }
      const mapped = this.letterToDigit(ch);
      if (mapped) normalized += mapped;
    }
    return normalized;
  }

  private letterToDigit(letter: string): string {
    if (letter === 'A' || letter === 'B' || letter === 'C') return '2';
    if (letter === 'D' || letter === 'E' || letter === 'F') return '3';
    if (letter === 'G' || letter === 'H' || letter === 'I') return '4';
    if (letter === 'J' || letter === 'K' || letter === 'L') return '5';
    if (letter === 'M' || letter === 'N' || letter === 'O') return '6';
    if (letter === 'P' || letter === 'Q' || letter === 'R' || letter === 'S') return '7';
    if (letter === 'T' || letter === 'U' || letter === 'V') return '8';
    if (letter === 'W' || letter === 'X' || letter === 'Y' || letter === 'Z') return '9';
    return '';
  }

  checkPhoneValidOrNot(row: any): boolean {
    const region = this.contactcountries.find(e => String(e.countryId) === String(row.countryId))?.code;;
    const parsed = this.googleUtil.parseAndKeepRawInput(row.phoneNumber, region);
    const isValid = this.googleUtil.isValidNumberForRegion(parsed, region);
    return isValid;
  }
  onlyNumbers(event: any) {
    event.target.value = event.target.value.replace(/[^0-9]/g, '');
    this.clientDataModal.bPayReference = event.target.value;
  }

  onBpayRefInput(event: any) {
    this.onlyNumbers(event);

    const value = this.clientDataModal.bPayReference;

    if (value && value.length > 25) {
      this.bpayRefError = true;

      this.clientDataModal.bPayReference = value.substring(0, 25);
    } else {
      this.bpayRefError = false;
    }
  }

}

class TableData {
  isVisible: boolean = false;
  rows: Item[] = [];
  columns: Item[] = [];

  constructor(rows?: number, cols?: number) {
    if (rows) {
      for (let i = 0; i < rows; i++) {
        this.addRow(i.toString());
      }
    }
    if (cols) {
      for (let i = 0; i < cols; i++) {
        this.addCol(i.toString());
      }
    }
  }

  addRow(rowTitle: string) {
    let row: Item = {
      id: this.rows.length,
      title: rowTitle
    }

    this.rows.push(row);
  }
  removeRows(rowTitle: string) {
    let row: Item = {
      id: this.rows.length,
      title: rowTitle

    }
    this.rows.pop();
  }
  addCol(colTitle: string) {
    let col: Item = {
      id: this.columns.length,
      title: colTitle
    }

    this.columns.push(col);
  }

}
class DynaicFilterPost {
  FilterId: number;
  SavedFilterName: string;
  Status: string;
  EntityTypeName: string;
  Tag: string;
  Location: string;
  Partner: string;
  Manager: string;
  TaxAgent: string;
  Contact: string;
  Industry: string;
  ActiveJob: string;
  OppurtunityJob: string;
  LastActivityDate: string;
  FollowupDate: string;
  LastInvoiceDate: string;
  WIP: string;
  AnnualIncome: string;
  GstRegisted: string;
  isTaxAgent: boolean = false;
  CreatedBy: string;
  isFavorite: boolean;
}
interface Item {
  id: number;
  title: string
}
class Clients {
  clientId: string;
  fullName: string;
  placeOfBirth: string;
  partnerName: string
  entityCounts: string;
  nextMeetingDate: string;
  openJobs: string;
}
class ClientsDetail {
  clientIds: any;
  partnerId: string;
  managerId: string
  taxagentId: string
  isTaxclient: any;
  nextMeetingDate: any;
  tagsId: any;
  status: any;
  contextFlag: any;
  contextUser: string;
}

export class WorkEmai {
  emailoption: string;
  emailstring: string;
  isemailbookmarked: boolean;
}
export class HomePhone {
  phoneoption: string;
  phonestring: string;
  isphonebookmarked: boolean;
}

class Entities {
  entityId: string;
  entityName: string;
  entityType: string;
  abn: string;
  primaryContact: string;
  taxAgent: string;
  manager: string;
  jobCount: string;
}

class assignEntity {
  id: any = 0;
  entityid: any;
  entityList: string;
  clientId: any;
  assignEntityIds: string;
}

class Dynamicfilter {
  clientName: boolean = false; entityType: boolean = false;
  location: boolean = false; isShowpartnerName: boolean = false;
  isShowcontactName: boolean = false; isShowemail: boolean = false;
  isShowassignTagsCount: boolean = false;
  isShowclientCode: boolean = false; isShowmanager: boolean = false;
  isShowinTaxClient: boolean = false; isShowtaxAgent: boolean = false;
  isShowcrmActivity: boolean = false; isShowworkPhone: boolean = false;
  isShowstatus: boolean = false; isShowabn: boolean = false;
  isShowopenJobs: boolean = false; isShowwip: boolean = false;
  isShowfollowUpDate: boolean = false; isShowlastActivityDate: boolean = true;
  isShowindustry: boolean = false; isShowacn: boolean = false; isShowMeetingDate: boolean = false;
  isShowgstRegistered: boolean = false; isShowopportunityJobs: boolean = false;
  isShowlastInvoiceSent: boolean = false; isShowannualIncome: boolean = false;
  isShowassigneeCount: boolean = false;
}

export class ContactWorkEmail {
  emailoption: any;
  emailstring: string;
}

export class ContactHomePhone {
  phoneoption: any;
  phonestring: string;
}

export class Tcontactworkemail {
  emailoption1: number;
  emailoption2: number;
  emailoption3: number;
  emailstring1: string;
  emailstring2: string;
  emailstring3: string;
}

export class tcontacthomephone {
  phoneoption1: number;
  phoneoption2: number;
  phoneoption3: number;
  phonestring1: string;
  phonestring2: string;
  phonestring3: string;
  phonebookmark1: boolean;
  phonebookmark2: boolean;
  phonebookmark3: boolean;
}
